"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f109 = void 0;
exports.f109 = {
    "miniafia oyan": [
        17
    ],
    "miniafia": [
        17
    ],
    "miniafia-arifama": [
        17
    ],
    "mandagué": [
        19
    ],
    "mogari": [
        19
    ],
    "mandobo atas": [
        28
    ],
    "mandobo": [
        28,
        1238
    ],
    "mandobbo": [
        28,
        1238
    ],
    "meto": [
        366,
        4747,
        29,
        908
    ],
    "manide": [
        35
    ],
    "my": [
        37,
        691,
        702,
        974,
        995,
        1143,
        1151,
        1158,
        1379,
        1706,
        1754,
        1755,
        1889,
        1902,
        1910,
        1953,
        1958,
        1962,
        1981,
        1989,
        1990,
        2184,
        2717,
        2772,
        3115,
        3197,
        3311,
        3313,
        3360,
        3465,
        3475,
        3626,
        3836,
        3838,
        3915,
        3917,
        4049,
        4108,
        4113,
        4140,
        4150,
        4169,
        4178,
        4318,
        4364,
        4384,
        4428,
        4463,
        4474,
        4637,
        4690,
        4694,
        4695,
        4771,
        4951,
        5025,
        5067,
        5068,
        5070,
        5081,
        5170,
        5222,
        5275,
        5672,
        5710,
        5955,
        5958,
        6107,
        6202,
        6224,
        6227,
        6234,
        6312,
        6494,
        6632,
        6705,
        6759,
        6768,
        6774,
        6867,
        6925,
        6991,
        6993,
        7012,
        7053,
        7110,
        7141,
        7282,
        7284,
        7285,
        7299,
        7409,
        7447,
        7458,
        7502,
        7603,
        7610,
        7724,
        7778,
        7839,
        7858,
        7961,
        8421,
        8514,
        8541,
        8997,
        8998,
        9002,
        9032,
        9078,
        9089
    ],
    "malaysia": [
        3197,
        5067,
        5068,
        5070,
        5222,
        8541,
        37,
        691,
        702,
        974,
        995,
        1143,
        1151,
        1158,
        1379,
        1706,
        1754,
        1755,
        1889,
        1902,
        1910,
        1953,
        1958,
        1962,
        1981,
        1989,
        1990,
        2184,
        2717,
        2772,
        3115,
        3311,
        3313,
        3360,
        3465,
        3475,
        3626,
        3836,
        3838,
        3915,
        3917,
        4049,
        4108,
        4113,
        4140,
        4150,
        4169,
        4178,
        4318,
        4364,
        4384,
        4428,
        4463,
        4474,
        4637,
        4690,
        4694,
        4695,
        4771,
        4951,
        5025,
        5081,
        5170,
        5275,
        5672,
        5710,
        5955,
        5958,
        6107,
        6202,
        6224,
        6227,
        6234,
        6312,
        6494,
        6632,
        6705,
        6759,
        6768,
        6774,
        6867,
        6925,
        6991,
        6993,
        7012,
        7053,
        7110,
        7141,
        7282,
        7284,
        7285,
        7299,
        7409,
        7447,
        7458,
        7502,
        7603,
        7610,
        7724,
        7778,
        7839,
        7858,
        7961,
        8421,
        8514,
        8997,
        8998,
        9002,
        9032,
        9078,
        9089
    ],
    "mbofon": [
        43
    ],
    "malay, ambonese": [
        50
    ],
    "malay": [
        50,
        1040,
        1153,
        1200,
        1215,
        1560,
        3322,
        4486,
        4598,
        4605,
        4694,
        4695,
        4707,
        4708,
        4781,
        4859,
        5015,
        5067,
        5068,
        5069,
        5070,
        5071,
        5072,
        5073,
        5081,
        6222,
        6311,
        8099,
        8542,
        9077,
        9078,
        1379,
        5919,
        6725,
        9089,
        1035,
        736,
        872,
        873,
        4725
    ],
    "melaju": [
        50
    ],
    "melayu": [
        5067,
        5069,
        5072,
        5073,
        736,
        1560,
        4102,
        4103,
        4486,
        4598,
        6222,
        6311,
        6725,
        50,
        3322,
        5068,
        5070,
        9077,
        9078
    ],
    "malayu ambon": [
        50
    ],
    "malayu": [
        50,
        9077,
        9078,
        5067,
        5068,
        5070
    ],
    "malayu ambong": [
        50
    ],
    "moluccan (maluku) malay": [
        50
    ],
    "moluccan": [
        4598,
        50
    ],
    "maluku": [
        50,
        1310,
        4598
    ],
    "maprik": [
        52
    ],
    "mesopotamian": [
        70,
        585
    ],
    "mesopotamian arabic": [
        70
    ],
    "mesopotamian gelet arabic": [
        70
    ],
    "maingtha": [
        71
    ],
    "manmaw": [
        71
    ],
    "mönghsa": [
        71
    ],
    "maina": [
        79
    ],
    "maronite": [
        83,
        84,
        85
    ],
    "miri": [
        94,
        95,
        5045,
        5046,
        5047
    ],
    "mɔjukru": [
        96
    ],
    "mojukru": [
        96
    ],
    "mardala": [
        104
    ],
    "mascogos": [
        146
    ],
    "mx": [
        146,
        305,
        602,
        603,
        604,
        605,
        608,
        1380,
        1440,
        1441,
        1444,
        1454,
        1461,
        1473,
        1516,
        1524,
        1528,
        1548,
        1555,
        1561,
        1562,
        1568,
        1569,
        1583,
        1584,
        1615,
        1629,
        1644,
        1656,
        1660,
        1665,
        1669,
        1672,
        1673,
        1674,
        1676,
        1682,
        1693,
        1697,
        1702,
        1710,
        1716,
        1851,
        2107,
        2116,
        2275,
        2917,
        3075,
        3088,
        3091,
        3097,
        3100,
        3294,
        3399,
        3765,
        4188,
        4571,
        4572,
        4581,
        4590,
        4593,
        4594,
        4599,
        4624,
        4629,
        4639,
        4673,
        4686,
        4728,
        4734,
        4769,
        4792,
        4796,
        4798,
        4799,
        4800,
        4803,
        4804,
        4807,
        4808,
        4810,
        4812,
        4813,
        4815,
        4816,
        4817,
        4819,
        4864,
        4901,
        4996,
        5016,
        5076,
        5115,
        5121,
        5124,
        5157,
        5205,
        5206,
        5220,
        5221,
        5223,
        5224,
        5226,
        5229,
        5255,
        5264,
        5267,
        5307,
        5341,
        5342,
        5343,
        5345,
        5356,
        5403,
        5439,
        5447,
        5449,
        5451,
        5453,
        5454,
        5455,
        5456,
        5458,
        5459,
        5461,
        5463,
        5464,
        5465,
        5466,
        5467,
        5556,
        5645,
        5704,
        5718,
        5751,
        5839,
        5946,
        5983,
        5986,
        5987,
        5988,
        5989,
        5991,
        5992,
        5995,
        5997,
        6045,
        6046,
        6051,
        6056,
        6060,
        6096,
        6142,
        6193,
        6197,
        6216,
        6223,
        6251,
        6255,
        6261,
        6262,
        6265,
        6269,
        6277,
        6354,
        6383,
        6782,
        7173,
        7303,
        7318,
        7348,
        7360,
        7373,
        7374,
        7413,
        7423,
        7473,
        7551,
        7560,
        7562,
        7576,
        7640,
        7646,
        7649,
        7650,
        7653,
        7661,
        7669,
        7673,
        7676,
        7680,
        7691,
        7702,
        7716,
        7718,
        7752,
        7833,
        7880,
        7888,
        7889,
        7890,
        7891,
        8058,
        8106,
        8113,
        8116,
        8117,
        8118,
        8125,
        8126,
        8127,
        8601,
        8645,
        8646,
        8648,
        8652,
        8653,
        8654,
        8655,
        8656,
        8658,
        8662,
        8663,
        8664,
        8667,
        8716,
        8736,
        8919,
        8969,
        8970,
        8971,
        8972,
        8973,
        8974,
        8982,
        8983,
        8984,
        8985,
        8986,
        8987,
        8988,
        8990,
        8991,
        8992,
        9003,
        9113,
        9114,
        9116,
        9117,
        9118,
        9119,
        9120,
        9121,
        9122,
        9123,
        9124,
        9125,
        9126,
        9127,
        9128,
        9129,
        9130,
        9131,
        9132,
        9133,
        9134,
        9135,
        9136,
        9137,
        9138,
        9139,
        9140,
        9141,
        9142,
        9143,
        9144,
        9145,
        9158,
        9160,
        9161,
        9162,
        9163,
        9164,
        9165,
        9166,
        9167,
        9168,
        9169,
        9170,
        9171
    ],
    "mexico": [
        5991,
        146,
        305,
        602,
        603,
        604,
        605,
        608,
        1380,
        1440,
        1441,
        1444,
        1454,
        1461,
        1473,
        1516,
        1524,
        1528,
        1548,
        1555,
        1561,
        1562,
        1568,
        1569,
        1583,
        1584,
        1615,
        1629,
        1644,
        1656,
        1660,
        1665,
        1669,
        1672,
        1673,
        1674,
        1676,
        1682,
        1693,
        1697,
        1702,
        1710,
        1716,
        1851,
        2107,
        2116,
        2275,
        2917,
        3075,
        3088,
        3091,
        3097,
        3100,
        3294,
        3399,
        3765,
        4188,
        4571,
        4572,
        4581,
        4590,
        4593,
        4594,
        4599,
        4624,
        4629,
        4639,
        4673,
        4686,
        4728,
        4734,
        4769,
        4792,
        4796,
        4798,
        4799,
        4800,
        4803,
        4804,
        4807,
        4808,
        4810,
        4812,
        4813,
        4815,
        4816,
        4817,
        4819,
        4864,
        4901,
        4996,
        5016,
        5076,
        5115,
        5121,
        5124,
        5157,
        5205,
        5206,
        5220,
        5221,
        5223,
        5224,
        5226,
        5229,
        5255,
        5264,
        5267,
        5307,
        5341,
        5342,
        5343,
        5345,
        5356,
        5403,
        5439,
        5447,
        5449,
        5451,
        5453,
        5454,
        5455,
        5456,
        5458,
        5459,
        5461,
        5463,
        5464,
        5465,
        5466,
        5467,
        5556,
        5645,
        5704,
        5718,
        5751,
        5839,
        5946,
        5983,
        5986,
        5987,
        5988,
        5989,
        5992,
        5995,
        5997,
        6045,
        6046,
        6051,
        6056,
        6060,
        6096,
        6142,
        6193,
        6197,
        6216,
        6223,
        6251,
        6255,
        6261,
        6262,
        6265,
        6269,
        6277,
        6354,
        6383,
        6782,
        7173,
        7303,
        7318,
        7348,
        7360,
        7373,
        7374,
        7413,
        7423,
        7473,
        7551,
        7560,
        7562,
        7576,
        7640,
        7646,
        7649,
        7650,
        7653,
        7661,
        7669,
        7673,
        7676,
        7680,
        7691,
        7702,
        7716,
        7718,
        7752,
        7833,
        7880,
        7888,
        7889,
        7890,
        7891,
        8058,
        8106,
        8113,
        8116,
        8117,
        8118,
        8125,
        8126,
        8127,
        8601,
        8645,
        8646,
        8648,
        8652,
        8653,
        8654,
        8655,
        8656,
        8658,
        8662,
        8663,
        8664,
        8667,
        8716,
        8736,
        8919,
        8969,
        8970,
        8971,
        8972,
        8973,
        8974,
        8982,
        8983,
        8984,
        8985,
        8986,
        8987,
        8988,
        8990,
        8991,
        8992,
        9003,
        9113,
        9114,
        9116,
        9117,
        9118,
        9119,
        9120,
        9121,
        9122,
        9123,
        9124,
        9125,
        9126,
        9127,
        9128,
        9129,
        9130,
        9131,
        9132,
        9133,
        9134,
        9135,
        9136,
        9137,
        9138,
        9139,
        9140,
        9141,
        9142,
        9143,
        9144,
        9145,
        9158,
        9160,
        9161,
        9162,
        9163,
        9164,
        9165,
        9166,
        9167,
        9168,
        9169,
        9170,
        9171
    ],
    "mendi": [
        154,
        3838,
        3839,
        239,
        348
    ],
    "mburugam": [
        168
    ],
    "mt": [
        175,
        495,
        2181,
        4663,
        5098,
        5099,
        5100
    ],
    "mount iriga negrito": [
        175
    ],
    "mount": [
        175,
        5107,
        8619
    ],
    "mt. iriga agta": [
        175
    ],
    "mm": [
        181,
        183,
        326,
        921,
        929,
        1225,
        1226,
        1360,
        1412,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421,
        1424,
        1428,
        1430,
        1431,
        1432,
        1503,
        1519,
        1525,
        1538,
        1542,
        1545,
        1547,
        1557,
        1636,
        1637,
        1639,
        1651,
        1654,
        1658,
        1659,
        1664,
        1718,
        1734,
        1735,
        1736,
        1737,
        1738,
        1926,
        1927,
        2089,
        2631,
        2968,
        3040,
        3225,
        3381,
        3383,
        3395,
        3461,
        3713,
        3714,
        3715,
        3716,
        3717,
        3743,
        3976,
        3977,
        4056,
        4061,
        4062,
        4065,
        4066,
        4070,
        4104,
        4105,
        4106,
        4110,
        4152,
        4153,
        4154,
        4470,
        4495,
        4567,
        4787,
        4956,
        5189,
        5193,
        5231,
        5232,
        5554,
        5643,
        5658,
        5660,
        5701,
        5703,
        5722,
        5737,
        5776,
        5831,
        6065,
        6087,
        6088,
        6191,
        6291,
        6380,
        6390,
        6391,
        6392,
        6477,
        6478,
        6479,
        6480,
        6481,
        6482,
        6486,
        6513,
        6514,
        6515,
        6523,
        6535,
        6605,
        6798,
        6819,
        6845,
        6846,
        6847,
        7178,
        7365,
        7368,
        7369,
        7387,
        7524,
        7577,
        7810,
        7936,
        7963,
        8202,
        8214,
        8804,
        8907,
        9061,
        9065,
        9185
    ],
    "myanmar": [
        8907,
        6390,
        5231,
        5232,
        5722,
        6523,
        7365,
        181,
        183,
        326,
        921,
        929,
        1225,
        1226,
        1360,
        1412,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421,
        1424,
        1428,
        1430,
        1431,
        1432,
        1503,
        1519,
        1525,
        1538,
        1542,
        1545,
        1547,
        1557,
        1636,
        1637,
        1639,
        1651,
        1654,
        1658,
        1659,
        1664,
        1718,
        1734,
        1735,
        1736,
        1737,
        1738,
        1926,
        1927,
        2089,
        2631,
        2968,
        3040,
        3225,
        3381,
        3383,
        3395,
        3461,
        3713,
        3714,
        3715,
        3716,
        3717,
        3743,
        3976,
        3977,
        4056,
        4061,
        4062,
        4065,
        4066,
        4070,
        4104,
        4105,
        4106,
        4110,
        4152,
        4153,
        4154,
        4470,
        4495,
        4567,
        4787,
        4956,
        5189,
        5193,
        5554,
        5643,
        5658,
        5660,
        5701,
        5703,
        5737,
        5776,
        5831,
        6065,
        6087,
        6088,
        6191,
        6291,
        6380,
        6391,
        6392,
        6477,
        6478,
        6479,
        6480,
        6481,
        6482,
        6486,
        6513,
        6514,
        6515,
        6535,
        6605,
        6798,
        6819,
        6845,
        6846,
        6847,
        7178,
        7368,
        7369,
        7387,
        7524,
        7577,
        7810,
        7936,
        7963,
        8202,
        8214,
        8804,
        9061,
        9065,
        9185
    ],
    "mobumrin": [
        187
    ],
    "mobumrin aizi": [
        187
    ],
    "mouin": [
        187
    ],
    "makama": [
        192,
        1071
    ],
    "mednovskiy": [
        193
    ],
    "montserrat creole english": [
        200
    ],
    "montserrat": [
        200,
        2180
    ],
    "maarten": [
        200,
        2208,
        5543,
        8081
    ],
    "ma": [
        4830,
        5082,
        6914,
        3502,
        5147,
        827,
        2641,
        2748,
        3522,
        3755,
        4735,
        4896,
        5039,
        6178,
        8533,
        1057,
        1529,
        3225,
        3688,
        4955,
        8777,
        227,
        421,
        456,
        2443,
        2634,
        6519,
        6520,
        6521,
        6837,
        6838,
        6839,
        6906,
        7884,
        7885,
        7886,
        8548,
        9014
    ],
    "morocco": [
        227,
        421,
        456,
        2443,
        2634,
        6519,
        6520,
        6521,
        6837,
        6838,
        6839,
        6906,
        7884,
        7885,
        7886,
        8548,
        9014
    ],
    "mpur": [
        234
    ],
    "mawu": [
        246,
        5228
    ],
    "mic̣i": [
        252
    ],
    "mol": [
        279
    ],
    "manajó": [
        285
    ],
    "mananyé": [
        285
    ],
    "manaxó": [
        285
    ],
    "manayé": [
        285
    ],
    "manaze": [
        285
    ],
    "manazewá": [
        285
    ],
    "manazo": [
        285
    ],
    "mamurug": [
        291
    ],
    "monobar": [
        291
    ],
    "maran": [
        292
    ],
    "mima": [
        294
    ],
    "mime": [
        294
    ],
    "mimi": [
        294,
        4470
    ],
    "mututu": [
        294
    ],
    "maaloula": [
        307,
        308,
        309,
        310
    ],
    "maalula": [
        307,
        308,
        309,
        310
    ],
    "maranunggu": [
        9098,
        312
    ],
    "mufian": [
        353,
        354,
        355
    ],
    "muhian": [
        353,
        354,
        355
    ],
    "muhiang": [
        353,
        354,
        355
    ],
    "mufian - balif": [
        354
    ],
    "mufian - filifita": [
        355
    ],
    "managalasi": [
        358
    ],
    "malaita": [
        367,
        4894
    ],
    "mountain arapesh": [
        371,
        372,
        373
    ],
    "mountain": [
        3895,
        371,
        372,
        3341,
        3342,
        3343,
        4249,
        5584,
        6142,
        373,
        4220,
        5893
    ],
    "mizaa": [
        378
    ],
    "mescalero-chiricahua": [
        381
    ],
    "mescalero-chiricahua apache": [
        381
    ],
    "moromiranga": [
        386
    ],
    "ml": [
        396,
        941,
        942,
        943,
        960,
        1006,
        1014,
        1024,
        1025,
        1269,
        1300,
        1301,
        1320,
        1747,
        1752,
        1763,
        1764,
        1766,
        1780,
        1814,
        1880,
        1897,
        1975,
        1976,
        1984,
        1985,
        1986,
        1988,
        1991,
        1992,
        1993,
        2016,
        2036,
        2378,
        2379,
        2447,
        2971,
        3415,
        3471,
        3659,
        5183,
        5241,
        5821,
        6792,
        6863,
        7000,
        7001,
        7060,
        7316,
        7317,
        7388,
        7746,
        7751,
        8498
    ],
    "mali": [
        2565,
        2016,
        2019,
        2020,
        396,
        941,
        942,
        943,
        960,
        1006,
        1014,
        1024,
        1025,
        1269,
        1300,
        1301,
        1320,
        1747,
        1752,
        1763,
        1764,
        1766,
        1780,
        1814,
        1880,
        1897,
        1975,
        1976,
        1984,
        1985,
        1986,
        1988,
        1991,
        1992,
        1993,
        2036,
        2378,
        2379,
        2447,
        2971,
        3415,
        3471,
        3659,
        5183,
        5241,
        5821,
        6792,
        6863,
        7000,
        7001,
        7060,
        7316,
        7317,
        7388,
        7746,
        7751,
        8498
    ],
    "mr": [
        422,
        2360,
        2373,
        2449,
        4704,
        4705,
        9010,
        9011
    ],
    "mauritania": [
        9010,
        9011,
        422,
        2360,
        2373,
        2449,
        4704,
        4705
    ],
    "mashubi": [
        444
    ],
    "maxubí": [
        444
    ],
    "mapudungun": [
        446
    ],
    "manzanero": [
        446
    ],
    "mapuche": [
        446
    ],
    "mapudungu": [
        446
    ],
    "maputongo": [
        446
    ],
    "mapuzungun": [
        446
    ],
    "moroccan": [
        8548,
        456,
        9014,
        7884,
        7885,
        7886
    ],
    "maghrebi arabic": [
        456,
        582
    ],
    "maghrebi": [
        456,
        582
    ],
    "maghribi": [
        456
    ],
    "moroccan arabic": [
        456
    ],
    "moroccan colloquial arabic": [
        456
    ],
    "moroccan dareja": [
        456
    ],
    "moroccan darija": [
        456
    ],
    "moroccan dereja": [
        456
    ],
    "massry": [
        457,
        458
    ],
    "modern egyptian language": [
        457,
        458
    ],
    "modern": [
        2092,
        457,
        458,
        2090,
        2091,
        2093,
        2933,
        2934,
        2935,
        2936,
        4795,
        7277,
        7743,
        7987,
        7988,
        7991,
        8896
    ],
    "malian asl": [
        463,
        464
    ],
    "malian": [
        1006,
        463,
        464
    ],
    "madidwana": [
        468
    ],
    "maleta": [
        476
    ],
    "muratayak": [
        482
    ],
    "maratayak": [
        482
    ],
    "mratayak": [
        482
    ],
    "murataik": [
        482
    ],
    "manobo, ata": [
        489
    ],
    "manobo": [
        489,
        4601,
        4603,
        4607,
        4617,
        4618,
        4869,
        5019,
        5085,
        5101,
        5830,
        796,
        888,
        4600
    ],
    "minanobo": [
        489
    ],
    "mand": [
        490
    ],
    "mt. iraya agta": [
        495
    ],
    "muji": [
        8840,
        8853,
        8856,
        511,
        8845,
        8857,
        8753,
        8887
    ],
    "molmo": [
        521
    ],
    "molmo one": [
        521
    ],
    "makayam": [
        523
    ],
    "makaeyam": [
        523
    ],
    "maarul dagestani": [
        532
    ],
    "maarul": [
        532
    ],
    "mobuta": [
        547
    ],
    "mbatyana": [
        550
    ],
    "macquarie": [
        553
    ],
    "manda": [
        4759,
        4767,
        9081,
        6914,
        566
    ],
    "mato": [
        4700,
        567,
        4747
    ],
    "mato grosso arára": [
        567
    ],
    "mòáka": [
        568
    ],
    "mongoumba": [
        568
    ],
    "middle armenian": [
        570
    ],
    "middle": [
        570,
        1558,
        2006,
        2234,
        2469,
        2692,
        2693,
        3069,
        4739,
        5769,
        5882,
        8262,
        8420,
        8558,
        4508,
        4509,
        4995,
        8543,
        4885,
        6560,
        7884,
        7885,
        7886,
        8893,
        3961
    ],
    "mayin nuwu": [
        577
    ],
    "mayin": [
        577
    ],
    "moro": [
        4973,
        584,
        7734,
        7735
    ],
    "morotoco": [
        584
    ],
    "maslawi": [
        585
    ],
    "mesopotamian qeltu arabic": [
        585
    ],
    "moslawi": [
        585
    ],
    "magbukun": [
        588
    ],
    "magbikin": [
        588
    ],
    "magbukun ayta": [
        588
    ],
    "mariveles ayta": [
        588
    ],
    "mariveles": [
        588
    ],
    "mariveleño": [
        588
    ],
    "mai brat": [
        591
    ],
    "mai": [
        591,
        4849,
        4922,
        5952,
        8849,
        1632,
        6300
    ],
    "maibrat": [
        591
    ],
    "maite": [
        591
    ],
    "majbrat": [
        591
    ],
    "maybrat": [
        591
    ],
    "mey brat": [
        591
    ],
    "mey": [
        4797,
        591
    ],
    "meshikan de san pedro shikora": [
        602
    ],
    "meshikan": [
        602,
        605
    ],
    "meshikan del este": [
        602
    ],
    "mexicanero del este": [
        602
    ],
    "mexicanero": [
        602,
        605
    ],
    "meshikan de san agustin buenaventura y de santa cruz": [
        605
    ],
    "meshikan del occidente": [
        605
    ],
    "mexicanero del occidente": [
        605
    ],
    "mbwe’wi": [
        606
    ],
    "mejicano": [
        608,
        5453,
        5465
    ],
    "mejicano de zacapoaxtla": [
        608
    ],
    "mexicano": [
        608,
        5341,
        5345,
        5439,
        5449,
        5453,
        5459,
        5464,
        5465,
        5466,
        5645,
        4728
    ],
    "mbambatana": [
        610
    ],
    "maldavaca": [
        613,
        4784
    ],
    "mitua": [
        613,
        4784
    ],
    "makrani": [
        618,
        619
    ],
    "mbele": [
        626
    ],
    "mee": [
        626,
        2081
    ],
    "mvele": [
        626
    ],
    "mbene": [
        626
    ],
    "mbat": [
        627
    ],
    "mbada": [
        627
    ],
    "mbadawa": [
        627
    ],
    "muag": [
        637
    ],
    "mahum": [
        643
    ],
    "mandju": [
        643
    ],
    "mobango": [
        646
    ],
    "madaré": [
        1239,
        648
    ],
    "mburku": [
        653
    ],
    "mburkanci": [
        653
    ],
    "mvәran": [
        653
    ],
    "menchum": [
        658,
        3259
    ],
    "minchia": [
        660,
        661
    ],
    "minjia": [
        660,
        661,
        8792
    ],
    "minkia": [
        660,
        661
    ],
    "mamenyan": [
        664
    ],
    "mengambo": [
        664
    ],
    "mboteni": [
        666
    ],
    "mborin": [
        666
    ],
    "mboténi": [
        666
    ],
    "maya": [
        4971,
        8919,
        5076,
        7274,
        672,
        1338,
        6052,
        6931,
        1441,
        3280
    ],
    "mabendi": [
        679
    ],
    "mabeni": [
        679
    ],
    "mizeran": [
        682
    ],
    "mbazla": [
        698
    ],
    "morom": [
        699
    ],
    "murba": [
        699
    ],
    "mbulungi": [
        703
    ],
    "mbulungwe": [
        703
    ],
    "metting": [
        721
    ],
    "mougulu": [
        729
    ],
    "melayu betawi": [
        736
    ],
    "melayu jakarte": [
        736
    ],
    "modo": [
        737,
        738
    ],
    "mödö": [
        737,
        738
    ],
    "makarim": [
        739
    ],
    "mukili": [
        739
    ],
    "mblafe": [
        749
    ],
    "mmen": [
        755
    ],
    "mə̂yn": [
        755
    ],
    "mme": [
        755
    ],
    "marae": [
        756
    ],
    "malba": [
        757,
        3478
    ],
    "malba birifor": [
        757
    ],
    "malba-birifor": [
        757
    ],
    "mubadji": [
        758
    ],
    "mandal": [
        773
    ],
    "mannadi": [
        773
    ],
    "mahasu": [
        774
    ],
    "mahasu pahari": [
        774
    ],
    "mahasui": [
        774
    ],
    "mendenkye": [
        787
    ],
    "mədəŋkyɛ": [
        787
    ],
    "məndenkie": [
        787
    ],
    "mahaga": [
        797
    ],
    "mbughotu": [
        797
    ],
    "mbongno": [
        798
    ],
    "malagasy, bara": [
        826
    ],
    "malagasy": [
        826,
        956,
        1298,
        4736,
        4737,
        4738,
        5080,
        5259,
        6918,
        7405,
        7541,
        7859,
        8551,
        8552
    ],
    "mg": [
        826,
        956,
        1298,
        2176,
        2446,
        4736,
        4737,
        4738,
        5080,
        5259,
        6918,
        7405,
        7541,
        7859,
        8551,
        8552
    ],
    "madagascar": [
        5259,
        826,
        956,
        1298,
        2176,
        2446,
        4736,
        4737,
        4738,
        5080,
        6918,
        7405,
        7541,
        7859,
        8551,
        8552
    ],
    "ma buwal": [
        827
    ],
    "mafoor": [
        832
    ],
    "mafoorsch": [
        832
    ],
    "mefoor": [
        832
    ],
    "myfoorsch": [
        832
    ],
    "moar": [
        846,
        4337
    ],
    "moor": [
        846,
        4704,
        4705
    ],
    "mankidi": [
        857
    ],
    "mankidia": [
        857
    ],
    "mankiria": [
        857
    ],
    "mbudja": [
        859
    ],
    "mien": [
        862,
        3283,
        3284,
        3285,
        3286,
        3287,
        963
    ],
    "min": [
        1037,
        1398,
        1399,
        1400,
        1717,
        4950,
        5293,
        5294,
        5295,
        5296,
        5297,
        963,
        862,
        9015
    ],
    "melau": [
        872,
        873
    ],
    "mid-southern": [
        874
    ],
    "mid-southern banda": [
        874
    ],
    "maket": [
        875
    ],
    "mbai": [
        5233,
        881,
        5820
    ],
    "mbay bediondo": [
        881
    ],
    "mbay": [
        5233,
        881,
        4744,
        5820
    ],
    "mbay bejondo": [
        881
    ],
    "minaro": [
        894
    ],
    "mangkettan": [
        897
    ],
    "manketa": [
        897
    ],
    "masbate sorsogon": [
        902
    ],
    "masbate": [
        902
    ],
    "molok meto": [
        908
    ],
    "molok": [
        908
    ],
    "metô": [
        908
    ],
    "mbilua": [
        913
    ],
    "mag-indi": [
        938
    ],
    "mag-indi ayta": [
        938
    ],
    "mag-indi sambal": [
        938
    ],
    "manduri": [
        947
    ],
    "mandori": [
        947
    ],
    "mandouri": [
        947
    ],
    "madouri": [
        947
    ],
    "maduri": [
        947
    ],
    "mandari": [
        5029,
        947,
        7976,
        7977,
        7978,
        7979
    ],
    "mandore": [
        947
    ],
    "mbarma": [
        952
    ],
    "malagasy, northern betsimisaraka": [
        956
    ],
    "mbawyakum": [
        958
    ],
    "mboyakum": [
        958
    ],
    "mu boomu": [
        960
    ],
    "mu": [
        960,
        3545,
        4338,
        5781,
        5782,
        5783,
        3702,
        3703,
        3704,
        2182,
        2450,
        4505,
        4712
    ],
    "muinane": [
        961,
        3093
    ],
    "muename": [
        961
    ],
    "muinana": [
        961
    ],
    "muinani": [
        3093,
        961
    ],
    "mon": [
        4956,
        963,
        5918,
        8851,
        5666,
        6380
    ],
    "min yao": [
        963
    ],
    "mindik": [
        964
    ],
    "murut, bookan": [
        974
    ],
    "murut": [
        974,
        4049,
        4108,
        5170,
        6202,
        6708,
        6945,
        7110,
        7502,
        3919,
        4425
    ],
    "masiwang": [
        978
    ],
    "miamunaa": [
        1002
    ],
    "meamuyna": [
        1002
    ],
    "miamuna’a": [
        1002
    ],
    "miranas": [
        1002
    ],
    "miranha": [
        1002
    ],
    "miranya": [
        1002
    ],
    "miraña": [
        1002
    ],
    "mirañã": [
        1002
    ],
    "miriña": [
        1002
    ],
    "mirãnha": [
        1002
    ],
    "mirãnia": [
        1002
    ],
    "mïamuna": [
        1002
    ],
    "mundabli": [
        1004
    ],
    "mufu": [
        1004
    ],
    "malian sign language": [
        1006
    ],
    "malienne": [
        1006
    ],
    "mbonzo": [
        1010
    ],
    "mbagani": [
        1033
    ],
    "malay talk": [
        1035
    ],
    "malay, banda": [
        1040
    ],
    "marind, bian": [
        1045
    ],
    "marind": [
        1045,
        5066
    ],
    "malind deg": [
        1045
    ],
    "malind": [
        1045
    ],
    "manipuri": [
        5913,
        4943,
        4944,
        4945,
        1048
    ],
    "mbrès": [
        1060
    ],
    "mboko": [
        4672,
        1062
    ],
    "maŋkɔ̧": [
        1069
    ],
    "mangkong": [
        1069,
        7147,
        7148
    ],
    "mankong": [
        1069
    ],
    "mbo": [
        4613,
        9103,
        1075,
        5513
    ],
    "mkaa": [
        1075
    ],
    "mkaa’": [
        1075
    ],
    "maure": [
        1084,
        4704,
        4705
    ],
    "mokpwe": [
        1087
    ],
    "mokpe": [
        1087
    ],
    "murgi": [
        1089
    ],
    "mbñioŋko": [
        1096
    ],
    "mbirao": [
        1097
    ],
    "mache": [
        1109,
        1110,
        1111
    ],
    "mech": [
        1109,
        1110,
        1111
    ],
    "meche": [
        1109,
        1110,
        1111
    ],
    "mechi": [
        1109,
        1110,
        1111
    ],
    "meci": [
        1109,
        1110,
        1111
    ],
    "mishāski": [
        1125,
        1126
    ],
    "miśa:ski": [
        1125,
        1126
    ],
    "masa": [
        5253,
        3671,
        4638,
        1129,
        7109
    ],
    "manenguba": [
        1135
    ],
    "malay, bacanese": [
        1153
    ],
    "mandailing": [
        1154
    ],
    "mandailing batak": [
        1154
    ],
    "mongolian": [
        4926,
        4927,
        4928,
        4929,
        4930,
        4931,
        4932,
        5090,
        5155,
        5156,
        1531,
        8558,
        1259,
        1260,
        1261,
        1170,
        1267,
        8398,
        8399
    ],
    "mayotte": [
        1172,
        2465,
        7228,
        7229
    ],
    "mbale": [
        1176
    ],
    "mongo": [
        1176,
        4450,
        4744,
        1870
    ],
    "mampa": [
        1184
    ],
    "mampwa": [
        1184
    ],
    "mandenyi": [
        1194
    ],
    "mandingi": [
        1194
    ],
    "mani": [
        1194
    ],
    "mmani": [
        1194
    ],
    "mbaelelea": [
        1198
    ],
    "mbaenggu": [
        1199
    ],
    "malay, berau": [
        1200
    ],
    "merau malay": [
        1200
    ],
    "merau": [
        1200
    ],
    "mbegumba": [
        1204
    ],
    "mvegumba": [
        1204
    ],
    "mbika": [
        1208
    ],
    "mekoh": [
        1208
    ],
    "muka": [
        1208,
        4406,
        4407,
        4408
    ],
    "manzhang dai": [
        1211
    ],
    "manzhang": [
        1211
    ],
    "malay, bukit": [
        1215
    ],
    "meratus": [
        1215
    ],
    "manaw": [
        1225,
        1226,
        4104,
        4105,
        4106
    ],
    "mwani’u": [
        1227
    ],
    "mz": [
        1228,
        1374,
        1458,
        1704,
        1912,
        2085,
        2086,
        4375,
        4747,
        4778,
        4958,
        5280,
        5361,
        5431,
        5711,
        5807,
        6127,
        6337,
        6569,
        6781,
        7539,
        7644,
        7731,
        7827,
        7837,
        8114,
        8119,
        8123,
        8124,
        8284,
        8285,
        8532,
        8566,
        8638,
        8733,
        8734,
        8846,
        8847
    ],
    "mozambique": [
        8566,
        1228,
        1374,
        1458,
        1704,
        1912,
        2085,
        2086,
        4375,
        4747,
        4778,
        4958,
        5280,
        5361,
        5431,
        5711,
        5807,
        6127,
        6337,
        6569,
        6781,
        7539,
        7644,
        7731,
        7827,
        7837,
        8114,
        8119,
        8123,
        8124,
        8284,
        8285,
        8532,
        8638,
        8733,
        8734,
        8846,
        8847
    ],
    "maniba": [
        1230
    ],
    "munduguma": [
        1234
    ],
    "mundugumor": [
        1234
    ],
    "mundukumo": [
        1234
    ],
    "mandobo bawah": [
        1238
    ],
    "mya bura": [
        1240
    ],
    "mya": [
        1240
    ],
    "miao": [
        1595,
        2970,
        2972,
        2973,
        2974,
        2975,
        2976,
        2978,
        2979,
        2980,
        2983,
        2984,
        2988,
        2989,
        2991,
        2995,
        2996,
        3050,
        3080,
        4918,
        5139,
        6801,
        1580,
        2997,
        2998,
        1245,
        2977,
        2981,
        2986,
        3005,
        3006,
        3007,
        3008,
        3009,
        4824,
        4886,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "mbwisi": [
        1247
    ],
    "molengue": [
        1250
    ],
    "molendji": [
        1250
    ],
    "minigir": [
        1253,
        8110
    ],
    "mulgarnoo": [
        1257
    ],
    "mongolia": [
        1259,
        1260,
        1261,
        1531,
        3734,
        4926,
        4927,
        4929,
        4931,
        5090,
        5985,
        7919
    ],
    "mongolia buriat": [
        1259,
        1260,
        1261
    ],
    "mongolian buriat": [
        1259,
        1260,
        1261
    ],
    "mn": [
        1259,
        1260,
        1261,
        1531,
        3734,
        4926,
        4927,
        4929,
        4931,
        5090,
        5985,
        7919
    ],
    "medumba": [
        1292
    ],
    "makakat": [
        1294
    ],
    "maqaqet": [
        1294
    ],
    "masama": [
        1297
    ],
    "malagasy, southern betsimisaraka": [
        1298,
        4736
    ],
    "mapos": [
        1304
    ],
    "mapos buang": [
        1304
    ],
    "mbisu": [
        1305,
        4553
    ],
    "mibisu": [
        1305,
        4553
    ],
    "miskito coast english creole": [
        1306
    ],
    "miskito": [
        1306
    ],
    "mískito coast english creole": [
        1307
    ],
    "mískito": [
        4809,
        1307
    ],
    "manau": [
        1317
    ],
    "monao": [
        1317
    ],
    "monau": [
        1317
    ],
    "mateo": [
        3091,
        1330
    ],
    "mp": [
        1339,
        2179,
        7678
    ],
    "mariana": [
        1339,
        2179,
        7678
    ],
    "maraworno": [
        1345
    ],
    "marworno": [
        1345
    ],
    "moseteno": [
        1346
    ],
    "mosetén": [
        1346
    ],
    "mehtã": [
        1353
    ],
    "mextã": [
        1353
    ],
    "mi tea": [
        1353
    ],
    "mi": [
        1353,
        2652
    ],
    "mochda": [
        1353
    ],
    "moxdoa": [
        1353
    ],
    "muteamasa": [
        1353
    ],
    "muxtea": [
        1353
    ],
    "mõxtã": [
        1353
    ],
    "möxdöá": [
        1353
    ],
    "managua": [
        1364
    ],
    "murato": [
        1367
    ],
    "malaccan malay creole": [
        1379
    ],
    "malaccan": [
        1379,
        4637
    ],
    "malaccan creole malay": [
        1379
    ],
    "min dong": [
        1398,
        1399,
        1400
    ],
    "min dong chinese": [
        1398,
        1399,
        1400
    ],
    "mudi": [
        1404
    ],
    "mudikora": [
        1404
    ],
    "muott": [
        1405,
        1406,
        1407
    ],
    "maphekha": [
        1436
    ],
    "micronesia": [
        1445,
        2152,
        3866,
        3880,
        4855,
        5051,
        5432,
        5528,
        5583,
        5748,
        6108,
        6147,
        6258,
        6371,
        7181,
        7949,
        8308,
        8309,
        8735
    ],
    "mari (russia)": [
        1447,
        1448
    ],
    "mari": [
        1447,
        1448,
        3018,
        4622,
        5049,
        3640,
        5227
    ],
    "mari, meadow": [
        1447,
        1448
    ],
    "meadow": [
        1447,
        1448
    ],
    "mari-woods": [
        1447,
        1448
    ],
    "mojai": [
        1461
    ],
    "méa": [
        1474
    ],
    "minnesota ojibwe": [
        1475,
        1476
    ],
    "minnesota": [
        1475,
        1476
    ],
    "mitsts": [
        1483
    ],
    "makaang": [
        1503
    ],
    "mgan": [
        1503
    ],
    "mkan": [
        1503
    ],
    "m’kaang": [
        1503
    ],
    "mini": [
        1505,
        4749
    ],
    "mixed": [
        1513,
        2510,
        1588,
        6544
    ],
    "mishmi": [
        4785,
        1520,
        1521,
        5214,
        9068
    ],
    "midhi": [
        1520,
        1521
    ],
    "melets tatar": [
        1527
    ],
    "melets": [
        1527
    ],
    "maa": [
        1529,
        4591,
        4592,
        4702
    ],
    "ma krung": [
        1529
    ],
    "ma ngan": [
        1529
    ],
    "ma to": [
        1529
    ],
    "ma xop": [
        1529
    ],
    "maaq": [
        1529
    ],
    "michigamea": [
        1534
    ],
    "mnong, central": [
        1535,
        1536,
        1537
    ],
    "mnong": [
        1535,
        1536,
        1537,
        4941,
        4949
    ],
    "mro-khimi": [
        1538
    ],
    "mro": [
        1538,
        5054,
        5055
    ],
    "mro-khimi chin": [
        1538
    ],
    "messapic": [
        1539
    ],
    "montenegrin": [
        1552,
        1553,
        7088,
        7090,
        7092,
        8906
    ],
    "me": [
        2331,
        2081,
        8549,
        1747,
        3791,
        1552,
        1553,
        7091,
        7095
    ],
    "montenegro": [
        8906,
        1552,
        1553,
        7091,
        7095
    ],
    "manowee": [
        1554
    ],
    "middle cornish": [
        1558
    ],
    "malay, cocos islands": [
        1560
    ],
    "melayu cocos": [
        1560
    ],
    "mam": [
        4585,
        1561,
        6564,
        7757
    ],
    "mission": [
        1568
    ],
    "moses-columbia": [
        1570
    ],
    "moses-columbia salish": [
        1570
    ],
    "miluk": [
        3207,
        1577
    ],
    "mishikhwutmetunee": [
        1577
    ],
    "mjiuniang": [
        1580
    ],
    "mii": [
        1584,
        1629
    ],
    "minor": [
        1587,
        2218
    ],
    "melanesian-chinese mixed pidgin english": [
        1588
    ],
    "melanesian-chinese": [
        1588
    ],
    "miao, chuanqiandian cluster": [
        1595
    ],
    "michif": [
        1603
    ],
    "mitchif": [
        1603
    ],
    "métis": [
        1603
    ],
    "main": [
        1612,
        1613,
        1614,
        1652
    ],
    "moose": [
        1614,
        4974,
        4975
    ],
    "moose cree": [
        1614
    ],
    "manjui": [
        1617
    ],
    "manjuy": [
        1617
    ],
    "miwok, coast": [
        1638
    ],
    "miwok": [
        1638,
        1642,
        4415,
        5698,
        6220,
        6915,
        4862
    ],
    "miwok, central sierra": [
        1642
    ],
    "manual": [
        1643,
        4728,
        5076
    ],
    "marais": [
        1652
    ],
    "maskekon": [
        1652
    ],
    "moskégon": [
        1652
    ],
    "medio": [
        1660,
        4810,
        8663
    ],
    "moundadan": [
        1675
    ],
    "mamundadan chetty": [
        1675
    ],
    "mamundadan": [
        1675
    ],
    "mandadan chetty": [
        1675
    ],
    "mandadan": [
        1675
    ],
    "moundadan chetty": [
        1675
    ],
    "moundan chetty": [
        1675
    ],
    "moundan": [
        1675,
        5126
    ],
    "marcos": [
        6197,
        1676,
        8973
    ],
    "miew": [
        1680
    ],
    "mieu": [
        1680
    ],
    "maiben": [
        1685
    ],
    "mashco piro": [
        1686
    ],
    "mashco": [
        1686
    ],
    "madiha": [
        1688,
        1929
    ],
    "madihá": [
        1688
    ],
    "madija": [
        1688
    ],
    "multi-colored waistband tai": [
        1694
    ],
    "multi-colored": [
        1694
    ],
    "monpa": [
        3741,
        7828,
        5893,
        1700,
        1701,
        4494,
        5929,
        5930,
        7738
    ],
    "maindo": [
        1704
    ],
    "min zhong chinese": [
        1717
    ],
    "minzhonghua": [
        1717
    ],
    "mingphuin": [
        1718
    ],
    "mumeng": [
        1723,
        6346
    ],
    "marik": [
        1724
    ],
    "marik od": [
        1724
    ],
    "matupi": [
        2968,
        1736,
        1737
    ],
    "maria, dandami": [
        1739
    ],
    "maria": [
        1739,
        4670,
        5058,
        2836
    ],
    "madiya": [
        5058,
        1739
    ],
    "maria gond": [
        1739
    ],
    "medz": [
        1740
    ],
    "mongo-sila": [
        1742
    ],
    "matino": [
        1744
    ],
    "maniwo": [
        1746
    ],
    "mangambilis": [
        1750
    ],
    "masakin dagig": [
        1793
    ],
    "masakin": [
        1793,
        3387
    ],
    "munsee": [
        1802
    ],
    "munsee delaware": [
        1802
    ],
    "munsiiw": [
        1802
    ],
    "mackenzian": [
        1804,
        1805,
        6734,
        6735
    ],
    "magabara": [
        1818
    ],
    "metru": [
        1845,
        6883
    ],
    "mesa grande diegueño": [
        1851
    ],
    "mesa": [
        1851
    ],
    "mbong": [
        1852
    ],
    "magrau": [
        1861,
        1862
    ],
    "manyo": [
        1863
    ],
    "mbogedo": [
        1863
    ],
    "mbogedu": [
        1863
    ],
    "mutyu": [
        1875
    ],
    "maroon": [
        1878,
        1879
    ],
    "mugumute": [
        1884
    ],
    "menindal": [
        1889
    ],
    "menindaq": [
        1889
    ],
    "minansut": [
        1889,
        2717
    ],
    "mazagway-hidi": [
        1891
    ],
    "mazagway": [
        1891
    ],
    "mombo": [
        1897
    ],
    "mombo dogon": [
        1897
    ],
    "madhi madhi": [
        1899
    ],
    "madhi": [
        1899
    ],
    "madhi-madhi": [
        1899
    ],
    "madhimadhi": [
        1899
    ],
    "mathi-mathi": [
        1899
    ],
    "muthi muthi": [
        1899
    ],
    "muthi": [
        1899
    ],
    "muthimuthi": [
        1899
    ],
    "mutti mutti": [
        1899
    ],
    "mutti": [
        1899
    ],
    "memekere": [
        1900
    ],
    "mofu-dugwor": [
        1900
    ],
    "medefaidrin": [
        1901
    ],
    "milian": [
        1902
    ],
    "mudburra": [
        1911
    ],
    "madbara": [
        1911
    ],
    "moodburra": [
        1911
    ],
    "mootburra": [
        1911
    ],
    "mudbara": [
        1911
    ],
    "mudbarra": [
        1911
    ],
    "mudbera": [
        1911
    ],
    "mudbra": [
        1911
    ],
    "mudbura": [
        1911
    ],
    "mutpura": [
        1911
    ],
    "muris": [
        1913
    ],
    "maiya": [
        1924
    ],
    "mid": [
        1925
    ],
    "mid grand valley dani": [
        1925
    ],
    "macrolanguage": [
        1936,
        1937,
        1938,
        3861,
        5067,
        5068,
        5069,
        5071,
        5072,
        5073,
        5385,
        5386,
        5387,
        5388,
        5948,
        5949,
        7223,
        7224,
        7225,
        7226,
        7227,
        5070,
        9186,
        9187
    ],
    "mositacha": [
        1950
    ],
    "minderico": [
        1955
    ],
    "minde": [
        1955
    ],
    "melobong rungus": [
        1958
    ],
    "melobong": [
        1958
    ],
    "melubong rungus": [
        1958
    ],
    "melubong": [
        1958
    ],
    "memagun": [
        1958
    ],
    "memogun": [
        1958
    ],
    "momogun": [
        1958,
        7447
    ],
    "melanau, daro-matu": [
        1962
    ],
    "melanau": [
        1962,
        4113,
        4690,
        6768
    ],
    "marille": [
        1970
    ],
    "middle dutch (ca. 1050-1350)": [
        2006
    ],
    "malang": [
        2010,
        6178
    ],
    "mali duun": [
        2016
    ],
    "maldivian": [
        2019,
        2020
    ],
    "mahl": [
        2019,
        2020
    ],
    "malikh": [
        2019,
        2020
    ],
    "malki": [
        2019,
        2020
    ],
    "mv": [
        2019,
        2020
    ],
    "maldives": [
        2019,
        2020
    ],
    "modenese": [
        2068
    ],
    "mada": [
        4651,
        5225,
        2069
    ],
    "mada dutse": [
        2069
    ],
    "mada eggon": [
        2069
    ],
    "mo egon": [
        2069
    ],
    "mo": [
        8248,
        2069,
        4852,
        5278,
        8819,
        2178,
        5274,
        6336,
        9028,
        9031
    ],
    "miyakubo sign language": [
        2071
    ],
    "miyakubo": [
        2071
    ],
    "miyakubo shuwa": [
        2071
    ],
    "me mana": [
        2081
    ],
    "mana": [
        2407,
        2081,
        3323
    ],
    "mee mana": [
        2081
    ],
    "modern greek (1453-)": [
        2092,
        2090,
        2091,
        2093
    ],
    "molo": [
        9095,
        2099
    ],
    "malo": [
        4875,
        2103
    ],
    "maloh": [
        2103
    ],
    "matoh": [
        2103
    ],
    "mbaloh": [
        2103
    ],
    "memaloh": [
        2103
    ],
    "melejo": [
        2104
    ],
    "mereo": [
        2104
    ],
    "mereyo": [
        2104
    ],
    "mewahang, eastern": [
        2105
    ],
    "mewahang": [
        2105,
        6458
    ],
    "meohang": [
        2105,
        6458
    ],
    "mussau-emira": [
        2106
    ],
    "mussau": [
        2106
    ],
    "musao": [
        2106
    ],
    "musau-emira": [
        2106
    ],
    "mamulique": [
        2107
    ],
    "minyag, eastern": [
        2110
    ],
    "minyag": [
        2110,
        8276
    ],
    "munya": [
        2110,
        8276
    ],
    "muya": [
        2110,
        4851,
        8276
    ],
    "muria, eastern": [
        2113
    ],
    "muria": [
        2113,
        2404,
        5143
    ],
    "muria gonḍi": [
        2113
    ],
    "mayan": [
        2116,
        5076
    ],
    "mbessa": [
        2117
    ],
    "mbesa": [
        9099,
        2117
    ],
    "mbizenaku": [
        2117
    ],
    "malvinas": [
        2151
    ],
    "man": [
        4912,
        3283,
        3284,
        3285,
        3286,
        3287,
        4208,
        4824,
        4935,
        4936,
        4937,
        6121,
        7870,
        3005,
        3006,
        3007,
        3008,
        3009,
        7601,
        7865,
        7866,
        8670,
        8671,
        8672,
        2164,
        2826
    ],
    "mh": [
        2177,
        4766
    ],
    "marshall islands": [
        2177,
        4766
    ],
    "marshall": [
        2177,
        4766
    ],
    "macao": [
        2963,
        5274,
        2178,
        6336,
        9028,
        9031
    ],
    "ms": [
        2180
    ],
    "malta": [
        2181,
        4663,
        5098,
        5099,
        5100
    ],
    "mauritius": [
        4712,
        2182,
        2450,
        4505
    ],
    "mw": [
        2183,
        4173,
        4201,
        4453,
        4556,
        5532,
        5786,
        5787,
        5804,
        7238,
        7643,
        7794
    ],
    "malawi": [
        4453,
        5804,
        7238,
        4556,
        5532,
        2183,
        4173,
        4201,
        5786,
        5787,
        7643,
        7794
    ],
    "markweeta": [
        2228
    ],
    "marakuet": [
        2228
    ],
    "marakwet": [
        2228
    ],
    "markweta": [
        2228
    ],
    "madu": [
        2232
    ],
    "middle english (1100-1500)": [
        2234
    ],
    "melilla": [
        2269
    ],
    "méxico": [
        5991,
        2275,
        4728
    ],
    "muri": [
        2315,
        2636,
        4954
    ],
    "mongol": [
        4760,
        4926,
        4927,
        4929,
        4931,
        4932,
        5155,
        5156,
        2320,
        2321,
        2322,
        8398,
        8399
    ],
    "mis-kemba": [
        2333
    ],
    "maasina": [
        2378,
        2379
    ],
    "maacina": [
        2378,
        2379
    ],
    "maasina fulfulde": [
        2378,
        2379
    ],
    "maasinankoore": [
        2378,
        2379
    ],
    "macina": [
        2378,
        2379
    ],
    "mahas": [
        2383,
        2384,
        2385
    ],
    "mahas-fiadidja": [
        2383,
        2384,
        2385
    ],
    "mahas-fiyadikkya": [
        2383,
        2384,
        2385
    ],
    "meänkieli": [
        2391
    ],
    "myá kákíryà": [
        2394
    ],
    "myá": [
        2394
    ],
    "myá kónzə̀l": [
        2394
    ],
    "mubi": [
        5127,
        2411,
        2579,
        2398
    ],
    "muchella": [
        2398
    ],
    "mutumui": [
        2400
    ],
    "muria, far western": [
        2404
    ],
    "mubi river": [
        2411
    ],
    "momu": [
        2417,
        2602
    ],
    "mc": [
        2444
    ],
    "monaco": [
        2444
    ],
    "mf": [
        2445
    ],
    "martin": [
        6426,
        2445
    ],
    "mq": [
        2448
    ],
    "martinique": [
        2448
    ],
    "miquelon": [
        2454
    ],
    "middle french (ca. 1400-1600)": [
        2469
    ],
    "mamgak": [
        2472
    ],
    "mbororo": [
        2479,
        2480,
        2497,
        2498
    ],
    "marilenghe": [
        2494
    ],
    "mafufu": [
        2499
    ],
    "mafulu": [
        2499
    ],
    "maja": [
        2509
    ],
    "mixed great andamanese": [
        2510
    ],
    "maroa": [
        2512
    ],
    "md": [
        2514,
        2515,
        2516,
        6577,
        6580,
        6615,
        8139
    ],
    "moldova": [
        8139,
        2514,
        2515,
        2516,
        6577,
        6580,
        6615
    ],
    "mbore": [
        2518
    ],
    "mborena kam": [
        2518
    ],
    "mborena": [
        2518
    ],
    "mborei": [
        2518
    ],
    "mudhili": [
        2532
    ],
    "mudhili gadaba": [
        2532
    ],
    "meiyari": [
        2543
    ],
    "mo’da": [
        2554
    ],
    "mo'da": [
        2554
    ],
    "muda": [
        8841,
        2554
    ],
    "matai": [
        2557
    ],
    "maiba": [
        2561
    ],
    "mali-baining": [
        2565
    ],
    "mainland tangkic": [
        2566
    ],
    "mainland": [
        2566
    ],
    "mundli": [
        2575,
        2576
    ],
    "mitebog": [
        2578
    ],
    "mapodi": [
        2579
    ],
    "mapuda": [
        2579
    ],
    "mocigin": [
        2579
    ],
    "motchekin": [
        2579
    ],
    "mudaye": [
        2579
    ],
    "mitstsi": [
        2590,
        7508
    ],
    "mehri": [
        2591
    ],
    "mahri": [
        2591
    ],
    "minyafuin": [
        2604
    ],
    "mina": [
        2999,
        5239,
        2605,
        8189
    ],
    "mina-gen": [
        2605
    ],
    "marwari ghera": [
        2621
    ],
    "marwari": [
        5153,
        5154,
        5190,
        5191,
        6643,
        2621
    ],
    "mid-waria": [
        2636
    ],
    "ma kaɗa": [
        2641
    ],
    "maroua": [
        2652
    ],
    "marva": [
        2652,
        2658
    ],
    "mi marva": [
        2652
    ],
    "mulao": [
        2654,
        4886
    ],
    "miksimap": [
        2664
    ],
    "magɨ": [
        2668
    ],
    "magɨ (madang province)": [
        2668
    ],
    "madang": [
        2668,
        3018
    ],
    "moriil": [
        2679,
        9107
    ],
    "mághdì": [
        2690
    ],
    "magiyi": [
        2691
    ],
    "magɨyi": [
        2691
    ],
    "middle high german (ca. 1050-1500)": [
        2692
    ],
    "middle low german": [
        2693
    ],
    "mbodomo": [
        2694
    ],
    "mirning": [
        2696
    ],
    "mirniny": [
        2696
    ],
    "magoma": [
        2700
    ],
    "mycenaean greek": [
        2701
    ],
    "mycenaean": [
        2701
    ],
    "mgbolizhia": [
        2702
    ],
    "mgbo": [
        2702
    ],
    "miganganm": [
        2709
    ],
    "migangam": [
        2709
    ],
    "mijiem": [
        2709
    ],
    "ma gavar": [
        2748
    ],
    "makwar": [
        2756
    ],
    "mokar": [
        2756
    ],
    "madi": [
        2768,
        3305,
        4443,
        4774,
        5058,
        5082,
        7003
    ],
    "marudu": [
        2772
    ],
    "mande": [
        2777,
        2778,
        2779,
        4277,
        4586,
        4587,
        4588,
        4589,
        6641,
        6642
    ],
    "mandi": [
        2777,
        2778,
        2779,
        4277,
        4795,
        4827,
        4828,
        7781
    ],
    "muno": [
        2784
    ],
    "mundart": [
        2795
    ],
    "mashiki": [
        2803
    ],
    "misak": [
        2814
    ],
    "moguex": [
        2814
    ],
    "mbyá": [
        2815
    ],
    "mbya": [
        2815,
        7115
    ],
    "mbiá": [
        2815
    ],
    "mbua": [
        2815
    ],
    "mbya-apytere": [
        2815
    ],
    "mbyá guaraní": [
        2815
    ],
    "mítua": [
        2816
    ],
    "mítus": [
        2816
    ],
    "maléku jaíka": [
        2821
    ],
    "maléku": [
        2821
    ],
    "malécu lhaíca": [
        2821
    ],
    "malécu": [
        2821
    ],
    "migulimancema": [
        2824
    ],
    "manx": [
        2826
    ],
    "manx gaelic": [
        2826
    ],
    "mãe": [
        2836
    ],
    "mbato": [
        2841
    ],
    "mbatto": [
        2841
    ],
    "mgbato": [
        2841
    ],
    "m’bato": [
        2841
    ],
    "moo": [
        2847
    ],
    "móò": [
        2847
    ],
    "mòò": [
        2847
    ],
    "mamangidigh": [
        2850
    ],
    "mamangiti": [
        2850
    ],
    "mbadjana": [
        2850
    ],
    "malununda": [
        2859
    ],
    "maré": [
        2868,
        3267
    ],
    "mgbakpa": [
        2874,
        2875,
        2876
    ],
    "moosehide": [
        2882
    ],
    "macho": [
        2884
    ],
    "macho-zwani": [
        2884
    ],
    "mansim": [
        2885
    ],
    "masset": [
        2890
    ],
    "majiahua": [
        2893,
        2894,
        2895
    ],
    "makuahine": [
        2907
    ],
    "matakaia hoyahoya": [
        2932
    ],
    "matakaia": [
        2932
    ],
    "modern standard hindi": [
        2933,
        2934,
        2935,
        2936
    ],
    "minitari": [
        2939
    ],
    "masarwa": [
        2950
    ],
    "malayisch": [
        2955
    ],
    "mel-khaonh": [
        2962
    ],
    "macao sign language": [
        2963
    ],
    "macau sign language": [
        2963
    ],
    "macau": [
        2963,
        8923,
        8924,
        8925,
        8926
    ],
    "macausl": [
        2963
    ],
    "matu": [
        2968,
        4787
    ],
    "matu chin": [
        2968
    ],
    "miao, southern mashan": [
        2970
    ],
    "mashan": [
        2970,
        2984,
        2988,
        2995
    ],
    "miao, central huishui": [
        2972
    ],
    "miao, large flowery": [
        2973,
        2974,
        2975
    ],
    "miao, eastern huishui": [
        2976
    ],
    "miao, southwestern guiyang": [
        2978
    ],
    "miao, southwestern huishui": [
        2979
    ],
    "miao, northern huishui": [
        2980
    ],
    "maek": [
        2982
    ],
    "miao, luopohe": [
        2983
    ],
    "miao, central mashan": [
        2984
    ],
    "mong": [
        2985,
        2986,
        2987,
        3005,
        3006,
        3007,
        3008,
        3009,
        5197,
        5198,
        5199,
        5200,
        5201,
        7529
    ],
    "moob": [
        3005,
        3006,
        3007,
        3008,
        3009,
        2986
    ],
    "miao, northern qiandong": [
        2986
    ],
    "m̥hu˧": [
        2986
    ],
    "m̥ə˧": [
        2986
    ],
    "miao, northern mashan": [
        2988
    ],
    "miao, eastern qiandong": [
        2989
    ],
    "mo˧": [
        2989
    ],
    "mhar": [
        2990
    ],
    "miao, southern qiandong": [
        2991
    ],
    "miao, western mashan": [
        2995
    ],
    "miao, southern guiyang": [
        2996
    ],
    "mushu maio": [
        2997,
        2998
    ],
    "mushu": [
        2997,
        2998
    ],
    "maio": [
        2997,
        2998
    ],
    "miáo": [
        2997,
        2998
    ],
    "mina (cameroon)": [
        2999
    ],
    "miao tsi": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "mong leng": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "mong njua": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "mong ntsua": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "moob leeg": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "meo": [
        4918,
        5139,
        5197,
        5198,
        5199,
        5200,
        5201,
        6121,
        3008,
        5618
    ],
    "meo dam": [
        3008
    ],
    "meo lai": [
        3008,
        6121
    ],
    "mangyan": [
        3010,
        3011,
        3244
    ],
    "minaŋyan": [
        3010,
        3011
    ],
    "motu, hiri": [
        3015,
        3016
    ],
    "motu": [
        3015,
        3016,
        4701
    ],
    "mari (madang province)": [
        3018
    ],
    "minh": [
        3034,
        8923,
        8924,
        8925,
        8926
    ],
    "malei": [
        3035
    ],
    "malei-hote": [
        3035
    ],
    "malê": [
        3035
    ],
    "megyaw": [
        3040
    ],
    "mil": [
        3046
    ],
    "moi": [
        4979,
        5218,
        3047,
        3048,
        5078
    ],
    "moi da vach": [
        3047,
        3048
    ],
    "moi luy": [
        3047,
        3048
    ],
    "miao, horned": [
        3050
    ],
    "magyar jelnyelv": [
        3059
    ],
    "magyar": [
        3070,
        3059,
        3071
    ],
    "magyarországi jelnyelv": [
        3059
    ],
    "magyarországi": [
        3059
    ],
    "maganar bebaye": [
        3060
    ],
    "maganar": [
        3060
    ],
    "maganar hannu": [
        3060
    ],
    "minika": [
        3066
    ],
    "mɨnɨca": [
        3066
    ],
    "meneca": [
        3066
    ],
    "meneka": [
        3066
    ],
    "minica huitoto": [
        3066
    ],
    "minica": [
        3066
    ],
    "mɨnɨca huitoto": [
        3066
    ],
    "middle hittite": [
        3069
    ],
    "madžarski": [
        3070,
        3071
    ],
    "maghiar": [
        3070,
        3071
    ],
    "maďarský": [
        3070,
        3071
    ],
    "mađarski": [
        3070,
        3071
    ],
    "mar": [
        3075,
        3091,
        3097,
        3100,
        4848
    ],
    "miao, northern guiyang": [
        3080
    ],
    "mixinewhe’": [
        3085
    ],
    "murui": [
        3090
    ],
    "murai": [
        3090
    ],
    "murai huitoto": [
        3090
    ],
    "murui huitoto": [
        3090
    ],
    "muinane huitoto": [
        3093
    ],
    "myts": [
        3095
    ],
    "maría": [
        3100,
        5255,
        5467,
        9128,
        4800,
        4803,
        5224,
        6056,
        8654,
        8974,
        8992,
        9124,
        9138,
        9142
    ],
    "mukta": [
        3106
    ],
    "munta": [
        3106
    ],
    "maipua": [
        3114
    ],
    "misiwa": [
        3136
    ],
    "mun’alyon": [
        3145
    ],
    "mayoyao": [
        3152
    ],
    "mayayao ifugao": [
        3152
    ],
    "mayayao": [
        3152
    ],
    "mayaoyaw": [
        3152
    ],
    "mayoyao ifugao": [
        3152
    ],
    "mojo": [
        3160
    ],
    "moja": [
        3160
    ],
    "mojeño": [
        3160,
        7712
    ],
    "moxo": [
        3160,
        7712
    ],
    "maranao": [
        5063,
        3197
    ],
    "mala malasar": [
        3205
    ],
    "mala": [
        3205,
        4919,
        6091,
        6633,
        4682,
        4831,
        3345
    ],
    "malasar": [
        8854,
        3205
    ],
    "maha malasar": [
        3205
    ],
    "maha": [
        3205,
        4703
    ],
    "malai malasar": [
        3205
    ],
    "malai": [
        3205,
        4833,
        4834,
        6067
    ],
    "malasir": [
        3205
    ],
    "mindivi": [
        3206
    ],
    "marsian": [
        3211
    ],
    "milyan": [
        3212
    ],
    "mocoa": [
        3218
    ],
    "minaean": [
        3220
    ],
    "miango": [
        3237
    ],
    "miyango": [
        3237
    ],
    "mbulu": [
        3238
    ],
    "mbulunge": [
        3238
    ],
    "manoki": [
        3239
    ],
    "münkü": [
        3239
    ],
    "mozhi": [
        3241,
        3242
    ],
    "maruhia": [
        3246
    ],
    "maragat": [
        3248
    ],
    "masimasi": [
        3254
    ],
    "marino": [
        5040,
        3263
    ],
    "moré": [
        3267,
        4974,
        4975
    ],
    "mbon": [
        3271
    ],
    "mbuzo": [
        3271
    ],
    "machoto": [
        3272
    ],
    "maeng": [
        3275
    ],
    "maeng itneg": [
        3275
    ],
    "moyadan": [
        3279
    ],
    "moyadan itneg": [
        3279
    ],
    "mienh": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "mian": [
        5003,
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "mjen": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "myen": [
        3283,
        3284,
        3285,
        3286,
        3287,
        5231,
        5232
    ],
    "may river": [
        3291
    ],
    "may": [
        3291,
        6719
    ],
    "may river iwam": [
        3291
    ],
    "morop": [
        3292
    ],
    "mesaka": [
        3297
    ],
    "messaga": [
        3297
    ],
    "messaga-ekol": [
        3297
    ],
    "messaka": [
        3297
    ],
    "mapi": [
        3318
    ],
    "musali": [
        3320
    ],
    "malay, jambi": [
        3322
    ],
    "mountain jewish": [
        3341,
        3342,
        3343
    ],
    "manem": [
        3353
    ],
    "majuu": [
        3355
    ],
    "mangbele": [
        3355
    ],
    "mobwa": [
        3381
    ],
    "maleh": [
        3381
    ],
    "mobwa karen": [
        3381
    ],
    "monpwa": [
        3381
    ],
    "mopwa": [
        3381
    ],
    "mogpha": [
        3383
    ],
    "mogwa": [
        3383
    ],
    "monebwa": [
        3383
    ],
    "monnepwa": [
        3383
    ],
    "mopaga": [
        3383
    ],
    "mopha": [
        3383
    ],
    "mesakin": [
        3387
    ],
    "machame": [
        3391
    ],
    "macame": [
        3391
    ],
    "machambe": [
        3391
    ],
    "madjame": [
        3391
    ],
    "mashami": [
        3391
    ],
    "makuri": [
        3395
    ],
    "makuri naga": [
        3395
    ],
    "makury": [
        3395
    ],
    "makury naga": [
        3395
    ],
    "mara": [
        5048,
        3396,
        4682,
        5950
    ],
    "mashi": [
        3397,
        4780,
        6852
    ],
    "mashi (nigeria)": [
        3397
    ],
    "mouwase": [
        3398
    ],
    "mixtec, western juxtlahuaca": [
        3399
    ],
    "mixtec": [
        3399,
        4572,
        4624,
        4629,
        4673,
        4686,
        4792,
        4796,
        4798,
        4799,
        4800,
        4803,
        4804,
        4807,
        4808,
        4812,
        4813,
        4815,
        4816,
        4817,
        4819,
        4864,
        4996,
        5016,
        5121,
        5124,
        5157,
        5205,
        5206,
        5223,
        5224,
        5226,
        5229,
        5255,
        8106,
        8113,
        8116,
        8118,
        8125,
        8645,
        8646,
        8648,
        8652,
        8653,
        8654,
        8655,
        8656,
        8658,
        8662,
        8663,
        8664,
        8667
    ],
    "mixteco del oeste de juxtlahuaca": [
        3399
    ],
    "mixteco": [
        3399,
        4572,
        4624,
        4629,
        4673,
        4686,
        4792,
        4796,
        4798,
        4799,
        4800,
        4803,
        4804,
        4807,
        4808,
        4812,
        4813,
        4815,
        4816,
        4817,
        4819,
        4996,
        5016,
        5121,
        5124,
        5157,
        5205,
        5206,
        5223,
        5224,
        5229,
        5255,
        8106,
        8113,
        8116,
        8118,
        8125,
        8645,
        8646,
        8648,
        8652,
        8653,
        8654,
        8656,
        8658,
        8663,
        8664,
        8667
    ],
    "munni": [
        3402
    ],
    "manus": [
        4378,
        7777,
        3406
    ],
    "malinké": [
        3411,
        4587,
        4588,
        4589,
        4890,
        4891
    ],
    "mthur": [
        3419,
        3420
    ],
    "manu": [
        3431,
        4104,
        4105,
        4106,
        5119
    ],
    "manuley": [
        3431
    ],
    "manuri": [
        3431
    ],
    "mimbara": [
        3431
    ],
    "monnoo": [
        3431
    ],
    "mäbaan": [
        3434
    ],
    "marip": [
        3461
    ],
    "malinke": [
        3471,
        4447,
        4890,
        4891,
        4587,
        4588,
        4589,
        5183
    ],
    "maninka": [
        4866,
        5075,
        4589,
        3471,
        4890,
        4891,
        4587,
        4588,
        5183
    ],
    "mits": [
        3472
    ],
    "malpa": [
        3478
    ],
    "mbaya-guaikuru": [
        3480
    ],
    "maditi": [
        3491
    ],
    "ma’di": [
        4774,
        7003,
        3491,
        4741,
        4879,
        4880
    ],
    "mangguar": [
        3500
    ],
    "manga": [
        3503,
        3504,
        4710,
        4915,
        7490
    ],
    "manga kanuri": [
        3503,
        3504
    ],
    "makalaka": [
        3516
    ],
    "mamoun": [
        3518
    ],
    "makonde": [
        3535
    ],
    "maconde": [
        3535
    ],
    "makonda": [
        3535
    ],
    "matambwe": [
        3535
    ],
    "mekwengo": [
        3535
    ],
    "mamusi": [
        3536
    ],
    "mu chikunda": [
        3545
    ],
    "ma-yɛgaŋ": [
        3560
    ],
    "mevembet": [
        3565
    ],
    "malinguat": [
        3565
    ],
    "manyang": [
        3571
    ],
    "malampashi": [
        3579,
        3580
    ],
    "male kudiya": [
        3595,
        3596
    ],
    "male": [
        4677,
        4678,
        3595,
        3596,
        4653,
        4831,
        4833
    ],
    "malhesti": [
        3601,
        3602
    ],
    "milchan": [
        3601,
        3602
    ],
    "milchanang": [
        3601,
        3602
    ],
    "milchang": [
        3601,
        3602
    ],
    "mongi": [
        3624
    ],
    "magar kham": [
        3627,
        3676,
        3684,
        3709
    ],
    "magar": [
        4755,
        4756,
        5042,
        3627,
        3676,
        3684,
        3709,
        4176
    ],
    "mo-di": [
        3632
    ],
    "mimika": [
        3634
    ],
    "mukamuga": [
        3634
    ],
    "manif": [
        3635
    ],
    "maiyach": [
        3640
    ],
    "meon": [
        3640
    ],
    "maharashtra bhil": [
        3655
    ],
    "maharashtra": [
        3655,
        5036,
        5037,
        5038
    ],
    "muhumbi": [
        3664
    ],
    "makware": [
        3691
    ],
    "mlap": [
        3696
    ],
    "malf": [
        3696
    ],
    "meher": [
        3700
    ],
    "mou": [
        3702,
        3703,
        3704,
        4956
    ],
    "mun xen": [
        3702,
        3703,
        3704
    ],
    "mun": [
        4824,
        3702,
        3703,
        3704,
        4956,
        6365
    ],
    "manchurian kirghiz": [
        3705
    ],
    "manchurian": [
        3705
    ],
    "moulmein pwo karen": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718
    ],
    "moulmein": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718
    ],
    "monpa, kalaktang": [
        3741
    ],
    "mabaka": [
        3742
    ],
    "mabaka itneg": [
        3742
    ],
    "mabaka valley kalinga": [
        3742
    ],
    "megi": [
        3744
    ],
    "mkaka": [
        3745
    ],
    "mkako": [
        3745
    ],
    "mek kosarek": [
        3748
    ],
    "mek": [
        3748,
        5545
    ],
    "ma giiwo": [
        3755
    ],
    "maki": [
        3772
    ],
    "makki": [
        3772
    ],
    "mangki": [
        3772
    ],
    "mangkir": [
        3772
    ],
    "ma’ki": [
        3772
    ],
    "migum": [
        3776
    ],
    "maskelynes": [
        3786
    ],
    "maskelyne islands": [
        3786
    ],
    "maskelyne": [
        3786
    ],
    "mbundu": [
        7957,
        3793
    ],
    "majukayang": [
        3796
    ],
    "madukayang kalinga": [
        3796
    ],
    "madukayang": [
        3796
    ],
    "majukayang kalinga": [
        3796
    ],
    "majukayong": [
        3796
    ],
    "monmon": [
        3800
    ],
    "mseŋ": [
        3800
    ],
    "mad": [
        3802,
        4848
    ],
    "mal": [
        4848,
        4879,
        4880,
        3802,
        4356
    ],
    "maler": [
        3802,
        4836,
        4837,
        4848
    ],
    "malti": [
        5098,
        3802,
        4836,
        4837,
        4848,
        5099,
        5100
    ],
    "malto": [
        3802,
        4836,
        4837,
        4848
    ],
    "maltu": [
        3802,
        4836,
        4837,
        4848
    ],
    "mangali kalinga": [
        3804
    ],
    "mangali": [
        3804
    ],
    "mankanya": [
        3825
    ],
    "mancagne": [
        3825
    ],
    "mancang": [
        3825
    ],
    "mancanha": [
        3825
    ],
    "mankaañ": [
        3825
    ],
    "mankanha": [
        3825
    ],
    "miguel": [
        4798,
        6722,
        8658,
        3827,
        8117,
        9114,
        9138,
        9167
    ],
    "mangalorean": [
        3832,
        3833,
        3861
    ],
    "maniq": [
        3836,
        3838,
        3839,
        7637
    ],
    "mawas": [
        3838,
        3839
    ],
    "mengo": [
        3838,
        3839
    ],
    "meni": [
        3838,
        3839,
        4681
    ],
    "menik": [
        3838,
        3839
    ],
    "moni": [
        4959,
        3838,
        3839
    ],
    "monik": [
        3838,
        3839
    ],
    "moniq": [
        3838,
        3839
    ],
    "mos": [
        3838,
        3839,
        7637
    ],
    "mullu": [
        3874
    ],
    "mullu kurumba": [
        3874
    ],
    "micc’i": [
        3892
    ],
    "mountain koiali": [
        3895
    ],
    "mountain koiari": [
        3895
    ],
    "mum": [
        3898
    ],
    "minuslim kalagan": [
        3902
    ],
    "minuslim": [
        3902
    ],
    "miyak": [
        3909
    ],
    "maragang": [
        3915
    ],
    "marigang": [
        3915
    ],
    "murut, kolod": [
        3919
    ],
    "mser": [
        3921
    ],
    "msər": [
        3921
    ],
    "malqartil": [
        3929
    ],
    "midiki": [
        3930
    ],
    "madutara": [
        3985
    ],
    "maduwonga": [
        3985
    ],
    "muyu, north": [
        3990
    ],
    "muyu": [
        3990,
        3999,
        5251,
        5784
    ],
    "moejoe": [
        3999,
        3990
    ],
    "muyu, south": [
        3999
    ],
    "metomka": [
        3999
    ],
    "mbarike": [
        4015
    ],
    "memme goji": [
        4021
    ],
    "memme": [
        4021
    ],
    "mashariki": [
        4023
    ],
    "mcgrath ingalik": [
        4035
    ],
    "mcgrath": [
        4035
    ],
    "masin-lak": [
        4048
    ],
    "murut, kalabakan": [
        4049
    ],
    "marlasi": [
        4067
    ],
    "mati": [
        9087,
        4077
    ],
    "mataweja": [
        4077
    ],
    "makoroko": [
        4097
    ],
    "mucoroca": [
        4097
    ],
    "melayu brunei": [
        4102,
        4103
    ],
    "manu manaw": [
        4104,
        4105,
        4106
    ],
    "manumanaw": [
        4104,
        4105,
        4106
    ],
    "manumanaw karen": [
        4104,
        4105,
        4106
    ],
    "manö": [
        4104,
        4105,
        4106
    ],
    "monu": [
        4104,
        4105,
        4106
    ],
    "manu and manaw dialects": [
        4106
    ],
    "murut, keningau": [
        4108
    ],
    "melanau, kanowit-tanjong": [
        4113
    ],
    "mirapmin": [
        4125
    ],
    "mandaya": [
        5065,
        4142,
        4603,
        5083
    ],
    "maquiri": [
        4161
    ],
    "mintamani": [
        4172
    ],
    "magar kaike": [
        4176
    ],
    "mbum": [
        4654,
        5820,
        4177
    ],
    "mbum bakal": [
        4177
    ],
    "mbum-east": [
        4177
    ],
    "margosatubig": [
        4186
    ],
    "manchad": [
        4192,
        4193
    ],
    "manchati": [
        4192,
        4193,
        4840
    ],
    "man la qua": [
        4208
    ],
    "moselle franconian": [
        4217
    ],
    "moselle": [
        4217
    ],
    "mia": [
        4235
    ],
    "mba rumbathama": [
        4240
    ],
    "mba": [
        4710,
        4240
    ],
    "mae hong son lawa": [
        4249
    ],
    "mae": [
        4905,
        4249,
        4922
    ],
    "mountain lawa": [
        4249
    ],
    "munga": [
        4259,
        4860,
        6644
    ],
    "munga lelau": [
        4259
    ],
    "mukuni": [
        4272
    ],
    "mengisa-leti": [
        4279
    ],
    "mengissa": [
        4279
    ],
    "mbuti": [
        4284
    ],
    "mauta": [
        4287
    ],
    "mlahsö": [
        4320
    ],
    "mooso": [
        4322
    ],
    "moso": [
        4322,
        5678
    ],
    "muhso": [
        4322
    ],
    "muhsur": [
        4322
    ],
    "museu": [
        4322
    ],
    "mussar": [
        4322
    ],
    "musser dam": [
        4322
    ],
    "musser": [
        4322
    ],
    "musso": [
        4322
    ],
    "mussuh": [
        4322
    ],
    "mussur": [
        4322
    ],
    "monégasque": [
        4333
    ],
    "munegascu": [
        4333
    ],
    "mabiti": [
        4334
    ],
    "maliko": [
        4334
    ],
    "mal mal": [
        4356
    ],
    "malmal": [
        4356
    ],
    "murri": [
        4356
    ],
    "milikin": [
        4364
    ],
    "millikin": [
        4364
    ],
    "mokaburra": [
        4372
    ],
    "moanus": [
        4378,
        7777
    ],
    "maron": [
        4379
    ],
    "merei": [
        4394
    ],
    "manadja": [
        4395
    ],
    "manidja": [
        4395
    ],
    "minitji": [
        4395
    ],
    "mulakaino": [
        4399
    ],
    "mugali": [
        4400,
        5135
    ],
    "mugali-ring": [
        4400
    ],
    "muga·yakkha": [
        4400
    ],
    "mingar": [
        4402
    ],
    "mulan": [
        4412
    ],
    "miwok, lake": [
        4415
    ],
    "mbalanhu": [
        4424
    ],
    "mbaanhu": [
        4424
    ],
    "mbalantu": [
        4424
    ],
    "mbaluntu": [
        4424
    ],
    "mwa": [
        4432,
        4760,
        4960,
        7312
    ],
    "miwa": [
        8112,
        4441
    ],
    "mondono": [
        4443
    ],
    "mongo-nkundu": [
        4450
    ],
    "malawi lomwe": [
        4453
    ],
    "montang": [
        4465,
        4466
    ],
    "mustangi": [
        4465,
        4466
    ],
    "marachi": [
        4479
    ],
    "marama": [
        4482
    ],
    "malay, larantuka": [
        4486
    ],
    "melayu larantuka": [
        4486
    ],
    "mauritian sign language": [
        4505
    ],
    "mauritian": [
        4505,
        4712
    ],
    "msl": [
        4505,
        4556,
        5076,
        5090,
        5699,
        8548
    ],
    "mizo": [
        4533,
        4534,
        4535
    ],
    "mizo chin": [
        4533,
        4534,
        4535
    ],
    "mizo ṭawng": [
        4533,
        4534,
        4535
    ],
    "makuva": [
        4544
    ],
    "maku'a": [
        4544
    ],
    "makua": [
        4747,
        4544,
        8123,
        8124,
        5431,
        8114
    ],
    "makue": [
        4544
    ],
    "makuwa": [
        4544,
        4747
    ],
    "maku’a": [
        4544
    ],
    "mbi": [
        4553
    ],
    "misu": [
        4553,
        6391
    ],
    "malawian sign language": [
        4556
    ],
    "malawian": [
        4556
    ],
    "malawi sign": [
        4556
    ],
    "malawi sign language": [
        4556
    ],
    "megam": [
        4685,
        4562
    ],
    "mazatec, san jerónimo tecóatl": [
        4571
    ],
    "mazatec": [
        4571,
        4581,
        4590,
        4594,
        5264,
        6051,
        8117,
        8126,
        8127
    ],
    "mazateco de san antonio eloxochitlán": [
        4571
    ],
    "mazateco": [
        4571,
        4581,
        4590,
        4594,
        5264,
        6051,
        8117,
        8126,
        8127
    ],
    "mazateco de san jerónimo tecóatl": [
        4571
    ],
    "mazateco del oeste": [
        4571
    ],
    "mixtec, yutanduchi": [
        4572
    ],
    "mixteco de yutanduchi": [
        4572
    ],
    "mixteco de yutanduchi de guerrero": [
        4572
    ],
    "madura": [
        4573
    ],
    "mathura": [
        4573
    ],
    "madhura": [
        4573
    ],
    "madurese": [
        4573
    ],
    "mabo-barkul": [
        4574
    ],
    "mabo-barukul": [
        4574
    ],
    "mafa": [
        4575
    ],
    "mofa": [
        4575
    ],
    "magahi": [
        4576
    ],
    "magadhi": [
        4576
    ],
    "magaya": [
        4576
    ],
    "maghai": [
        4576
    ],
    "maghaya": [
        4576
    ],
    "maghori": [
        4576
    ],
    "magi": [
        4761,
        4576
    ],
    "magodhi": [
        4576
    ],
    "megahi": [
        4576
    ],
    "maithili": [
        4577,
        4578,
        4579,
        4580
    ],
    "maitili": [
        4577,
        4578,
        4579,
        4580
    ],
    "maitli": [
        4577,
        4578,
        4579,
        4580
    ],
    "methli": [
        4577,
        4578,
        4579,
        4580
    ],
    "mazatec, jalapa de díaz": [
        4581
    ],
    "mazateco de san felipe jalapa de díaz": [
        4581
    ],
    "mazateco del este bajo": [
        4581
    ],
    "makasar": [
        4582,
        4583,
        4584
    ],
    "mangkasara’": [
        4582,
        4583,
        4584
    ],
    "macassar": [
        4582,
        4583,
        4584
    ],
    "macassarese": [
        4582,
        4583,
        4584,
        4725
    ],
    "makassa": [
        4582,
        4583,
        4584
    ],
    "makassaarsche": [
        4582,
        4583,
        4584
    ],
    "makassar": [
        4725,
        4582,
        4583,
        4584
    ],
    "makassarese": [
        4582,
        4583,
        4584,
        4725
    ],
    "mangasara": [
        4582,
        4583,
        4584
    ],
    "mengkasara": [
        4582,
        4583,
        4584
    ],
    "mandingo": [
        4586,
        4587,
        4588,
        4589,
        5265
    ],
    "mandi'nka kango": [
        4586,
        4587
    ],
    "mandinka": [
        4586,
        4587
    ],
    "manding": [
        4586,
        4587,
        4588,
        4589
    ],
    "mandinga": [
        4586,
        4587
    ],
    "mandingue": [
        4586,
        4587
    ],
    "mandinque": [
        4586,
        4587
    ],
    "mandi’nka kango": [
        4586,
        4587
    ],
    "mandi’nka": [
        4586,
        4587
    ],
    "mandé": [
        4586,
        4587
    ],
    "madingo": [
        4587,
        4588,
        4589
    ],
    "maninga": [
        4587,
        4588,
        4589,
        4890,
        4891
    ],
    "maninka-mori": [
        4587,
        4588,
        4589
    ],
    "maninkakan": [
        4890,
        4891,
        5183,
        4587,
        4588,
        4589
    ],
    "maninkakan, eastern": [
        4587,
        4588,
        4589
    ],
    "maninkaxan": [
        4587,
        4588,
        4589,
        4890,
        4891
    ],
    "mazatec, chiquihuitlán": [
        4590
    ],
    "mazateco de san juan chiquihuitlán": [
        4590
    ],
    "mazateco del sur": [
        4590
    ],
    "maasai": [
        4591,
        4592
    ],
    "masai": [
        4591,
        4592
    ],
    "massai": [
        4591,
        4592
    ],
    "matlatzinca, san francisco": [
        4593
    ],
    "matlatzinca": [
        4593,
        5839
    ],
    "matlatzinca de san francisco de los ranchos": [
        4593
    ],
    "mazatec, huautla": [
        4594
    ],
    "mazateco de huautla de jimenez": [
        4594
    ],
    "mazateco de la sierra": [
        4594
    ],
    "mazateco del centro": [
        4594
    ],
    "mawe": [
        4595,
        4702
    ],
    "mabue": [
        4595
    ],
    "maragua": [
        4595
    ],
    "maué": [
        4595
    ],
    "mawé": [
        4595
    ],
    "mampruli": [
        4596,
        4597
    ],
    "mampelle": [
        4596,
        4597
    ],
    "mamprule": [
        4596,
        4597
    ],
    "mamprusi": [
        4596,
        4597
    ],
    "mamprussi": [
        4596,
        4597
    ],
    "manpelle": [
        4596,
        4597
    ],
    "malay, north moluccan": [
        4598
    ],
    "melayu maluku utara": [
        4598
    ],
    "mazahua, central": [
        4599
    ],
    "mazahua": [
        4599,
        4901
    ],
    "masawa": [
        4599
    ],
    "mazahua de oriente": [
        4599
    ],
    "misamis higaonon manobo": [
        4600
    ],
    "misamis": [
        4600
    ],
    "manobo, western bukidnon": [
        4601
    ],
    "menuvù": [
        4601,
        4607
    ],
    "macushi": [
        4602
    ],
    "makusi": [
        4602
    ],
    "macushi maimu": [
        4602
    ],
    "maimu": [
        4602
    ],
    "macusi": [
        4602
    ],
    "macussi": [
        4602
    ],
    "macuxi": [
        4602
    ],
    "makuchi": [
        4602
    ],
    "makushi": [
        4602
    ],
    "makuxi": [
        4602
    ],
    "manobo, dibabawon": [
        4603
    ],
    "molale": [
        4604
    ],
    "molala": [
        4604
    ],
    "molalla": [
        4604
    ],
    "molele": [
        4604
    ],
    "malay, baba": [
        4605
    ],
    "mangseng": [
        4606
    ],
    "mangsing": [
        4606
    ],
    "masegi": [
        4606
    ],
    "maseki": [
        4606
    ],
    "manobo, ilianen": [
        4607
    ],
    "makunadöbö": [
        4608
    ],
    "makú nadëb": [
        4608
    ],
    "makú": [
        4616,
        4608,
        8397,
        8718
    ],
    "macu": [
        8397,
        4608
    ],
    "malol": [
        4609
    ],
    "malolo": [
        4609
    ],
    "malon": [
        4609
    ],
    "maxakalí": [
        4610
    ],
    "macuni": [
        4610
    ],
    "mashakalí": [
        4610
    ],
    "maxacalí": [
        4610
    ],
    "monacó": [
        4610
    ],
    "monaxo": [
        4610
    ],
    "monocho": [
        4610
    ],
    "mbaama": [
        4611,
        4671
    ],
    "mbama": [
        4611,
        5440
    ],
    "mbamba": [
        4611
    ],
    "macaguán": [
        4612
    ],
    "macaguane": [
        4612
    ],
    "macaguane-hitnu": [
        4612
    ],
    "mbo (cameroon)": [
        4613
    ],
    "mboo": [
        4613
    ],
    "malayo": [
        4614
    ],
    "maracasero": [
        4614
    ],
    "marocasero": [
        4614
    ],
    "maisin": [
        4615
    ],
    "maisan": [
        4615
    ],
    "macusa": [
        4616
    ],
    "manobo, sarangani": [
        4617
    ],
    "menobò": [
        4617
    ],
    "manobo, matigsalug": [
        4618
    ],
    "matigsalug": [
        4618
    ],
    "matig-salug manobo": [
        4618
    ],
    "matig-salug": [
        4618
    ],
    "matigsalug manobo": [
        4618
    ],
    "mbula-bwazza": [
        4619
    ],
    "mbula": [
        4933,
        4619
    ],
    "mbulungish": [
        4620
    ],
    "monson": [
        4620
    ],
    "mbulongish": [
        4620
    ],
    "monchon": [
        4620
    ],
    "monshon": [
        4620
    ],
    "maring": [
        4621,
        5597,
        5598,
        5512
    ],
    "mareng": [
        4621
    ],
    "mari (east sepik province)": [
        4622
    ],
    "memoni": [
        4623
    ],
    "mixtec, amoltepec": [
        4624
    ],
    "mixteco de amoltepec": [
        4624
    ],
    "maka": [
        4625,
        4640,
        4703,
        4856,
        8532
    ],
    "mak'á": [
        4625
    ],
    "maca": [
        4625,
        8532
    ],
    "macá": [
        4625
    ],
    "maká": [
        4625
    ],
    "mak’á": [
        4625
    ],
    "matsigenka": [
        4626
    ],
    "machiguenga": [
        4626
    ],
    "matsiganga": [
        4626
    ],
    "matsigenga": [
        4626
    ],
    "matsiguenga": [
        4626
    ],
    "mañaries": [
        4626
    ],
    "mutum": [
        4627
    ],
    "mixtec, itundujia": [
        4629
    ],
    "mixteco de santa cruz itundujia": [
        4629
    ],
    "matses": [
        4630
    ],
    "magirona": [
        4630
    ],
    "majoruna-matsés": [
        4630
    ],
    "majuruna": [
        4630
    ],
    "matse": [
        4630
    ],
    "matses-mayoruna": [
        4630
    ],
    "matsés": [
        4630
    ],
    "maxirona": [
        4630
    ],
    "maxuruna": [
        4630
    ],
    "mayiruna": [
        4630
    ],
    "mayoruna": [
        4630
    ],
    "mayuzuna": [
        4630
    ],
    "mapoyo": [
        4631,
        6048
    ],
    "mapayo": [
        4631
    ],
    "mapoio": [
        4631
    ],
    "mapoye": [
        4631
    ],
    "mopoi": [
        4631
    ],
    "maquiritari": [
        4632
    ],
    "maiongong": [
        4632
    ],
    "makiritare": [
        4632
    ],
    "maquiritai": [
        4632
    ],
    "maquiritare": [
        4632
    ],
    "mayongong": [
        4632
    ],
    "mesem": [
        4633
    ],
    "mese": [
        4633
    ],
    "mvanip": [
        4634
    ],
    "magu": [
        4634
    ],
    "mvanlip": [
        4634
    ],
    "mvano": [
        4634
    ],
    "mvanon": [
        4634
    ],
    "mvanöp": [
        4634
    ],
    "mbunda": [
        4635
    ],
    "mbuunda": [
        4635
    ],
    "mbúùnda": [
        4635
    ],
    "macaguaje": [
        4636
    ],
    "makaguaje": [
        4636
    ],
    "malaccan portuguese creole": [
        4637
    ],
    "malacca creole": [
        4637
    ],
    "malacca": [
        4637
    ],
    "malaccan creole portuguese": [
        4637
    ],
    "malaqueiro": [
        4637
    ],
    "malaquenho": [
        4637
    ],
    "malaquense": [
        4637
    ],
    "malaquês": [
        4637
    ],
    "malayo-portuguese": [
        4637
    ],
    "malaysian portuguese creole": [
        4637
    ],
    "malaysian": [
        8541,
        4637,
        5067,
        5068,
        5070,
        9089
    ],
    "malaca": [
        4637
    ],
    "masana": [
        4638
    ],
    "massa": [
        4638,
        4994
    ],
    "massana": [
        4638
    ],
    "mixe, coatlán": [
        4639
    ],
    "mixe": [
        4639,
        4810,
        5115,
        5220,
        5221,
        5267,
        5403,
        6383
    ],
    "makaa": [
        4640,
        4856
    ],
    "mǝkaá": [
        4640
    ],
    "mekaa": [
        4640
    ],
    "menya": [
        4642,
        8276
    ],
    "menyama": [
        4642
    ],
    "menye": [
        4642
    ],
    "mambai": [
        4643,
        4752
    ],
    "mambay": [
        4643
    ],
    "mamgbay": [
        4643
    ],
    "mamgbei": [
        4643
    ],
    "manbai": [
        4643
    ],
    "mangbai": [
        4643
    ],
    "mangbaï de biparé": [
        4643
    ],
    "mangbaï": [
        4643
    ],
    "mangbei": [
        4643
    ],
    "momboi": [
        4643
    ],
    "mongbay": [
        4643
    ],
    "mà̧mbày": [
        4643
    ],
    "mengisa": [
        4644
    ],
    "mangisa": [
        4644
    ],
    "mengisa-njowe": [
        4644
    ],
    "mengisa-njowi": [
        4644
    ],
    "mambila, cameroon": [
        4645
    ],
    "mambila": [
        4645,
        5266
    ],
    "mambere": [
        4645,
        5266
    ],
    "mambilla": [
        4645,
        5266
    ],
    "minanibai": [
        4646
    ],
    "mawa": [
        4647,
        8271
    ],
    "maaw": [
        4647
    ],
    "mahoua": [
        4647
    ],
    "mahwa": [
        4647
    ],
    "mawa (chad)": [
        4647
    ],
    "mpiemo": [
        4648
    ],
    "mbimou": [
        4648
    ],
    "mbimu": [
        4648
    ],
    "mbyemo": [
        4648
    ],
    "mpo": [
        4648
    ],
    "mpyemo": [
        4648
    ],
    "mawan": [
        4650
    ],
    "mada (nigeria)": [
        4651
    ],
    "madda": [
        4651
    ],
    "morigi": [
        4652
    ],
    "morigi island": [
        4652
    ],
    "male (papua new guinea)": [
        4653
    ],
    "mboum": [
        4654,
        5820
    ],
    "mboumtiba": [
        4654
    ],
    "maba": [
        4655,
        4656,
        5010
    ],
    "mabang": [
        4655,
        4656
    ],
    "maba (chad)": [
        4655,
        4656
    ],
    "mabaa": [
        4655,
        4656
    ],
    "mabak": [
        4655,
        4656
    ],
    "moksha": [
        4657
    ],
    "moksha mordvin": [
        4657
    ],
    "mordvin": [
        4657,
        5250
    ],
    "mokshan": [
        4657
    ],
    "mordoff": [
        4657
    ],
    "mordov": [
        4657
    ],
    "mordvin-moksha": [
        4657
    ],
    "massalat": [
        4658
    ],
    "maguindanaon": [
        4659
    ],
    "magindanao": [
        4659
    ],
    "magindanaon": [
        4659
    ],
    "magindanaw": [
        4659
    ],
    "magindanawn": [
        4659
    ],
    "maguindanao": [
        4659
    ],
    "maguindanaw": [
        4659
    ],
    "mamvu": [
        4660
    ],
    "mangbetu": [
        4661
    ],
    "mambetto": [
        4661
    ],
    "mangbettu": [
        4661
    ],
    "mangbɛtʉ": [
        4661
    ],
    "mangbέtʉ": [
        4661
    ],
    "mangbutu": [
        4662
    ],
    "mangu-ngutu": [
        4662
    ],
    "mombuttu": [
        4662
    ],
    "maltese sign language": [
        4663
    ],
    "maltese": [
        4663,
        5098,
        5099,
        5100
    ],
    "maltija": [
        4663
    ],
    "maltin": [
        4663
    ],
    "mayogo": [
        4664
    ],
    "madyɵgɵ": [
        4664
    ],
    "madyɵgɵ́": [
        4664
    ],
    "maigo": [
        4664
    ],
    "maiko": [
        4664
    ],
    "majugu": [
        4664
    ],
    "mayko": [
        4664
    ],
    "mayugo": [
        4664
    ],
    "màdìmádòkò": [
        4664
    ],
    "mbati": [
        4665,
        5331
    ],
    "mbala": [
        4666
    ],
    "mbole": [
        4667
    ],
    "mandar": [
        4668,
        4669
    ],
    "mandharsche": [
        4668,
        4669
    ],
    "manjar": [
        4668,
        4669
    ],
    "manubara": [
        4670
    ],
    "maria (papua new guinea)": [
        4670
    ],
    "mbere": [
        4671
    ],
    "mbédé": [
        4671
    ],
    "mbété": [
        4671
    ],
    "mboxo": [
        4672
    ],
    "mbuku": [
        4672,
        5011
    ],
    "mixtec, santa lucía monteverde": [
        4673
    ],
    "monteverde": [
        4673
    ],
    "mixteco de santa lucía monteverde": [
        4673
    ],
    "mixteco de yosonotú": [
        4673
    ],
    "mbosi": [
        4674
    ],
    "mbochi": [
        4674
    ],
    "mboshe": [
        4674
    ],
    "mboshi": [
        4674
    ],
    "male (ethiopia)": [
        4677,
        4678
    ],
    "menka": [
        4680,
        6248
    ],
    "mamwoh": [
        4680
    ],
    "marra": [
        4682
    ],
    "maarra": [
        4682
    ],
    "melpa": [
        4683
    ],
    "medlpa": [
        4683
    ],
    "metlpa": [
        4683
    ],
    "mengen": [
        4684
    ],
    "migam": [
        4685
    ],
    "mixtec, southwestern tlaxiaco": [
        4686
    ],
    "mixteco de santiago nuyoo": [
        4686
    ],
    "mixteco del suroeste de tlaxiaco": [
        4686
    ],
    "mixteco del suroeste del distrito de tlaxiaco": [
        4686
    ],
    "midob": [
        4687
    ],
    "meidob": [
        4687
    ],
    "meidob nubian": [
        4687
    ],
    "midobi": [
        4687
    ],
    "meyah": [
        4688,
        5110
    ],
    "meah": [
        4688
    ],
    "meax": [
        4688
    ],
    "mejach": [
        4688
    ],
    "mejah": [
        4688
    ],
    "meyach": [
        4688
    ],
    "mekeo": [
        4689
    ],
    "mekeo-kovio": [
        4689
    ],
    "melanau, central": [
        4690
    ],
    "milanau": [
        4690
    ],
    "milano": [
        4690
    ],
    "mangala": [
        4691
    ],
    "manala": [
        4691
    ],
    "mangalaa": [
        4691
    ],
    "mangarla": [
        4691
    ],
    "minala": [
        4691
    ],
    "mende": [
        4692,
        4693,
        6878
    ],
    "mɛnde": [
        4692,
        4693
    ],
    "mende (sierra leone)": [
        4692,
        4693
    ],
    "mɛnde yia": [
        4692,
        4693
    ],
    "malay, kedah": [
        4694,
        4695
    ],
    "malay, satun": [
        4694
    ],
    "miriwoong": [
        4696,
        6604
    ],
    "merong": [
        4696
    ],
    "miriwun": [
        4696
    ],
    "miriwung": [
        4696
    ],
    "mirung": [
        4696
    ],
    "merey": [
        4697
    ],
    "mere": [
        4697
    ],
    "meri": [
        4771,
        4697
    ],
    "mofu de méri": [
        4697
    ],
    "mofu": [
        4720,
        4697,
        4797
    ],
    "méri": [
        4697
    ],
    "méré": [
        4697
    ],
    "mero": [
        4698,
        6638
    ],
    "meru": [
        4698,
        6638,
        8959
    ],
    "masmaje": [
        4699
    ],
    "masmadje": [
        4699
    ],
    "mesmedje": [
        4699
    ],
    "maan": [
        4702
    ],
    "mah": [
        4771,
        4702
    ],
    "mann": [
        4702
    ],
    "mano": [
        4702
    ],
    "manon": [
        4702
    ],
    "máá": [
        4702
    ],
    "mã́ã́": [
        4702
    ],
    "maaka": [
        4703
    ],
    "maga": [
        4703
    ],
    "magha": [
        4703
    ],
    "mauri": [
        4704,
        4705
    ],
    "menominee": [
        4706
    ],
    "mamaceqtaw": [
        4706
    ],
    "menomini": [
        4706
    ],
    "malay, pattani": [
        4707,
        4708
    ],
    "mbane": [
        4710
    ],
    "mendankwe-nkwen": [
        4711
    ],
    "morisyen": [
        4712
    ],
    "morisien": [
        4712
    ],
    "mauricean": [
        4712
    ],
    "morisyin": [
        4712
    ],
    "maurisyen": [
        4712
    ],
    "mauritian creole": [
        4712
    ],
    "mauritius creole french": [
        4712
    ],
    "maurysen": [
        4712
    ],
    "munkaf": [
        4713
    ],
    "mogofin": [
        4714,
        4715
    ],
    "mikifore": [
        4714,
        4715
    ],
    "mixifore": [
        4714,
        4715
    ],
    "matal": [
        4716
    ],
    "mouktele": [
        4716
    ],
    "muktele": [
        4716
    ],
    "muktile": [
        4716
    ],
    "mandara": [
        7333,
        4717,
        4718
    ],
    "mandara montagnard": [
        4717,
        4718
    ],
    "montagnard": [
        4717,
        4718
    ],
    "mefele": [
        4719
    ],
    "mofu, north": [
        4720
    ],
    "mofu-douvangar": [
        4720
    ],
    "mofu-nord": [
        4720
    ],
    "marghi west": [
        4721
    ],
    "marghi": [
        4722,
        5060,
        4721
    ],
    "marghi south": [
        4722
    ],
    "margi": [
        4722,
        5060
    ],
    "margi ti ntәm": [
        4722
    ],
    "mbembe, cross river": [
        4723
    ],
    "mbembe": [
        4723,
        5812
    ],
    "mbe": [
        4724
    ],
    "mbube": [
        4724
    ],
    "macassarese malay": [
        4725
    ],
    "makassar malay": [
        4725
    ],
    "makassarese malay": [
        4725
    ],
    "moba": [
        4726
    ],
    "muaba": [
        4726
    ],
    "moa": [
        4726
    ],
    "moab": [
        4726
    ],
    "moare": [
        4726
    ],
    "marrithiyel": [
        4727
    ],
    "maridhiel": [
        4727
    ],
    "maridhiyel": [
        4727
    ],
    "maridjiel": [
        4727
    ],
    "marithiel": [
        4727
    ],
    "marithiyel": [
        4727
    ],
    "mexican sign language": [
        4728
    ],
    "mexican": [
        4728
    ],
    "mexicana": [
        4728
    ],
    "manos": [
        4728
    ],
    "mokareng": [
        4729
    ],
    "mokerang": [
        4729
    ],
    "mokoreng": [
        4729
    ],
    "mbwela": [
        4730
    ],
    "mbuela": [
        4730
    ],
    "mbwera": [
        4730
    ],
    "mandjak": [
        4731
    ],
    "majak": [
        4731
    ],
    "mandjaque": [
        4731
    ],
    "mandyak": [
        4731
    ],
    "manjaaku": [
        4731
    ],
    "manjaca": [
        4731
    ],
    "manjack": [
        4731
    ],
    "manjaco": [
        4731
    ],
    "manjacu": [
        4731
    ],
    "manjago": [
        4731
    ],
    "manjak": [
        4731
    ],
    "manjaku": [
        4731
    ],
    "manjanku": [
        4731
    ],
    "manjiak": [
        4731
    ],
    "manjáku": [
        4731
    ],
    "mendyako": [
        4731
    ],
    "mulaha": [
        4732
    ],
    "melo": [
        4733
    ],
    "mayo": [
        4734,
        6418,
        8912,
        6422
    ],
    "mabaan": [
        4735
    ],
    "ma baan": [
        4735
    ],
    "maaban": [
        4735
    ],
    "maban": [
        4735
    ],
    "meban": [
        4735
    ],
    "malagasy fiteny": [
        4736,
        4738
    ],
    "malagasy ôfisialy": [
        4736,
        4738
    ],
    "malagasy, merina": [
        4736,
        4738
    ],
    "merina": [
        4736,
        4738
    ],
    "malgache": [
        4736,
        4738
    ],
    "middle irish (900-1200)": [
        4739
    ],
    "mararit": [
        4740
    ],
    "mararet": [
        4740
    ],
    "merarit": [
        4740
    ],
    "morokodo": [
        4741
    ],
    "moru": [
        4742,
        4743
    ],
    "mango": [
        4744
    ],
    "mbay doba": [
        4744
    ],
    "maklew": [
        4745
    ],
    "makleu": [
        4745
    ],
    "mpumpong": [
        4746
    ],
    "mbombo": [
        4746
    ],
    "mpompo": [
        4746
    ],
    "mpompon": [
        4746
    ],
    "mpongmpong": [
        4746
    ],
    "mpopo": [
        4746
    ],
    "mpumpoo": [
        4746
    ],
    "mpumpoŋ": [
        4746
    ],
    "makhuwa-meetto": [
        4747
    ],
    "macua": [
        4747,
        8123,
        8124
    ],
    "makhua": [
        4747
    ],
    "makoa": [
        4747
    ],
    "maquoua": [
        4747,
        8123,
        8124
    ],
    "medo": [
        4747
    ],
    "meetto": [
        4747
    ],
    "metto": [
        4747
    ],
    "mêto": [
        4747
    ],
    "megili": [
        4748
    ],
    "migili": [
        4748
    ],
    "mijili": [
        4748
    ],
    "mawes": [
        4750
    ],
    "maleu-kilenge": [
        4751
    ],
    "mambae": [
        4752
    ],
    "manbae": [
        4752
    ],
    "mbangi": [
        4753
    ],
    "mbangui": [
        4753
    ],
    "meta’": [
        4754
    ],
    "metaʼ": [
        4754
    ],
    "menemo-mogamo": [
        4754
    ],
    "meta'": [
        4754
    ],
    "metta": [
        4754
    ],
    "mitaa": [
        4754
    ],
    "moghamo-menemo": [
        4754
    ],
    "muta": [
        4754
    ],
    "mɨta’": [
        4754
    ],
    "magar, eastern": [
        4755,
        4756
    ],
    "magari": [
        4755,
        4756,
        5042
    ],
    "magarkura": [
        4755,
        4756
    ],
    "mangar": [
        4755,
        4756,
        5042
    ],
    "mangari": [
        4755,
        4756,
        5042
    ],
    "manggar": [
        4755,
        4756
    ],
    "malila": [
        4757
    ],
    "malilia": [
        4757
    ],
    "mambwe-lungu": [
        4758
    ],
    "mambe-lungu": [
        4758
    ],
    "mambwe-rungu": [
        4758
    ],
    "manda (tanzania)": [
        4759
    ],
    "manda-matumba": [
        4759
    ],
    "mwakai": [
        4760
    ],
    "mailu": [
        4761
    ],
    "matengo": [
        4762
    ],
    "matumbi": [
        4763
    ],
    "matuumbi": [
        4763
    ],
    "mbunga": [
        4764
    ],
    "mbugwe": [
        4765
    ],
    "mbuwe": [
        4765
    ],
    "marshallese": [
        4766
    ],
    "manda (india)": [
        4767
    ],
    "mahongwe": [
        4768
    ],
    "mocho": [
        4769
    ],
    "motocintleco": [
        4769
    ],
    "motozintleco": [
        4769
    ],
    "mbugu": [
        4770
    ],
    "ma’a": [
        4770,
        8277
    ],
    "mbougou": [
        4770
    ],
    "maathi": [
        4770
    ],
    "mah meri": [
        4771
    ],
    "ma’ betisek": [
        4771
    ],
    "ma’": [
        4771
    ],
    "mama": [
        4899,
        4772
    ],
    "mamaa": [
        4772
    ],
    "margu": [
        4773
    ],
    "marrgu": [
        4773
    ],
    "mãꞌdí": [
        4774
    ],
    "ma'di": [
        4774
    ],
    "ma’adi": [
        4774
    ],
    "ma’aditi": [
        4774
    ],
    "ma’di ti": [
        4774
    ],
    "ma’diti": [
        4774
    ],
    "mogholi": [
        4775
    ],
    "moghol": [
        4775
    ],
    "mogol": [
        4775
    ],
    "mogul": [
        4775
    ],
    "mongul": [
        4775
    ],
    "mungaka": [
        4776
    ],
    "munga’ka": [
        4776
    ],
    "mauwake": [
        4777
    ],
    "mawake": [
        4777
    ],
    "makhuwa-moniga": [
        4778
    ],
    "moniga": [
        4778
    ],
    "mócheno": [
        4779
    ],
    "mashi (zambia)": [
        4780
    ],
    "masi": [
        4780
    ],
    "malay, balinese": [
        4781
    ],
    "mandan": [
        4782
    ],
    "mandahuaca": [
        4784
    ],
    "mandauaca": [
        4784
    ],
    "mandauáca": [
        4784
    ],
    "mandawaca": [
        4784
    ],
    "mandawaka": [
        4784
    ],
    "mandawáka": [
        4784
    ],
    "mbukushu": [
        4786
    ],
    "mambukush": [
        4786
    ],
    "mampukush": [
        4786
    ],
    "mbukuhu": [
        4786
    ],
    "mbukushi": [
        4786
    ],
    "malu": [
        4787,
        4894
    ],
    "mulu": [
        4787
    ],
    "ma’anyan": [
        4788
    ],
    "ma'anyan": [
        4788
    ],
    "maanyak dayak": [
        4788
    ],
    "maanyak": [
        4788
    ],
    "ma’anjan": [
        4788
    ],
    "mor": [
        4789,
        4972
    ],
    "mor (mor islands)": [
        4789
    ],
    "maori": [
        4790,
        6472
    ],
    "māori": [
        4790,
        6472
    ],
    "miami": [
        4791
    ],
    "maumee": [
        4791
    ],
    "miami-illinois": [
        4791
    ],
    "myaamia": [
        4791
    ],
    "mixtec, atatlahuca": [
        4792
    ],
    "mixteco de san esteban atatlahuca": [
        4792
    ],
    "mi’kmaq": [
        4793,
        4794
    ],
    "mi'kmaq": [
        4793,
        4794
    ],
    "micmac": [
        4793,
        4794
    ],
    "miigmao": [
        4793,
        4794
    ],
    "mikmak": [
        4793,
        4794
    ],
    "mikmaw": [
        4793,
        4794
    ],
    "mi’gmaq": [
        4793,
        4794
    ],
    "mi’gmaw": [
        4793,
        4794
    ],
    "mi’gmawi’simg": [
        4793,
        4794
    ],
    "mi’kmaw": [
        4793,
        4794
    ],
    "mìgmaq": [
        4793,
        4794
    ],
    "mìkmaq": [
        4793,
        4794
    ],
    "míkmawísimk": [
        4793,
        4794
    ],
    "mandaic": [
        4795,
        5254
    ],
    "mandaayi": [
        4795
    ],
    "mandaean": [
        4795,
        5254
    ],
    "mandini": [
        4795
    ],
    "mandāyì": [
        4795
    ],
    "mandɔyí": [
        4795
    ],
    "modern mandaic": [
        4795
    ],
    "mixtec, ocotepec": [
        4796
    ],
    "mixteco de santo tomás ocotepec": [
        4796
    ],
    "mixteco de sierra sur noroeste": [
        4796
    ],
    "mofu-gudur": [
        4797
    ],
    "mey mafaw": [
        4797
    ],
    "mafaw": [
        4797
    ],
    "mey mafaw gudur": [
        4797
    ],
    "mey aŋgwa": [
        4797
    ],
    "mey ŋga aŋgwa": [
        4797
    ],
    "mofou": [
        4797
    ],
    "mofou de goudour": [
        4797
    ],
    "mofu south": [
        4797
    ],
    "mofu-sud": [
        4797
    ],
    "mixtec, san miguel el grande": [
        4798
    ],
    "mixteco de san pedro molinos": [
        4798
    ],
    "molinos": [
        4798
    ],
    "mixteco del sur bajo": [
        4798
    ],
    "mixtec, chayuco": [
        4799
    ],
    "mixteco de chayucu": [
        4799
    ],
    "mixtec, chigmecatitlán": [
        4800
    ],
    "mixteco de santa maría chigmecatitlán": [
        4800
    ],
    "mungbam": [
        4801
    ],
    "mikasuki": [
        4802
    ],
    "miccosukee": [
        4802
    ],
    "mikasuki seminole": [
        4802
    ],
    "mikisúkî": [
        4802
    ],
    "mixtec, peñoles": [
        4803
    ],
    "mixteco de santa maría peñoles": [
        4803
    ],
    "mixtec, alacatlatzala": [
        4804
    ],
    "misteko": [
        4804
    ],
    "mixteco de alacatlatzala": [
        4804
    ],
    "minangkabau": [
        4805,
        4806,
        9089
    ],
    "minang": [
        8619,
        4805,
        4806
    ],
    "mixtec, pinotepa nacional": [
        4807
    ],
    "mixteco de pinotepa nacional": [
        4807
    ],
    "mixtec, apasco-apoala": [
        4808
    ],
    "mixteco de santiago apoala": [
        4808
    ],
    "marquito": [
        4809
    ],
    "miskuto": [
        4809
    ],
    "mosquito": [
        4809
    ],
    "mískitu": [
        4809
    ],
    "mísquito": [
        4809
    ],
    "mixe, isthmus": [
        4810
    ],
    "mixe del istmo": [
        4810
    ],
    "mixe medio del este": [
        4810
    ],
    "mixtec, southern puebla": [
        4812
    ],
    "mixteco de la frontera puebla-oaxaca": [
        4812,
        8646
    ],
    "mixteco del sur de puebla": [
        4812
    ],
    "mixtec, cacaloxtepec": [
        4813
    ],
    "mixteco de cacaloxtepec": [
        4813
    ],
    "mai-hea-ri": [
        4814
    ],
    "maihiri": [
        4814
    ],
    "mixtec, mixtepec": [
        4815
    ],
    "mixtepec": [
        4815,
        9116,
        9132,
        9163
    ],
    "mixteco de oeste central": [
        4815
    ],
    "mixteco de san juan mixtepec": [
        4815
    ],
    "mixtepec mixtec": [
        4815
    ],
    "mixtec, ayutla": [
        4816
    ],
    "mixteco de ayutla": [
        4816
    ],
    "mixteco de ayutla de los libres": [
        4816
    ],
    "mixtec, coatzospan": [
        4817
    ],
    "mixteco de coatzóspan": [
        4817
    ],
    "mixteco de san juan coatzospan": [
        4817
    ],
    "makalero": [
        4818
    ],
    "maklere": [
        4818
    ],
    "mixtec, san juan colorado": [
        4819
    ],
    "mixteco de oaxaca de la costa noroeste": [
        4819
    ],
    "mixteco de san juan colorado": [
        4819
    ],
    "maidu, northwest": [
        4820
    ],
    "maidu": [
        4820,
        5584,
        8122,
        5709
    ],
    "maiduan": [
        4820
    ],
    "mechoopda": [
        4820
    ],
    "meidoo": [
        4820
    ],
    "michopdo": [
        4820
    ],
    "muskum": [
        4821
    ],
    "muzgum": [
        4821
    ],
    "mongor": [
        4822
    ],
    "mongour": [
        4822
    ],
    "monguor": [
        4822
    ],
    "mongghul": [
        4822
    ],
    "mwera": [
        4823,
        5178
    ],
    "mwera (nyasa)": [
        4823
    ],
    "man lan-tien": [
        4824
    ],
    "man lantien": [
        4824
    ],
    "men": [
        4824,
        7865,
        7866
    ],
    "mawak": [
        4825
    ],
    "matukar panau": [
        4826
    ],
    "matukar": [
        4826
    ],
    "matugar": [
        4826
    ],
    "mandeali": [
        4827,
        4828
    ],
    "mandiali": [
        4827,
        4828
    ],
    "mandyali": [
        4827,
        4828
    ],
    "mandiyali": [
        4827,
        4828
    ],
    "medebur": [
        4829
    ],
    "ma (papua new guinea)": [
        4830
    ],
    "mawam": [
        4830
    ],
    "mebu": [
        4830
    ],
    "malankuravan": [
        4831
    ],
    "mala koravan": [
        4831
    ],
    "malaikuravan": [
        4831
    ],
    "malakkuravan": [
        4831
    ],
    "male kuravan": [
        4831
    ],
    "malapandaram": [
        4832
    ],
    "malapantaram": [
        4832
    ],
    "malepantaram": [
        4832
    ],
    "malaryan": [
        4833
    ],
    "malai arayan": [
        4833
    ],
    "malayarayan": [
        4833
    ],
    "malayarayar": [
        4833
    ],
    "male arayans": [
        4833
    ],
    "maley arayan": [
        4833
    ],
    "maley": [
        4833
    ],
    "malavedan": [
        4834
    ],
    "malai vedan": [
        4834
    ],
    "malavetan": [
        4834
    ],
    "miship": [
        4835
    ],
    "malatri": [
        4836,
        4837
    ],
    "manna-dora": [
        4838
    ],
    "mannan": [
        4839
    ],
    "mannan pasha": [
        4839
    ],
    "manne": [
        4839
    ],
    "mannyod": [
        4839
    ],
    "mahali": [
        4841,
        4842
    ],
    "mahili": [
        4841
    ],
    "mahle": [
        4841,
        4842
    ],
    "mahli": [
        4841
    ],
    "mahican": [
        4843,
        4979
    ],
    "majhi": [
        4844
    ],
    "manjhi": [
        4844,
        4910
    ],
    "macedonian": [
        4845,
        4846,
        8540,
        8906
    ],
    "macedoneana": [
        4845
    ],
    "macedonian slavic": [
        4845,
        4846
    ],
    "mk": [
        4845,
        4846,
        7072
    ],
    "macedonia": [
        4845,
        4846,
        7072
    ],
    "mbre": [
        4847
    ],
    "mal paharia": [
        4848
    ],
    "mader": [
        4848
    ],
    "mal pahariya": [
        4848
    ],
    "malpaharia": [
        4848
    ],
    "manlati": [
        4848
    ],
    "marpaharia": [
        4848
    ],
    "maw": [
        4848,
        9061
    ],
    "mawdo": [
        4848
    ],
    "mawer": [
        4848
    ],
    "mawer nondi": [
        4848
    ],
    "maimai": [
        4849
    ],
    "mawchi": [
        4850
    ],
    "mauchi": [
        4850
    ],
    "mavchi": [
        4850
    ],
    "mawachi": [
        4850
    ],
    "mawchi bhil": [
        4850
    ],
    "mowchi": [
        4850
    ],
    "miya": [
        4851
    ],
    "miyanci": [
        4851
    ],
    "miyawa": [
        4851
    ],
    "mίy": [
        4851
    ],
    "mak": [
        4852,
        6050
    ],
    "mak (china)": [
        4852
    ],
    "mo-hua": [
        4852
    ],
    "mochiahua": [
        4852
    ],
    "mohua": [
        4852
    ],
    "mojiahua": [
        4852
    ],
    "mokilese": [
        4855
    ],
    "mokil": [
        4855
    ],
    "mwoakilese": [
        4855
    ],
    "mwoakilloa": [
        4855
    ],
    "makya": [
        4856
    ],
    "meka": [
        4856,
        6536
    ],
    "mekae": [
        4856
    ],
    "mekay": [
        4856
    ],
    "mekey": [
        4856
    ],
    "mekye": [
        4856
    ],
    "mika": [
        4856
    ],
    "moka": [
        4856
    ],
    "mokole": [
        4857
    ],
    "mokollé": [
        4857
    ],
    "mokolé": [
        4857
    ],
    "mokwale": [
        4857
    ],
    "monkole": [
        4857
    ],
    "mɔ̄kɔ́lé": [
        4857
    ],
    "moklen": [
        4858
    ],
    "malay, kupang": [
        4859
    ],
    "mingang doso": [
        4860
    ],
    "mingang": [
        4860
    ],
    "munga doso": [
        4860
    ],
    "mungàn": [
        4860
    ],
    "moikodi": [
        4861
    ],
    "malas": [
        4863
    ],
    "mixtec, silacayoapan": [
        4864
    ],
    "maninka, konyanka": [
        4866
    ],
    "maninya": [
        4866,
        5265
    ],
    "mafea": [
        4867
    ],
    "mavea": [
        4867
    ],
    "monokutuba": [
        4868
    ],
    "munukutuba": [
        4868
    ],
    "manobo, kinamiging": [
        4869
    ],
    "makian, east": [
        4870
    ],
    "makian": [
        4870,
        5027
    ],
    "makian dalam": [
        4870
    ],
    "makian timur": [
        4870
    ],
    "makasae": [
        4871
    ],
    "macassai": [
        4871
    ],
    "makasai": [
        4871
    ],
    "makassai": [
        4871
    ],
    "maksae": [
        4871
    ],
    "ma’asae": [
        4871
    ],
    "malayalam": [
        4872,
        4873,
        4874
    ],
    "malayal": [
        4872,
        4873,
        4874
    ],
    "malayalani": [
        4872,
        4873,
        4874
    ],
    "malayali": [
        4872,
        4873,
        4874
    ],
    "malean": [
        4872,
        4873,
        4874
    ],
    "maliyad": [
        4872,
        4873,
        4874
    ],
    "mallealle": [
        4872,
        4873,
        4874
    ],
    "mopla": [
        4872,
        4873,
        4874
    ],
    "mbule": [
        4876
    ],
    "mbola": [
        4876
    ],
    "mbure": [
        4876
    ],
    "manambu": [
        4878
    ],
    "madl": [
        4879,
        4880
    ],
    "mape": [
        4881
    ],
    "malimpung": [
        4882
    ],
    "miltu": [
        4883
    ],
    "miltou": [
        4883
    ],
    "malua bay": [
        4885
    ],
    "malua": [
        4885
    ],
    "middle nambas": [
        4885
    ],
    "mulam": [
        4886
    ],
    "molao": [
        4886
    ],
    "mulao miao": [
        4886
    ],
    "muliao": [
        4886
    ],
    "mulou": [
        4886
    ],
    "malango": [
        4887
    ],
    "mlomp": [
        4888
    ],
    "mlomp north": [
        4888
    ],
    "mugil": [
        4889
    ],
    "maninkakan, western": [
        4890,
        4891
    ],
    "malinka": [
        4890,
        4891
    ],
    "maninka-western": [
        4890,
        4891
    ],
    "maslava": [
        4892
    ],
    "masalit": [
        4893
    ],
    "masala": [
        4893
    ],
    "masaraka": [
        4893
    ],
    "masale": [
        4893
    ],
    "masara": [
        4893
    ],
    "massalit": [
        4893
    ],
    "massolit": [
        4893
    ],
    "mesalit": [
        4893
    ],
    "malu’u": [
        4894
    ],
    "mwotlap": [
        4895
    ],
    "motalava": [
        4895
    ],
    "motlav": [
        4895
    ],
    "moloko": [
        4896
    ],
    "ma mǝloko": [
        4896
    ],
    "mǝloko": [
        4896
    ],
    "melokwo": [
        4896
    ],
    "mokyo": [
        4896
    ],
    "molko": [
        4896
    ],
    "molkoa": [
        4896
    ],
    "molkwo": [
        4896
    ],
    "molokwo": [
        4896
    ],
    "mǝlokwo": [
        4896
    ],
    "malfaxal": [
        4897
    ],
    "malvaxal-toman island": [
        4897
    ],
    "malvaxal-toman": [
        4897
    ],
    "malaynon": [
        4898
    ],
    "momina": [
        4900
    ],
    "mazahua, michoacán": [
        4901
    ],
    "michoacán": [
        4901,
        5345
    ],
    "mazahua de occidente": [
        4901
    ],
    "michoacán mazahua": [
        4901
    ],
    "maonan": [
        4902,
        4903,
        4904
    ],
    "mundat": [
        4906
    ],
    "mehináku": [
        4908
    ],
    "mahinaku": [
        4908
    ],
    "mehinaco": [
        4908
    ],
    "mehinako": [
        4908
    ],
    "meinaku": [
        4908
    ],
    "minaco": [
        4908
    ],
    "musar": [
        4909
    ],
    "majhwar": [
        4910
    ],
    "majhvar": [
        4910
    ],
    "manjhia": [
        4910
    ],
    "mukha-dora": [
        4911
    ],
    "mukha dhora": [
        4911
    ],
    "mukha": [
        4911
    ],
    "man met": [
        4912
    ],
    "met": [
        4912
    ],
    "manmi": [
        4912
    ],
    "manmit": [
        4912
    ],
    "maii": [
        4913
    ],
    "mae-morae": [
        4913
    ],
    "mafilau": [
        4913
    ],
    "mkir": [
        4913
    ],
    "minamanwa": [
        4914
    ],
    "mamanwa": [
        4914
    ],
    "mamanwa negrito": [
        4914
    ],
    "mangga": [
        4915
    ],
    "manga buang": [
        4915
    ],
    "mangga buang": [
        4915
    ],
    "musa": [
        4916,
        8893
    ],
    "musan": [
        4916
    ],
    "musian": [
        4916
    ],
    "musak": [
        4917
    ],
    "miao, western xiangxi": [
        4918
    ],
    "meo do": [
        4918,
        5139,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "malalamai": [
        4919
    ],
    "mmaala": [
        4920
    ],
    "mmala": [
        4920
    ],
    "miriti": [
        4921
    ],
    "miriti tapuyo": [
        4921
    ],
    "miriti-tapuia": [
        4921
    ],
    "mirity-tapuya": [
        4921
    ],
    "mwae": [
        4922
    ],
    "madak": [
        4923
    ],
    "mandak": [
        4923
    ],
    "migaama": [
        4924
    ],
    "migama": [
        4924
    ],
    "mabaale": [
        4925
    ],
    "mabale": [
        4925
    ],
    "mbali": [
        4925,
        7957
    ],
    "mongolian, halh": [
        4929,
        4931,
        4926,
        4927,
        4932
    ],
    "mangaaba": [
        4933
    ],
    "mangaava": [
        4933
    ],
    "mangaawa": [
        4933
    ],
    "mangap": [
        4933
    ],
    "mangap-mbula": [
        4933
    ],
    "muna": [
        4934
    ],
    "manchu": [
        4935,
        4936,
        4937
    ],
    "manju gisun": [
        4935,
        4936,
        4937
    ],
    "manju": [
        4935,
        4936,
        4937
    ],
    "mondé": [
        4938,
        7328
    ],
    "mundani": [
        4940
    ],
    "mundàni": [
        4940
    ],
    "mnong, eastern": [
        4941
    ],
    "mono": [
        4942,
        4952,
        5061,
        5105,
        8388
    ],
    "mono (democratic republic of congo)": [
        4942
    ],
    "meitei": [
        4943,
        4944,
        4945
    ],
    "meetei": [
        4943,
        4944,
        4945
    ],
    "meeteilon": [
        4943,
        4944,
        4945
    ],
    "meitei manipuri": [
        4943,
        4944,
        4945
    ],
    "meiteilon": [
        4943,
        4944,
        4945
    ],
    "meiteiron": [
        4943,
        4944,
        4945
    ],
    "meithe": [
        4943,
        4944,
        4945
    ],
    "meithei": [
        4943,
        4944,
        4945
    ],
    "menipuri": [
        4943,
        4944,
        4945
    ],
    "mitei": [
        4943,
        4944,
        4945
    ],
    "mithe": [
        4943,
        4944,
        4945
    ],
    "munji": [
        4946
    ],
    "munjani": [
        4946
    ],
    "munjigi": [
        4946
    ],
    "munjiwar": [
        4946
    ],
    "malmariv": [
        4947
    ],
    "mapena": [
        4948
    ],
    "mnong, southern": [
        4949
    ],
    "min bei chinese": [
        4950
    ],
    "min pei": [
        4950
    ],
    "minriq": [
        4951
    ],
    "mendriq": [
        4951
    ],
    "menraq": [
        4951
    ],
    "menrik": [
        4951
    ],
    "menriq": [
        4951
    ],
    "monache": [
        4952
    ],
    "monachi": [
        4952
    ],
    "mono (usa)": [
        4952
    ],
    "mansi": [
        4953
    ],
    "mansiy": [
        4953
    ],
    "mer": [
        4954,
        7950
    ],
    "miere": [
        4954
    ],
    "mugaba": [
        4955
    ],
    "mugiki": [
        4955
    ],
    "mantion": [
        4957
    ],
    "manyawa": [
        4958
    ],
    "megani": [
        4959
    ],
    "migani": [
        4959
    ],
    "mwan": [
        4960
    ],
    "mona": [
        4960
    ],
    "mouna": [
        4960
    ],
    "muan": [
        4960
    ],
    "muana": [
        4960
    ],
    "mocoví": [
        4961
    ],
    "mbocobí": [
        4961
    ],
    "mocobí": [
        4961
    ],
    "mokovi": [
        4961
    ],
    "mobilian": [
        4962
    ],
    "montagnais": [
        4963
    ],
    "montagnais innu": [
        4963
    ],
    "mongondow": [
        4964
    ],
    "minahassa": [
        4964
    ],
    "mongondou": [
        4964
    ],
    "mohawk": [
        4965
    ],
    "mboi": [
        4966
    ],
    "mboire": [
        4966
    ],
    "mboyi": [
        4966
    ],
    "monzombo": [
        4967
    ],
    "mondjembo": [
        4967
    ],
    "monjombo": [
        4967
    ],
    "mono-jembo": [
        4967
    ],
    "monzumbo": [
        4967
    ],
    "munzombo": [
        4967
    ],
    "morori": [
        4968
    ],
    "marori": [
        4968
    ],
    "moaraeri": [
        4968
    ],
    "moraori": [
        4968
    ],
    "morari": [
        4968
    ],
    "mangue": [
        4969
    ],
    "monimbo": [
        4969
    ],
    "monom": [
        4970
    ],
    "menam": [
        4970
    ],
    "monam": [
        4970
    ],
    "maya, mopán": [
        4971
    ],
    "mopán": [
        4971
    ],
    "maya mopán": [
        4971
    ],
    "mopan": [
        4971
    ],
    "mopane": [
        4971
    ],
    "mopán maya": [
        4971
    ],
    "mor (bomberai peninsula)": [
        4972
    ],
    "mòoré": [
        4974,
        4975
    ],
    "mole": [
        4974,
        4975
    ],
    "more": [
        4974,
        4975,
        9107
    ],
    "moshi": [
        4974,
        4975,
        5892
    ],
    "mossi": [
        4974,
        4975
    ],
    "motilone": [
        4976,
        8935
    ],
    "motilón": [
        4976,
        6426,
        8935
    ],
    "mogum": [
        4977
    ],
    "mogoum": [
        4977
    ],
    "mogume": [
        4977
    ],
    "mohave": [
        4978
    ],
    "macav chukwar": [
        4978
    ],
    "macav": [
        4978
    ],
    "mojave": [
        4978
    ],
    "moi (congo)": [
        4979
    ],
    "molima": [
        4980
    ],
    "morima": [
        4980
    ],
    "mukulu": [
        4983
    ],
    "mokoulou": [
        4983
    ],
    "mokulu": [
        4983
    ],
    "mpoto": [
        4984
    ],
    "malak malak": [
        4985
    ],
    "malak": [
        4985
    ],
    "malagmalag": [
        4985
    ],
    "malak-malak": [
        4985
    ],
    "malakmalak": [
        4985
    ],
    "mullikmullik": [
        4985
    ],
    "mulluk-mulluk": [
        4985
    ],
    "mullukmulluk": [
        4985
    ],
    "mangarrayi": [
        4986
    ],
    "mangarai": [
        4986
    ],
    "mangarayi": [
        4986
    ],
    "manggarai": [
        5034,
        4986,
        6528
    ],
    "mungarai": [
        4986
    ],
    "mungerry": [
        4986
    ],
    "machinere": [
        4987
    ],
    "machineri": [
        4987
    ],
    "manchinere": [
        4987
    ],
    "manchineri": [
        4987
    ],
    "manitenerí": [
        4987
    ],
    "manitenére": [
        4987
    ],
    "manxinéri": [
        4987
    ],
    "maxinéri": [
        4987
    ],
    "majang": [
        4988,
        4989
    ],
    "marba": [
        4990,
        5169
    ],
    "maung": [
        4991,
        9111
    ],
    "mawng": [
        4991
    ],
    "mawung": [
        4991
    ],
    "mpade": [
        4992
    ],
    "makari": [
        4992
    ],
    "makary": [
        4992
    ],
    "makary kotoko": [
        4992
    ],
    "martu wangka": [
        4993
    ],
    "martu": [
        4993
    ],
    "mardo": [
        4993
    ],
    "mardujara": [
        4993
    ],
    "martuwangka": [
        4993
    ],
    "mbara": [
        4994,
        5161,
        8105,
        8684
    ],
    "massa de guelengdeng": [
        4994
    ],
    "mbara (chad)": [
        4994
    ],
    "maraliinan": [
        4995
    ],
    "maralinan": [
        4995
    ],
    "middle watut": [
        4995
    ],
    "mixtec, yosondúa": [
        4996
    ],
    "mixteco de santiago yosondúa": [
        4996
    ],
    "mindiri": [
        4997
    ],
    "miu": [
        4998
    ],
    "myu": [
        4998
    ],
    "migabac": [
        4999
    ],
    "migaba’": [
        4999
    ],
    "matís": [
        5000
    ],
    "mian weng": [
        5003
    ],
    "mianmin": [
        5003,
        7191
    ],
    "makuráp": [
        5004
    ],
    "macurapi": [
        5004
    ],
    "macuráp": [
        5004
    ],
    "makurápi": [
        5004
    ],
    "massaka": [
        5004
    ],
    "mungkip": [
        5005
    ],
    "munkip": [
        5005
    ],
    "mapidian": [
        5006
    ],
    "mahuayana": [
        5006,
        5279
    ],
    "maiopitian": [
        5006
    ],
    "maopidian": [
        5006
    ],
    "maopityan": [
        5006
    ],
    "mapidi": [
        5006
    ],
    "mapidiana": [
        5006
    ],
    "mawayana": [
        5279,
        5006
    ],
    "misima-panaeati": [
        5007
    ],
    "misima": [
        5007
    ],
    "misima-paneati": [
        5007
    ],
    "misiman": [
        5007
    ],
    "mapia": [
        5008
    ],
    "mapian": [
        5008
    ],
    "mpi": [
        5009
    ],
    "maba (indonesia)": [
        5010
    ],
    "mbuko": [
        5011
    ],
    "mbokou": [
        5011
    ],
    "mboku": [
        5011
    ],
    "mangole": [
        5012
    ],
    "mangoli": [
        5012
    ],
    "matepi": [
        5013
    ],
    "momuna": [
        5014
    ],
    "malay, kota bangun kutai": [
        5015
    ],
    "mixtec, tlazoyaltepec": [
        5016
    ],
    "mixteco bajo de valles": [
        5016
    ],
    "mixteco de santiago tlazoyaltepec": [
        5016
    ],
    "mariri": [
        5017
    ],
    "mairiri": [
        5017
    ],
    "mamasa": [
        5018
    ],
    "mamasa toraja": [
        5018
    ],
    "manobo, rajah kabunsuwan": [
        5019
    ],
    "mbelime": [
        5020
    ],
    "mbilme": [
        5020
    ],
    "mbèlimè": [
        5020
    ],
    "marquesan, south": [
        5021
    ],
    "marquesan": [
        5021,
        5057
    ],
    "moronene": [
        5022
    ],
    "maronene": [
        5022
    ],
    "modole": [
        5023
    ],
    "madole": [
        5023
    ],
    "manipa": [
        5024
    ],
    "minokok": [
        5025
    ],
    "mander": [
        5026
    ],
    "makian, west": [
        5027
    ],
    "makian barat": [
        5027
    ],
    "makian luar": [
        5027
    ],
    "mok": [
        5028
    ],
    "mŏk": [
        5028
    ],
    "muak": [
        7936,
        5028
    ],
    "mondari": [
        5029,
        7976,
        7977,
        7978,
        7979
    ],
    "mundari": [
        7976,
        7977,
        7978,
        7979,
        5029
    ],
    "mosimo": [
        5030
    ],
    "murupi": [
        5031
    ],
    "mamuju": [
        5032,
        5033
    ],
    "mamoedjoe": [
        5032,
        5033
    ],
    "mamoedjoesch": [
        5032,
        5033
    ],
    "mamudju": [
        5032,
        5033
    ],
    "malasanga": [
        5035
    ],
    "marathi": [
        5036,
        5037,
        5038,
        5914,
        8049
    ],
    "maharathi": [
        5036,
        5037,
        5038
    ],
    "malhatee": [
        5036,
        5037,
        5038
    ],
    "marthi": [
        5036,
        5037,
        5038
    ],
    "muruthu": [
        5036,
        5037,
        5038
    ],
    "mlabri": [
        5039
    ],
    "ma ku": [
        5039
    ],
    "mabri": [
        5039
    ],
    "mla": [
        5039
    ],
    "mla-bri": [
        5039
    ],
    "mrabri": [
        5039
    ],
    "maewo": [
        5187,
        5040
    ],
    "maricopa": [
        5041
    ],
    "magar, western": [
        5042
    ],
    "martha's vineyard sign language": [
        5043
    ],
    "marthas": [
        5043
    ],
    "mising": [
        5045,
        5046,
        5047
    ],
    "miching": [
        5045,
        5046,
        5047
    ],
    "mishing": [
        5045,
        5046,
        5047
    ],
    "missing": [
        5045,
        5046,
        5047
    ],
    "mara chin": [
        5048
    ],
    "mara reih": [
        5048
    ],
    "maram": [
        5561,
        5048
    ],
    "mira": [
        5048,
        6823
    ],
    "miram": [
        5048
    ],
    "mari, hill": [
        5049
    ],
    "mari-hills": [
        5049
    ],
    "mortlockese": [
        5051
    ],
    "mortlock": [
        5051,
        5457
    ],
    "mwerlap": [
        5052
    ],
    "merelava": [
        5052
    ],
    "merlav": [
        5052
    ],
    "merlav-merig": [
        5052
    ],
    "mru": [
        5054,
        5055
    ],
    "maru": [
        5054,
        5055
    ],
    "mrucha": [
        5054,
        5055
    ],
    "mrung": [
        5054,
        5055,
        7714,
        7715
    ],
    "mrusa": [
        5054,
        5055
    ],
    "murung": [
        5054,
        5055
    ],
    "morouas": [
        5056
    ],
    "moruas": [
        5056
    ],
    "marquesan, north": [
        5057
    ],
    "madia": [
        5058
    ],
    "maria (india)": [
        5058
    ],
    "modh": [
        5058
    ],
    "modi": [
        5058
    ],
    "maragus": [
        5059
    ],
    "maragaus": [
        5059
    ],
    "marakus": [
        5059
    ],
    "marghi central": [
        5060
    ],
    "mon-non": [
        5061
    ],
    "mono (cameroon)": [
        5061
    ],
    "mangareva": [
        5062
    ],
    "mangarevan": [
        5062
    ],
    "magareva": [
        5062
    ],
    "maranaw": [
        5063
    ],
    "mëranaw": [
        5063
    ],
    "maremgi": [
        5064
    ],
    "marengge": [
        5064
    ],
    "malay (macrolanguage)": [
        5067,
        5068,
        5069,
        5071,
        5072,
        5073,
        5070
    ],
    "malay, standard": [
        5070,
        5067,
        5068
    ],
    "malaysian malay": [
        5067,
        5068,
        5070
    ],
    "melayu baku": [
        5067,
        5068,
        5070
    ],
    "masbatenyo": [
        5074
    ],
    "masbateño": [
        5074
    ],
    "minasbate": [
        5074
    ],
    "maninka, sankaran": [
        5075
    ],
    "maya sign language": [
        5076
    ],
    "mayan sign language": [
        5076
    ],
    "musey": [
        5077
    ],
    "mosi": [
        5077,
        5892
    ],
    "moussei": [
        5077
    ],
    "moussey": [
        5077
    ],
    "musaya": [
        5077
    ],
    "musei": [
        5077
    ],
    "museyna": [
        5077
    ],
    "musiina": [
        5077
    ],
    "musoi": [
        5077
    ],
    "mussoi": [
        5077
    ],
    "mussoy": [
        5077
    ],
    "mekwei": [
        5078,
        5218
    ],
    "menggei": [
        5078
    ],
    "menggwei": [
        5078
    ],
    "mooi": [
        5078,
        5218
    ],
    "munggai": [
        5078
    ],
    "mungge": [
        5078
    ],
    "munkei": [
        5078
    ],
    "moraid": [
        5079
    ],
    "malagasy, masikoro": [
        5080
    ],
    "masikoro": [
        5080
    ],
    "masikoro malagasy": [
        5080
    ],
    "malay, sabah": [
        5081
    ],
    "ma (democratic republic of congo)": [
        5082
    ],
    "madyo": [
        5082
    ],
    "mansaka": [
        5083
    ],
    "minansaka": [
        5083
    ],
    "mandaya mansaka": [
        5083
    ],
    "molof": [
        5084
    ],
    "manobo, agusan": [
        5085
    ],
    "minanubu": [
        5085
    ],
    "mombum": [
        5087
    ],
    "maritsauá": [
        5088
    ],
    "manitsauá": [
        5088
    ],
    "manitsawa": [
        5088
    ],
    "manitsawá": [
        5088
    ],
    "mantizula": [
        5088
    ],
    "moenebeng": [
        5089
    ],
    "mwelebeng": [
        5089
    ],
    "mongolian sign language": [
        5090
    ],
    "masela, west": [
        5091
    ],
    "masela": [
        5091,
        5230,
        8108
    ],
    "marsela": [
        5091,
        5230,
        8108
    ],
    "musom": [
        5092
    ],
    "misatik": [
        5092
    ],
    "maslam": [
        5093
    ],
    "maltam": [
        5093
    ],
    "mansoanka": [
        5094
    ],
    "mansoanca": [
        5094
    ],
    "maswanka": [
        5094
    ],
    "moresada": [
        5095
    ],
    "murisapa": [
        5095
    ],
    "murusapa-sarewa": [
        5095
    ],
    "makarub": [
        5096
    ],
    "makarup": [
        5096
    ],
    "mikarew": [
        5096
    ],
    "mikarew-ariaw": [
        5096
    ],
    "mikarup": [
        5096
    ],
    "momare": [
        5097
    ],
    "momale": [
        5097
    ],
    "momole": [
        5097
    ],
    "mumare": [
        5097
    ],
    "manobo, cotabato": [
        5101
    ],
    "menubù": [
        5101
    ],
    "morofo": [
        5102
    ],
    "munit": [
        5103
    ],
    "mualang": [
        5104
    ],
    "mono (solomon islands)": [
        5105
    ],
    "mono-alu": [
        5105
    ],
    "murik": [
        5106,
        5222
    ],
    "murik (papua new guinea)": [
        5106
    ],
    "mount goliath": [
        5107
    ],
    "munggui": [
        5108
    ],
    "maiwa": [
        5109,
        8279
    ],
    "maiwa (papua new guinea)": [
        5109
    ],
    "moskona": [
        5110
    ],
    "meninggo": [
        5110
    ],
    "meningo": [
        5110
    ],
    "mbo’": [
        5111
    ],
    "mbe'": [
        5111
    ],
    "montol": [
        5112
    ],
    "montal": [
        5112
    ],
    "mator": [
        5113
    ],
    "matagalpa": [
        5114
    ],
    "mixe, totontepec": [
        5115
    ],
    "mixe alto del norte": [
        5115
    ],
    "muong": [
        5117,
        7654,
        7672,
        7865,
        7866
    ],
    "mewari": [
        5118
    ],
    "mewadi": [
        5118
    ],
    "manu park panoan": [
        5119
    ],
    "mota": [
        5120
    ],
    "mixtec, tututepec": [
        5121
    ],
    "mixteco de san pedro tututepec": [
        5121
    ],
    "mixteco de villa de tututepec": [
        5121
    ],
    "morafa": [
        5122
    ],
    "mixtec, tidaá": [
        5124
    ],
    "mixteco de san pedro tidaá": [
        5124
    ],
    "mixteco de tidaá": [
        5124
    ],
    "metan": [
        5125
    ],
    "mitang": [
        5125
    ],
    "mundang": [
        5126
    ],
    "mundaŋ": [
        5126
    ],
    "marhay": [
        5126
    ],
    "moundang": [
        5126
    ],
    "musemban": [
        5126
    ],
    "múndàŋ": [
        5126
    ],
    "moubi": [
        5127
    ],
    "mbuh": [
        5128
    ],
    "mbu’": [
        5128
    ],
    "mednyj": [
        5129
    ],
    "medny": [
        5129
    ],
    "mednyj aleut": [
        5129
    ],
    "media lengua": [
        5130
    ],
    "media": [
        5130
    ],
    "musgu": [
        5131
    ],
    "mouloui": [
        5131
    ],
    "mousgou": [
        5131
    ],
    "mousgoum": [
        5131
    ],
    "mousgoun": [
        5131
    ],
    "mulwi": [
        5131
    ],
    "munjuk": [
        5131
    ],
    "musgum": [
        5131
    ],
    "musuk": [
        5131
    ],
    "muzuk": [
        5131
    ],
    "mündü": [
        5132
    ],
    "mondo": [
        5132,
        7107
    ],
    "mondu": [
        5132
    ],
    "mountou": [
        5132
    ],
    "mundo": [
        5132
    ],
    "musi": [
        5133
    ],
    "mabire": [
        5134
    ],
    "mugom": [
        5135
    ],
    "mugu": [
        5135
    ],
    "mugum": [
        5135
    ],
    "multiple languages": [
        5136
    ],
    "multiple": [
        5136
    ],
    "maiwala": [
        5137
    ],
    "mubako": [
        5138
    ],
    "mumbake": [
        5138
    ],
    "miao, eastern xiangxi": [
        5139
    ],
    "murle": [
        5140,
        5141
    ],
    "murleye": [
        5140,
        5141
    ],
    "merule": [
        5140,
        5141
    ],
    "mourle": [
        5140,
        5141
    ],
    "murelei": [
        5140,
        5141
    ],
    "murlɛ": [
        5140,
        5141
    ],
    "murule": [
        5140,
        5141
    ],
    "muskogee": [
        5142
    ],
    "maskoke": [
        5142
    ],
    "muscogee": [
        5142
    ],
    "mvskoke": [
        5142
    ],
    "muria, western": [
        5143
    ],
    "mudia": [
        5143
    ],
    "muria gondi": [
        5143
    ],
    "mogogodo": [
        5144
    ],
    "mukogodo": [
        5144
    ],
    "mukoquodo": [
        5144
    ],
    "muthuvan": [
        5145
    ],
    "mudavan": [
        5145
    ],
    "muduva": [
        5145
    ],
    "muduvan": [
        5145
    ],
    "muduvar": [
        5145
    ],
    "mutuvar": [
        5145
    ],
    "mbo-ung": [
        5146
    ],
    "mboung": [
        5146
    ],
    "muyang": [
        5147
    ],
    "ma muyaŋ": [
        5147
    ],
    "muyaŋ": [
        5147
    ],
    "mouyenge": [
        5147
    ],
    "mouyengue": [
        5147
    ],
    "muyenge": [
        5147
    ],
    "myau": [
        5147
    ],
    "myenge": [
        5147
    ],
    "mursi": [
        5148,
        5149
    ],
    "manam": [
        5150
    ],
    "manam pile": [
        5150
    ],
    "manum": [
        5150
    ],
    "mattole": [
        5151
    ],
    "mamboru": [
        5152
    ],
    "memboro": [
        5152
    ],
    "marawar": [
        5153,
        5154
    ],
    "merwari": [
        8340,
        5153,
        5154
    ],
    "mongolian, peripheral": [
        5155,
        5156
    ],
    "menggu": [
        5155,
        5156
    ],
    "monggol": [
        5155,
        5156
    ],
    "mixtec, yucuañe": [
        5157
    ],
    "mixteco de san bartolomé yucuañe": [
        5157
    ],
    "mixteco del sureste central": [
        5157
    ],
    "mulgi": [
        5158
    ],
    "mire": [
        5158
    ],
    "miyako": [
        5159
    ],
    "miyako-ikema": [
        5159
    ],
    "mekmek": [
        5160
    ],
    "mbara (australia)": [
        5161
    ],
    "midjamba": [
        5161
    ],
    "mitjamba": [
        5161
    ],
    "minaveha": [
        5162
    ],
    "minavega": [
        5162
    ],
    "marovo": [
        5163
    ],
    "masenrempulu": [
        5164,
        8279
    ],
    "massenrempulu": [
        5164
    ],
    "moere": [
        5165
    ],
    "marau": [
        5166
    ],
    "massep": [
        5167
    ],
    "masep": [
        5167
    ],
    "mpotovoro": [
        5168
    ],
    "marfa": [
        5169
    ],
    "murut, tahol": [
        5170
    ],
    "murut, tagal": [
        5170
    ],
    "machinga": [
        5171
    ],
    "meoswar": [
        5172
    ],
    "mair": [
        5173
    ],
    "maiyon": [
        5173
    ],
    "maiyã": [
        5173
    ],
    "mesqan": [
        5174
    ],
    "mwatebu": [
        5175
    ],
    "mukawa": [
        5177
    ],
    "mwela": [
        5178
    ],
    "mwera (chimwera)": [
        5178
    ],
    "murrinh-patha": [
        5179
    ],
    "murinbada": [
        5179
    ],
    "murinbata": [
        5179
    ],
    "murinhpatha": [
        5179
    ],
    "murinpatha": [
        5179
    ],
    "murinypata": [
        5179
    ],
    "moewehafen": [
        5180
    ],
    "mouk-aria": [
        5181
    ],
    "meaun": [
        5182
    ],
    "mewun": [
        5182
    ],
    "maninkakan, kita": [
        5183
    ],
    "mirandese": [
        5184
    ],
    "mirandés": [
        5184
    ],
    "mirandês": [
        5184
    ],
    "madjingay": [
        5185
    ],
    "mwanga": [
        5186
    ],
    "maewo, central": [
        5187
    ],
    "mabuiag": [
        5188
    ],
    "müün": [
        5189
    ],
    "mindat": [
        5189
    ],
    "mün": [
        5189
    ],
    "mün chin": [
        5189
    ],
    "mwimbi-muthambi": [
        5192
    ],
    "moken": [
        5193,
        5194
    ],
    "mawken": [
        5193,
        5194
    ],
    "mittu": [
        5195
    ],
    "mentawai": [
        5196
    ],
    "mentawei": [
        5196
    ],
    "mentawi": [
        5196
    ],
    "mpa": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "meo kao": [
        5197,
        5198,
        5200
    ],
    "mong do": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "mong trang": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "mán tráng": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "mán": [
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "mediak": [
        5202
    ],
    "mosiro": [
        5203
    ],
    "moingi": [
        5204
    ],
    "mixtec, northwest oaxaca": [
        5205
    ],
    "mixteco de yucuná": [
        5205
    ],
    "mixteco del noroeste": [
        5205
    ],
    "mixteco del noroeste de oaxaca": [
        5205
    ],
    "mixtec, tezoatlán": [
        5206
    ],
    "mixteco de tezoatlán de segura y luna": [
        5206
    ],
    "manyika": [
        5207
    ],
    "manika": [
        5207
    ],
    "modang": [
        5208
    ],
    "mele-fila": [
        5209
    ],
    "malgbe": [
        5210
    ],
    "malbe": [
        5210
    ],
    "malgwe": [
        5210
    ],
    "mbangala": [
        5211
    ],
    "mvuba": [
        5212
    ],
    "mbuba": [
        5212
    ],
    "mvuba-a": [
        5212
    ],
    "mozarabic": [
        5213
    ],
    "miju-mishmi": [
        5214
    ],
    "miji": [
        6895,
        5214
    ],
    "miju": [
        5214
    ],
    "monumbo": [
        5215
    ],
    "mambuwan": [
        5215
    ],
    "maxi": [
        5216
    ],
    "mahi": [
        5216
    ],
    "maxi gbe": [
        5216
    ],
    "maxi-gbe": [
        5216
    ],
    "meramera": [
        5217
    ],
    "melamela": [
        5217
    ],
    "moi (indonesia)": [
        5218
    ],
    "mosana": [
        5218
    ],
    "mbowe": [
        5219
    ],
    "mixe, tlahuitoltepec": [
        5220
    ],
    "mixe alto del centro": [
        5220
    ],
    "mixe, juquila": [
        5221
    ],
    "murik (malaysia)": [
        5222
    ],
    "mixtec, huitepec": [
        5223
    ],
    "mixteco de huitepec": [
        5223
    ],
    "mixteco de san antonio huitepec": [
        5223
    ],
    "mixteco de zaachila": [
        5223
    ],
    "mixtec, jamiltepec": [
        5224
    ],
    "mixteco de jamiltepec": [
        5224
    ],
    "mixteco de oaxaca de costa central baja": [
        5224
    ],
    "mixteco de santa maría huazolotitlán": [
        5224
    ],
    "mada (cameroon)": [
        5225
    ],
    "maɗa": [
        5225
    ],
    "mixtec, metlatónoc": [
        5226
    ],
    "metlatónoc": [
        5226
    ],
    "metlatónoc mixtec": [
        5226
    ],
    "mahou": [
        5228
    ],
    "mahu": [
        5228
    ],
    "maou": [
        5228
    ],
    "mau": [
        5228,
        6846
    ],
    "mauka": [
        5228
    ],
    "mauke": [
        5228
    ],
    "mawukakan": [
        5228
    ],
    "mixtec, southeastern nochixtlán": [
        5229
    ],
    "mixteco de santo domingo nuxaá": [
        5229
    ],
    "mixteco del sureste de nochixtlán": [
        5229
    ],
    "masela, central": [
        5230
    ],
    "marsela-south babar": [
        5230
    ],
    "marsela-south": [
        5230
    ],
    "myamasa": [
        5231,
        5232
    ],
    "myamma saka": [
        5231,
        5232
    ],
    "myamma": [
        5231,
        5232
    ],
    "myanma": [
        5231,
        5232
    ],
    "mbay moissala": [
        5233
    ],
    "moissala": [
        5233
    ],
    "mbaye": [
        5233
    ],
    "mbaï": [
        5233
    ],
    "moissala mbai": [
        5233
    ],
    "mayeka": [
        5234
    ],
    "myene": [
        5235
    ],
    "màwés aasʼè": [
        5236
    ],
    "màwés": [
        5236
    ],
    "manta": [
        5237
    ],
    "menta": [
        5237
    ],
    "makah": [
        5238
    ],
    "mina (india)": [
        5239
    ],
    "mangayat": [
        5240
    ],
    "mangaya": [
        5240
    ],
    "mongaiyat": [
        5240
    ],
    "mamara": [
        5241
    ],
    "mamaara": [
        5241
    ],
    "mamara senoufo": [
        5241
    ],
    "mianka": [
        5241
    ],
    "minianka": [
        5241
    ],
    "miniyanka": [
        5241
    ],
    "minya": [
        5241
    ],
    "minyanka": [
        5241
    ],
    "moma": [
        5242
    ],
    "moma-kulawi": [
        5242
    ],
    "me’en": [
        5243,
        5244
    ],
    "me'en": [
        5243,
        5244
    ],
    "mɛʼɛnɛn": [
        5244
    ],
    "mura": [
        5246
    ],
    "múra-pirahã": [
        5246
    ],
    "muniche": [
        5247
    ],
    "munichi": [
        5247
    ],
    "munichino": [
        5247
    ],
    "mesmes": [
        5248
    ],
    "mundurukú": [
        5249
    ],
    "mõnjoroko": [
        5249
    ],
    "monjoroku": [
        5249
    ],
    "mundurucu": [
        5249
    ],
    "mordva": [
        5250
    ],
    "mordvin-erzya": [
        5250
    ],
    "mordvinian": [
        5250
    ],
    "muyuw": [
        5251
    ],
    "murua": [
        5251
    ],
    "murua dukwayasi": [
        5251
    ],
    "murua kaulae": [
        5251
    ],
    "muruwa": [
        5251
    ],
    "muyua": [
        5251
    ],
    "muyuwa": [
        5251
    ],
    "masaaba": [
        5252
    ],
    "masaba": [
        5252
    ],
    "macuna": [
        5253
    ],
    "masa ye": [
        5253
    ],
    "makuna": [
        5253
    ],
    "makuna-erulia": [
        5253
    ],
    "majsá": [
        5253
    ],
    "maxsã": [
        5253
    ],
    "mandaic, classical": [
        5254
    ],
    "mixtec, santa maría zacatepec": [
        5255
    ],
    "mixteco de santa maría zacatepec": [
        5255
    ],
    "mozabite": [
        5256,
        5257,
        5258
    ],
    "mzab": [
        5256,
        5257,
        5258
    ],
    "mzabi": [
        5256,
        5257,
        5258
    ],
    "malagasy sign language": [
        5259
    ],
    "madagascar sign language": [
        5259
    ],
    "malimba": [
        5260
    ],
    "mudima": [
        5260
    ],
    "mulimba": [
        5260
    ],
    "morawa": [
        5261
    ],
    "monastic sign language": [
        5262
    ],
    "monastic": [
        5262
    ],
    "mazatec, ixcatlán": [
        5264
    ],
    "mazateco de san pedro ixcatlán": [
        5264
    ],
    "mazateco de presa bajo": [
        5264
    ],
    "manya": [
        5265
    ],
    "maninyakan": [
        5265
    ],
    "maniya": [
        5265
    ],
    "manya kan": [
        5265
    ],
    "mambila, nigeria": [
        5266
    ],
    "mabila": [
        5266
    ],
    "mixe, mazatlán": [
        5267
    ],
    "mazatlán": [
        5267,
        8127
    ],
    "mazatlán mixe": [
        5267
    ],
    "mumuye": [
        5268
    ],
    "mazandarani": [
        5269
    ],
    "mazanderani": [
        5269
    ],
    "matipuhy": [
        5270
    ],
    "mariape-nahuqua": [
        5270
    ],
    "matipu": [
        5270
    ],
    "movima": [
        5271
    ],
    "mowimaj": [
        5271
    ],
    "mori atas": [
        5272
    ],
    "mori": [
        5272,
        8555,
        6085
    ],
    "marubo": [
        5273
    ],
    "marova": [
        5273
    ],
    "maruba": [
        5273
    ],
    "marúbo": [
        5273
    ],
    "macanese": [
        5274
    ],
    "macaense": [
        5274
    ],
    "macao creole portuguese": [
        5274
    ],
    "makista": [
        5274
    ],
    "mintil": [
        5275
    ],
    "mitil": [
        5275
    ],
    "midsivindi": [
        5276
    ],
    "mandja": [
        5277
    ],
    "manja": [
        5277
    ],
    "manza": [
        5426,
        5277
    ],
    "mänzä": [
        5277
    ],
    "mmfo": [
        5278
    ],
    "mozambican sign language": [
        5280
    ],
    "mozambican": [
        5280,
        8566
    ],
    "maiadom": [
        5281
    ],
    "maiadomeqa": [
        5281
    ],
    "maiadomu": [
        5281
    ],
    "moil": [
        5292
    ],
    "min nam": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "min nan": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "min nan chinese": [
        5293,
        5294,
        5295,
        5296
    ],
    "minnan": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "maqua": [
        5300
    ],
    "mayen": [
        5309
    ],
    "machongrr": [
        5312
    ],
    "mochumi": [
        5312
    ],
    "mochungrr": [
        5312
    ],
    "mojung": [
        5312
    ],
    "mao": [
        5317,
        7386,
        7387,
        8916
    ],
    "maikel": [
        5317
    ],
    "mao naga": [
        5317
    ],
    "memi": [
        5317
    ],
    "muw": [
        5317
    ],
    "ma’bo": [
        5320
    ],
    "mbacca": [
        5320
    ],
    "mbaka": [
        5320
    ],
    "mbwaka": [
        5320
    ],
    "mabo": [
        5320
    ],
    "modan": [
        5321
    ],
    "maruongmai": [
        5329
    ],
    "mbu": [
        5330
    ],
    "mungyen": [
        5330
    ],
    "mongbandi": [
        5331
    ],
    "mongwandi": [
        5331,
        5422
    ],
    "mūöt": [
        5334,
        5335
    ],
    "mathsereng": [
        5337
    ],
    "mexicano de la huasteca hidalguense": [
        5341
    ],
    "masehual tla’tol": [
        5343
    ],
    "masehual": [
        5343
    ],
    "michoacan aztec": [
        5345
    ],
    "michoacan": [
        5345
    ],
    "michoacán nahuatl": [
        5345
    ],
    "melamba": [
        5360
    ],
    "mesing": [
        5360
    ],
    "mosange": [
        5369
    ],
    "modunga": [
        5377
    ],
    "mondugu": [
        5377
    ],
    "mondunga": [
        5377
    ],
    "mangdhika": [
        5396
    ],
    "mangsdekha": [
        5396
    ],
    "mangdep": [
        5396
    ],
    "mare": [
        5401
    ],
    "marean": [
        5401
    ],
    "mixe, north central": [
        5403
    ],
    "myamkat": [
        5405
    ],
    "myamskad": [
        5405
    ],
    "malamauda": [
        5406
    ],
    "malaumanda": [
        5406
    ],
    "malumanda": [
        5406
    ],
    "mfumte": [
        5419
    ],
    "mfɨ́ti": [
        5419
    ],
    "minagende": [
        5421
    ],
    "megimba": [
        5425
    ],
    "mogimba": [
        5425
    ],
    "mundum": [
        5425
    ],
    "mingi": [
        5429
    ],
    "mihavane": [
        5431
    ],
    "mihavani": [
        5431
    ],
    "mihawani": [
        5431
    ],
    "makhuwa": [
        8123,
        8124,
        5431,
        8532
    ],
    "men’s": [
        5432
    ],
    "mens": [
        5432
    ],
    "mexicano de guerrero": [
        5439
    ],
    "minjanti": [
        5443
    ],
    "mehcanohtlahtol": [
        5453
    ],
    "morelos": [
        5455
    ],
    "morelos nahuatl": [
        5455
    ],
    "melaꞌtájto̱l": [
        5465
    ],
    "mecayapan isthmus nahuatl": [
        5465
    ],
    "mecayapan": [
        5465
    ],
    "mejicano del istmo": [
        5465
    ],
    "mjillem": [
        5471
    ],
    "mzangyim": [
        5493
    ],
    "mohongia": [
        5494
    ],
    "mawanda": [
        5495
    ],
    "miklai": [
        5496
    ],
    "monr": [
        5500
    ],
    "marlpa": [
        5506
    ],
    "mayangkhang": [
        5519,
        5520
    ],
    "miyang-khang": [
        5519,
        5520
    ],
    "mibini": [
        5523
    ],
    "mankiyali": [
        5552
    ],
    "maram naga": [
        5561
    ],
    "mindoumou": [
        5564
    ],
    "mindumbu": [
        5564
    ],
    "minduumo": [
        5564
    ],
    "mzieme": [
        5565
    ],
    "mzieme naga": [
        5565
    ],
    "mabea": [
        5567,
        5568
    ],
    "mabi": [
        5567,
        5568
    ],
    "magbea": [
        5567,
        5568
    ],
    "mgoumba": [
        5567,
        5568
    ],
    "mvumbo": [
        5567,
        5568
    ],
    "monsang": [
        5569
    ],
    "mawshang": [
        5569
    ],
    "mongsang": [
        5569
    ],
    "monsang naga": [
        5569
    ],
    "monshang": [
        5569
    ],
    "moshang": [
        5569,
        5703
    ],
    "mushang": [
        5569
    ],
    "makura": [
        5572
    ],
    "manang": [
        5574,
        5575
    ],
    "manang ke": [
        5574,
        5575
    ],
    "manangba": [
        5574,
        5575
    ],
    "manange": [
        5574,
        5575
    ],
    "manangi": [
        5574,
        5575
    ],
    "moyon": [
        5577,
        5578
    ],
    "mayol": [
        5577,
        5578
    ],
    "mayon naga": [
        5577,
        5578
    ],
    "mayon": [
        5577,
        5578
    ],
    "moyon naga": [
        5577,
        5578
    ],
    "mayo-kebi": [
        5581
    ],
    "maidu, northeast": [
        5584
    ],
    "maidu proper": [
        5584
    ],
    "mountain maidu": [
        5584
    ],
    "májdy": [
        5584
    ],
    "mailang": [
        5596
    ],
    "maring naga": [
        5597,
        5598
    ],
    "magingo": [
        5609
    ],
    "meu": [
        5618
    ],
    "mueang": [
        5620,
        5621
    ],
    "mu’ang": [
        5620,
        5621
    ],
    "myang": [
        5620,
        5621
    ],
    "muang": [
        5620,
        5621
    ],
    "mung": [
        5620,
        5621
    ],
    "mida": [
        5625
    ],
    "mathwadi bhilori": [
        5626
    ],
    "mathwadi": [
        5626
    ],
    "manggang": [
        5632
    ],
    "mondropolon": [
        5646
    ],
    "meluri": [
        5647
    ],
    "moiyui": [
        5666
    ],
    "mozhumi": [
        5666
    ],
    "meng yu": [
        5678
    ],
    "meng": [
        5678
    ],
    "mosso": [
        5678
    ],
    "mosuo": [
        5678
    ],
    "musuo yu": [
        5678
    ],
    "musuo": [
        5678
    ],
    "mise": [
        5688
    ],
    "miwok, northern sierra": [
        5698
    ],
    "maritime sign language": [
        5699
    ],
    "maritime": [
        5699,
        7737
    ],
    "mantsi": [
        5723,
        9112
    ],
    "mehek": [
        5749
    ],
    "mehek suma": [
        5749
    ],
    "me’ek": [
        5749
    ],
    "middle newar": [
        5769
    ],
    "manundi": [
        5775
    ],
    "manjamuesi": [
        5799
    ],
    "mwezi": [
        5799
    ],
    "mombe": [
        5811
    ],
    "mbembe, tigon": [
        5812
    ],
    "mbémbe": [
        5812
    ],
    "mezama": [
        5817
    ],
    "mbum nzakambay": [
        5820
    ],
    "moabite": [
        5829
    ],
    "manobo, obo": [
        5830
    ],
    "manuvu’": [
        5830
    ],
    "matlatzinca, atzingo": [
        5839
    ],
    "matlatzinka": [
        5839
    ],
    "maaro": [
        5857
    ],
    "middle korean (10th-16th cent.)": [
        5882
    ],
    "mochi": [
        5892
    ],
    "monkha": [
        5893
    ],
    "mönpa": [
        5893
    ],
    "mucubal": [
        5899
    ],
    "mahairi": [
        5904
    ],
    "mochica": [
        5906
    ],
    "macanipa": [
        5907
    ],
    "minoan": [
        5911
    ],
    "mayna": [
        5916
    ],
    "matchopa": [
        5929,
        5930
    ],
    "mara ma-siki": [
        5950
    ],
    "ma-siki": [
        5950
    ],
    "maijuna": [
        5952
    ],
    "mai ja": [
        5952
    ],
    "maihuna": [
        5952
    ],
    "maijɨki": [
        5952
    ],
    "máíhɨki": [
        5952
    ],
    "muro": [
        5956
    ],
    "muru": [
        5956
    ],
    "malahoi": [
        5982
    ],
    "mezquital": [
        5983
    ],
    "mezquital otomi": [
        5983
    ],
    "madre": [
        5987
    ],
    "mexquititlán": [
        5989
    ],
    "majubim": [
        6022
    ],
    "machado": [
        6022,
        8240
    ],
    "mezontla": [
        6045
    ],
    "metzontla": [
        6045
    ],
    "mezontla popoloca": [
        6045
    ],
    "mak (nigeria)": [
        6050
    ],
    "mazatec, puebla and northeastern": [
        6051
    ],
    "mazateco de puebla y del noroeste": [
        6051
    ],
    "moium": [
        6053
    ],
    "makkal": [
        6067
    ],
    "malai paliyar": [
        6067
    ],
    "mudderschprooch": [
        6082
    ],
    "mennonite german": [
        6086
    ],
    "mennonite": [
        6086
    ],
    "mennonite low german": [
        6086
    ],
    "mennoniten platt": [
        6086
    ],
    "mennoniten": [
        6086
    ],
    "mala (papua new guinea)": [
        6091
    ],
    "malala": [
        6091
    ],
    "manikacha": [
        6095
    ],
    "meco": [
        6096
    ],
    "morehead": [
        6102,
        7168,
        7363
    ],
    "majugan": [
        6105
    ],
    "melanesian sign language": [
        6120
    ],
    "melanesian": [
        6120,
        7666
    ],
    "man pa seng": [
        6121
    ],
    "mirpur": [
        6131
    ],
    "mirpur panjabi": [
        6131
    ],
    "mirpur punjabi": [
        6131
    ],
    "mirpuri": [
        6131
    ],
    "magadhan": [
        6138,
        6139,
        6140,
        6141
    ],
    "mountain pima": [
        6142
    ],
    "maco": [
        8322,
        6145,
        8397
    ],
    "madutjara": [
        6150
    ],
    "malachini": [
        6168
    ],
    "maleng": [
        6178
    ],
    "ma lieng": [
        6178
    ],
    "malieng": [
        6178
    ],
    "miani": [
        6182,
        7620
    ],
    "miani north": [
        6182
    ],
    "mijean": [
        6193
    ],
    "murut, paluan": [
        6202
    ],
    "māhārāṣṭri prākrit": [
        6208
    ],
    "māhārāṣṭri": [
        6208
    ],
    "mauresque": [
        6212
    ],
    "manat": [
        6217
    ],
    "miwok, plains": [
        6220
    ],
    "malay, papuan": [
        6222
    ],
    "melayu papua": [
        6222
    ],
    "mpinda": [
        6226
    ],
    "mangarongaro": [
        6229
    ],
    "miamia": [
        6235
    ],
    "manoa": [
        6236
    ],
    "muslim pontic": [
        6241,
        6242,
        6243
    ],
    "muslim": [
        7773,
        7774,
        7775,
        6241,
        6242,
        6243
    ],
    "malecite-passamaquoddy": [
        6281
    ],
    "maliseet-passamaquoddy": [
        6281
    ],
    "madaglashti": [
        6299
    ],
    "mogao": [
        6301
    ],
    "miaro": [
        6308
    ],
    "miaro awyu": [
        6308
    ],
    "malay, central": [
        6311
    ],
    "melayu tengah": [
        6311
    ],
    "midden maleisch": [
        6311
    ],
    "midden": [
        6311
    ],
    "maleisch": [
        6311
    ],
    "migowy": [
        6318
    ],
    "mahsudi": [
        6323
    ],
    "meseta": [
        6354
    ],
    "merap": [
        6356
    ],
    "merah": [
        6359,
        7624
    ],
    "mul": [
        6365
    ],
    "muh": [
        6365
    ],
    "miguelenho": [
        6368
    ],
    "migueleno": [
        6368
    ],
    "manape": [
        6376
    ],
    "molbog": [
        6378
    ],
    "molbog palawan": [
        6378
    ],
    "mon karen": [
        6380
    ],
    "mon kayin": [
        6380
    ],
    "mutheit": [
        6380
    ],
    "mixe, quetzaltepec": [
        6383
    ],
    "midland mixe": [
        6383
    ],
    "midland": [
        6383
    ],
    "mixe alto del sur": [
        6383
    ],
    "matihuaca": [
        6397
    ],
    "mercheros": [
        6408
    ],
    "margos-yarowilca-lauricocha": [
        6422
    ],
    "margos-yarowilca-lauricocha quechua": [
        6422
    ],
    "margos": [
        6422
    ],
    "margos-cauri-chavinillo": [
        6422
    ],
    "martín": [
        6426,
        7716
    ],
    "mewahang, western": [
        6458
    ],
    "maragoli": [
        6459
    ],
    "maragooli": [
        6459
    ],
    "malavi": [
        6463
    ],
    "mallow": [
        6463
    ],
    "malvi": [
        6463
    ],
    "malwada": [
        6463
    ],
    "malwi": [
        6463
    ],
    "māori kūki ’āirani": [
        6472
    ],
    "mashang": [
        6479
    ],
    "marangdong": [
        6481
    ],
    "miraya": [
        6488
    ],
    "miraya bikol": [
        6488
    ],
    "môa remo": [
        6500
    ],
    "môa": [
        6500
    ],
    "maropa": [
        6505
    ],
    "mores": [
        6506
    ],
    "manihiki-rakahanga": [
        6534
    ],
    "marka": [
        6536,
        7000,
        7001
    ],
    "marka dafing": [
        6536
    ],
    "marka-dafin": [
        6536
    ],
    "murkim": [
        6547
    ],
    "manouche": [
        6556
    ],
    "manuche": [
        6556
    ],
    "manuš": [
        6556
    ],
    "mimico-gestual": [
        6559
    ],
    "middle eastern romani": [
        6560
    ],
    "mıtrıp": [
        6560
    ],
    "marma": [
        6565
    ],
    "mraima": [
        6565
    ],
    "muatiamvua": [
        6568
    ],
    "moldavian": [
        6575,
        6576,
        6577,
        6578,
        6579,
        6580
    ],
    "moldovan": [
        6575,
        6576,
        6577,
        6578,
        6579,
        6580
    ],
    "miriwoong sign language": [
        6604
    ],
    "mwsl": [
        6604
    ],
    "macedo": [
        6627,
        6628
    ],
    "macedo romania": [
        6627,
        6628
    ],
    "macedo romanian": [
        6627,
        6628
    ],
    "macedo-romanian": [
        6627,
        6628
    ],
    "macedo-rumanian": [
        6627,
        6628
    ],
    "megleno": [
        6629
    ],
    "meglenite": [
        6629
    ],
    "meglenitic": [
        6629
    ],
    "megleno romanian": [
        6629
    ],
    "mukhad": [
        6630,
        6631
    ],
    "myhadbyr": [
        6630,
        6631
    ],
    "myhynnynydy-ch’al": [
        6630,
        6631
    ],
    "myxʼabišdy čʼel": [
        6630,
        6631
    ],
    "myxʼabišdy": [
        6630,
        6631
    ],
    "mala (nigeria)": [
        6633
    ],
    "marrubhasha": [
        6643
    ],
    "marvadi": [
        6643
    ],
    "marvari": [
        6643
    ],
    "marwadi": [
        6643
    ],
    "marwari (india)": [
        6643
    ],
    "manggai": [
        6644
    ],
    "midhaga": [
        6645
    ],
    "mithaka": [
        6645
    ],
    "muoy": [
        6659
    ],
    "murire": [
        6659
    ],
    "meskwaki": [
        6660
    ],
    "meshkwahkihaki": [
        6660
    ],
    "mesquakie": [
        6660
    ],
    "madeggusu": [
        6692
    ],
    "mandeghughusu": [
        6692
    ],
    "meghwar bhil": [
        6704
    ],
    "meghwar": [
        6704
    ],
    "murut, sembakung": [
        6708
    ],
    "mbalangwe": [
        6709
    ],
    "melayu bahasa": [
        6725
    ],
    "melanau, sibu": [
        6768
    ],
    "miao, small flowery": [
        6801
    ],
    "mag-antsi": [
        6807
    ],
    "mag-anchi ayta": [
        6807
    ],
    "mag-anchi": [
        6807
    ],
    "mag-anchi sambal": [
        6807
    ],
    "mag-antsi ayta": [
        6807
    ],
    "menggae": [
        6810
    ],
    "mahdi shahri": [
        6821
    ],
    "mahdi": [
        6821
    ],
    "mehdishahri": [
        6821
    ],
    "mera sagtengpa": [
        6823
    ],
    "mera": [
        6823
    ],
    "meragsagstengkha": [
        6823
    ],
    "mira sagtengpa": [
        6823
    ],
    "mashuakwe": [
        6835
    ],
    "manamabobo": [
        6850
    ],
    "manava": [
        6850
    ],
    "makoma": [
        6870
    ],
    "mende (papua new guinea)": [
        6878
    ],
    "motuna": [
        6885
    ],
    "madungore": [
        6893
    ],
    "mapun": [
        6896
    ],
    "ma manda": [
        6914
    ],
    "miwok, southern sierra": [
        6915
    ],
    "me-wuk": [
        6915
    ],
    "meewoc": [
        6915
    ],
    "mewoc": [
        6915
    ],
    "miwoc": [
        6915
    ],
    "miwokan": [
        6915
    ],
    "mokélumne": [
        6915
    ],
    "moquelumnan": [
        6915
    ],
    "mekens": [
        6917
    ],
    "mekém": [
        6917
    ],
    "malagasy, sakalava": [
        6918
    ],
    "maumere": [
        6920
    ],
    "multani": [
        6927,
        6928,
        6929,
        6930
    ],
    "mutani": [
        6927,
        6928,
        6929,
        6930
    ],
    "maia": [
        6931
    ],
    "mawo": [
        6934
    ],
    "mattu": [
        6943
    ],
    "murut, selungai": [
        6945
    ],
    "ma’ya": [
        6961
    ],
    "ma'ya": [
        6961
    ],
    "mandelaut": [
        6972
    ],
    "musasa": [
        6973
    ],
    "musahar": [
        6973
    ],
    "mananahua": [
        6998
    ],
    "maraka": [
        7000,
        7001
    ],
    "markaajo": [
        7000,
        7001
    ],
    "markakan": [
        7000,
        7001
    ],
    "ma’di, southern": [
        7003
    ],
    "ma’di urule": [
        7003
    ],
    "miyobe": [
        7047
    ],
    "mɛyɔ́pɛ": [
        7047
    ],
    "meyobe": [
        7047
    ],
    "méthel d-saqátri": [
        7084,
        7085
    ],
    "méthel": [
        7084,
        7085
    ],
    "murut, serudung": [
        7110
    ],
    "mbia chee": [
        7115
    ],
    "mbia": [
        7115,
        8936
    ],
    "mímica": [
        7144
    ],
    "makong": [
        7147,
        7148
    ],
    "mang cong": [
        7147,
        7148
    ],
    "mang": [
        9110,
        7147,
        7148
    ],
    "mang-koong": [
        7147,
        7148
    ],
    "mankoong": [
        7147,
        7148
    ],
    "makon": [
        7147,
        7148
    ],
    "matya": [
        7167
    ],
    "matya samo": [
        7167
    ],
    "moglon": [
        7187
    ],
    "mwaghavul": [
        7198
    ],
    "mwahavul": [
        7198
    ],
    "mẽkisêdjê": [
        7207
    ],
    "mukhiya": [
        7208
    ],
    "molisano": [
        7220
    ],
    "molise croatian": [
        7220
    ],
    "molise": [
        7220
    ],
    "molise slavic": [
        7220
    ],
    "maore": [
        7228,
        7229
    ],
    "maore comorian": [
        7228,
        7229
    ],
    "malawi sena": [
        7238
    ],
    "manata": [
        7247
    ],
    "mississiou": [
        7255
    ],
    "meissenish": [
        7264
    ],
    "meißnisch": [
        7264
    ],
    "maya samo": [
        7274
    ],
    "modern chaldean": [
        7277
    ],
    "mirabo": [
        7290
    ],
    "menhti kenaga": [
        7301
    ],
    "menhti": [
        7301
    ],
    "minto": [
        7301
    ],
    "murmi": [
        7308,
        7309,
        7310,
        7390,
        7391,
        7599
    ],
    "mnm": [
        7322
    ],
    "madara": [
        7333
    ],
    "mopara": [
        7334
    ],
    "mamedja": [
        7336
    ],
    "mamidza": [
        7336
    ],
    "metabi": [
        7336
    ],
    "muntabi": [
        7336
    ],
    "magüa": [
        7355
    ],
    "me’phaa, malinaltepec": [
        7360
    ],
    "me’phaa": [
        7360,
        7661,
        7669,
        7680
    ],
    "malinaltepec": [
        7360
    ],
    "malinaltepec me'phaa": [
        7360
    ],
    "mephaa": [
        7360,
        7661,
        7669,
        7680
    ],
    "malinaltepec tlapanec": [
        7360
    ],
    "mè’phàà mañuwìín": [
        7360
    ],
    "mè’phàà": [
        7360,
        7661
    ],
    "mañuwìín": [
        7360
    ],
    "marom": [
        7395
    ],
    "modra": [
        7401
    ],
    "malagasy, tandroy-mahafaly": [
        7405
    ],
    "mahafaly": [
        7405
    ],
    "movono": [
        7457
    ],
    "madhya chhetriya tharu": [
        7471
    ],
    "madhya": [
        7471,
        8049
    ],
    "madhya ksetriya tharu": [
        7471
    ],
    "moopan": [
        7478
    ],
    "muppans": [
        7478
    ],
    "mid-eastern": [
        7481
    ],
    "madhya-purbiya tharu": [
        7481
    ],
    "madhya-purbiya": [
        7481
    ],
    "murut, timugon": [
        7502
    ],
    "masadiit": [
        7512
    ],
    "masadiit itneg": [
        7512
    ],
    "mong tsi": [
        7529
    ],
    "malagasy, tesaka": [
        7541
    ],
    "miz": [
        7547,
        7548
    ],
    "mur pano": [
        7552
    ],
    "mur": [
        7552
    ],
    "misantla totonac": [
        7562
    ],
    "misantla": [
        7562
    ],
    "mawissi": [
        7570
    ],
    "marina": [
        7573
    ],
    "mata-coahuitlán": [
        7576
    ],
    "monglwe": [
        7577
    ],
    "miisiirii": [
        7587
    ],
    "machicui": [
        7592
    ],
    "motembo": [
        7609
    ],
    "maiani": [
        7620
    ],
    "miani south": [
        7620
    ],
    "ménik": [
        7629
    ],
    "manik": [
        7629
    ],
    "münik": [
        7629
    ],
    "mos tean-ean": [
        7637
    ],
    "minahasa": [
        7648
    ],
    "minhasa": [
        7648
    ],
    "meridional": [
        7654
    ],
    "me’phaa, azoyú": [
        7661
    ],
    "mè’pháà tsìndíì": [
        7661
    ],
    "mè’pháà": [
        7661
    ],
    "melanesian english": [
        7666
    ],
    "margaya": [
        7668
    ],
    "me’phaa, tlacoapa": [
        7669
    ],
    "me’phaa de tlacoapa": [
        7669
    ],
    "meꞌpa̱a̱ wíꞌi̱i̱n": [
        7669,
        7680
    ],
    "meꞌpa̱a̱": [
        7669,
        7680
    ],
    "mi’phaa": [
        7669
    ],
    "muòng": [
        7672
    ],
    "me’phaa, acatepec": [
        7680
    ],
    "me’pa": [
        7680
    ],
    "me’pa wí’ìn": [
        7680
    ],
    "me’pàà wí’ììn": [
        7680
    ],
    "me’pàà": [
        7680
    ],
    "motumotu": [
        7687
    ],
    "mbaniata": [
        7692
    ],
    "mojeño trinitario": [
        7712
    ],
    "mojos": [
        7712
    ],
    "moxos": [
        7712
    ],
    "moro joloano": [
        7734,
        7735
    ],
    "matsuvan": [
        7736
    ],
    "motsuvan": [
        7736
    ],
    "maritime tsimshianic": [
        7737
    ],
    "monba": [
        7738,
        7828
    ],
    "menba": [
        7738,
        7828
    ],
    "memba": [
        7738
    ],
    "motuo": [
        7738
    ],
    "motuo menba": [
        7738
    ],
    "mstsl": [
        7743
    ],
    "modern standard thai sign language": [
        7743
    ],
    "mitsogo": [
        7748
    ],
    "mubami": [
        7750
    ],
    "maya-tekiteko": [
        7757
    ],
    "mame": [
        7757
    ],
    "mbelala": [
        7770
    ],
    "muslim tat": [
        7773,
        7774,
        7775
    ],
    "mussulman tati": [
        7773,
        7774,
        7775
    ],
    "mussulman": [
        7773,
        7774,
        7775
    ],
    "musulman tats": [
        7773,
        7775
    ],
    "musulman": [
        7773,
        7775
    ],
    "m’bunai": [
        7777
    ],
    "mutu": [
        7783,
        7784,
        7785
    ],
    "mutu - saveeng-oov": [
        7784
    ],
    "mutu - saveeng-tuam": [
        7785
    ],
    "mata": [
        7791
    ],
    "masbuar-tela": [
        7809
    ],
    "monpa, tawang": [
        7828
    ],
    "menpa": [
        7828
    ],
    "moinba": [
        7828
    ],
    "momba": [
        7828
    ],
    "mompa": [
        7828
    ],
    "monba, cuona": [
        7828
    ],
    "monkit": [
        7828
    ],
    "mouton": [
        7848
    ],
    "moutong": [
        7848
    ],
    "mebêngokrê": [
        7857
    ],
    "malagasy, tanosy": [
        7859
    ],
    "maen": [
        7865,
        7866
    ],
    "mene": [
        7865,
        7866
    ],
    "mène": [
        7865,
        7866
    ],
    "mènè": [
        7865,
        7866
    ],
    "muoi": [
        7865,
        7866,
        7870
    ],
    "man thanh": [
        7870
    ],
    "môc-châu": [
        7870
    ],
    "mungak": [
        7875
    ],
    "middle atlas berber": [
        7884,
        7885,
        7886
    ],
    "moroccan amazigh": [
        7884,
        7885,
        7886
    ],
    "mahuan": [
        7887
    ],
    "muduga": [
        7907
    ],
    "mudugar": [
        7907
    ],
    "muz": [
        7908
    ],
    "mizlime": [
        7910
    ],
    "minna": [
        7930
    ],
    "muak sa-aak": [
        7936
    ],
    "mova": [
        7937
    ],
    "movoyu": [
        7937
    ],
    "meriam mir": [
        7950
    ],
    "meriam": [
        7950
    ],
    "mir": [
        7950
    ],
    "meryam mir": [
        7950
    ],
    "meryam": [
        7950
    ],
    "miriam": [
        7950
    ],
    "miriam-mir": [
        7950
    ],
    "mbari": [
        7957
    ],
    "mbundu benguella": [
        7957
    ],
    "m’bundo": [
        7957
    ],
    "marrucinian": [
        7958
    ],
    "morrobalama": [
        7960
    ],
    "moroba-lama": [
        7960
    ],
    "morrabalama": [
        7960
    ],
    "morrobolam": [
        7960
    ],
    "macham naga": [
        7963
    ],
    "macham": [
        7963
    ],
    "makyam": [
        7963
    ],
    "makyan naga": [
        7963
    ],
    "makyan": [
        7963
    ],
    "mbakarla": [
        7966
    ],
    "munari": [
        7976,
        7977,
        7978,
        7979
    ],
    "munda": [
        7981,
        7982,
        7983,
        7976,
        7977,
        7978,
        7979
    ],
    "muṇḍari": [
        7976,
        7977,
        7978,
        7979
    ],
    "muɳɖa jagar": [
        7981,
        7982,
        7983
    ],
    "muɳɖa": [
        7981,
        7982,
        7983
    ],
    "malakula": [
        7986
    ],
    "modern standard urdu": [
        7987,
        7988,
        7991
    ],
    "morato": [
        7995
    ],
    "muratu": [
        7995
    ],
    "marattiyan": [
        8045
    ],
    "madhya pradesh marathi": [
        8049
    ],
    "maligo": [
        8052
    ],
    "manimo": [
        8054
    ],
    "maculái": [
        8058
    ],
    "macurawe": [
        8058
    ],
    "macurái": [
        8058
    ],
    "makurawe": [
        8058
    ],
    "mom jango": [
        8075
    ],
    "mom": [
        8075
    ],
    "malankudi": [
        8087
    ],
    "malarkuti": [
        8087
    ],
    "mulak": [
        8092
    ],
    "malay, tenggarong kutai": [
        8099
    ],
    "martuyhunira": [
        8104
    ],
    "mardadhunira": [
        8104
    ],
    "mardudhunira": [
        8104
    ],
    "martuthunira": [
        8104
    ],
    "mbabaram": [
        8105
    ],
    "mogmnanarim": [
        8105
    ],
    "mixtec, juxtlahuaca": [
        8106
    ],
    "mixteco de juxtlahuaca": [
        8106
    ],
    "mudu": [
        8107
    ],
    "mudu koraga": [
        8107
    ],
    "muudu": [
        8107
    ],
    "masela, east": [
        8108
    ],
    "mainfränkisch": [
        8109
    ],
    "minigiri": [
        8110
    ],
    "maraghei": [
        8111
    ],
    "mixtec, ixtayutla": [
        8113
    ],
    "mixteco de santiago ixtayutla": [
        8113
    ],
    "makhuwa-shirima": [
        8114
    ],
    "makhuwa-exirima": [
        8114
    ],
    "makhuwa-niassa": [
        8114
    ],
    "makhuwa-xirima": [
        8114
    ],
    "malgana": [
        8115
    ],
    "maldjana": [
        8115
    ],
    "maljanna": [
        8115
    ],
    "malkana": [
        8115
    ],
    "mixtec, mitlatongo": [
        8116
    ],
    "mitlatongo": [
        8116
    ],
    "mitlatongo mixtec": [
        8116
    ],
    "mixteco de mitlatongo": [
        8116
    ],
    "mazatec, soyaltepec": [
        8117
    ],
    "mazateco de san miguel soyaltepec": [
        8117
    ],
    "mazateco de temascal": [
        8117
    ],
    "mazateco del noreste": [
        8117
    ],
    "mixtec, soyaltepec": [
        8118
    ],
    "mixteco de san bartolo soyaltepec": [
        8118
    ],
    "mixteco del noreste bajo": [
        8118
    ],
    "marenje": [
        8119
    ],
    "marendje": [
        8119
    ],
    "moksela": [
        8120
    ],
    "maksela": [
        8120
    ],
    "muluridyi": [
        8121
    ],
    "molloroidyi": [
        8121
    ],
    "mooloroiji": [
        8121
    ],
    "mularitchee": [
        8121
    ],
    "mullridgey": [
        8121
    ],
    "muluridji": [
        8121
    ],
    "mulurutji": [
        8121
    ],
    "maidu, valley": [
        8122
    ],
    "makhuwa-makhuwana": [
        8123,
        8124
    ],
    "makhuwwa of nampula": [
        8123,
        8124
    ],
    "makhuwwa": [
        8123,
        8124
    ],
    "makoane": [
        8123,
        8124
    ],
    "mixtec, tamazola": [
        8125
    ],
    "mixteco de san juan tamazola": [
        8125
    ],
    "mazatec, ayautla": [
        8126
    ],
    "mazateco del sureste": [
        8126
    ],
    "mazatec, mazatlán": [
        8127
    ],
    "mazateco de mazatlán villa de flores": [
        8127
    ],
    "mazateco del suroeste": [
        8127
    ],
    "mazatlán mazatec": [
        8127
    ],
    "maatšeeli": [
        8133,
        8134
    ],
    "moldova sign language": [
        8139
    ],
    "mbute": [
        8145
    ],
    "mbutere": [
        8145
    ],
    "mfuti": [
        8145
    ],
    "matabello": [
        8155
    ],
    "massachusett": [
        8160
    ],
    "massachusetts": [
        8160
    ],
    "marangis": [
        8172
    ],
    "meung hom": [
        8186
    ],
    "meung": [
        8186
    ],
    "mina bhil": [
        8189
    ],
    "maudalgo": [
        8200
    ],
    "manusela": [
        8224
    ],
    "minidien": [
        8234
    ],
    "miniden": [
        8234
    ],
    "mungkañ": [
        8238
    ],
    "munkan": [
        8238
    ],
    "munggan": [
        8238
    ],
    "muduapa": [
        8242
    ],
    "matotoa": [
        8242
    ],
    "mwali": [
        8255
    ],
    "mohélien": [
        8255
    ],
    "mwali comorian": [
        8255
    ],
    "middle welsh": [
        8262
    ],
    "mawa (nigeria)": [
        8271
    ],
    "mamaindê": [
        8274
    ],
    "mamaindé": [
        8274
    ],
    "mamainsahai’gidu": [
        8274
    ],
    "minyag, western": [
        8276
    ],
    "maiwa (indonesia)": [
        8279
    ],
    "mie": [
        8281
    ],
    "mwani": [
        8284,
        8285
    ],
    "muane": [
        8284,
        8285
    ],
    "mwane": [
        8284,
        8285
    ],
    "mwaní": [
        8284,
        8285
    ],
    "manombai": [
        8317
    ],
    "manobai": [
        8317
    ],
    "maco-piaroa": [
        8322
    ],
    "mako": [
        8322
    ],
    "maku": [
        8322,
        8397
    ],
    "maula": [
        8323
    ],
    "mauula": [
        8323
    ],
    "mawula": [
        8323
    ],
    "maialnga": [
        8332
    ],
    "mapute": [
        8336
    ],
    "mopute": [
        8336
    ],
    "mewati": [
        8357
    ],
    "mewathi": [
        8357
    ],
    "mort noular": [
        8384
    ],
    "mort": [
        8384
    ],
    "mono (wrong)": [
        8388
    ],
    "massacará": [
        8395
    ],
    "manajé": [
        8396
    ],
    "máku": [
        8397
    ],
    "makó": [
        8397
    ],
    "máko": [
        8397
    ],
    "mahakam": [
        8411
    ],
    "middle breton": [
        8420
    ],
    "meeraman": [
        8423
    ],
    "murram": [
        8423
    ],
    "malayic dayak": [
        8449
    ],
    "malayic": [
        8449
    ],
    "moko": [
        8459
    ],
    "mongup": [
        8465
    ],
    "mamburra": [
        8468
    ],
    "mirdha": [
        8487
    ],
    "morva": [
        8487
    ],
    "minjungbal": [
        8490
    ],
    "minjang": [
        8490
    ],
    "minjangbal": [
        8490
    ],
    "minyowa": [
        8490
    ],
    "minyung": [
        8490
    ],
    "manigri": [
        8493
    ],
    "manigri-kambolé ede nago": [
        8493
    ],
    "manigri-kambolé": [
        8493
    ],
    "mendalam": [
        8495
    ],
    "mendalam kajan": [
        8495
    ],
    "mendalam kayan": [
        8495
    ],
    "mainstream": [
        8502
    ],
    "mainstream kenyah": [
        8502
    ],
    "mushungulu": [
        8530
    ],
    "mushunguli": [
        8530
    ],
    "mbonga": [
        8531
    ],
    "mboa": [
        8531
    ],
    "makhuwa-marrevone": [
        8532
    ],
    "makua-marevone": [
        8532
    ],
    "marevone": [
        8532
    ],
    "marrevone": [
        8532
    ],
    "mbudum": [
        8533
    ],
    "ma mbudum": [
        8533
    ],
    "mbedam": [
        8533
    ],
    "mboudoum": [
        8533
    ],
    "median": [
        8534
    ],
    "mingrelian": [
        8535
    ],
    "margalepi": [
        8535
    ],
    "margali": [
        8535
    ],
    "margaluri": [
        8535
    ],
    "margaluri nina": [
        8535
    ],
    "megrel": [
        8535
    ],
    "megrelian": [
        8535
    ],
    "megruli": [
        8535
    ],
    "mengaka": [
        8536,
        8537
    ],
    "megaka": [
        8536,
        8537
    ],
    "məgaka": [
        8536,
        8537
    ],
    "muminh": [
        8538
    ],
    "majera": [
        8539
    ],
    "mazera": [
        8539
    ],
    "midah": [
        8539
    ],
    "mida’a": [
        8539
    ],
    "malaysian sign language": [
        8541
    ],
    "malay, manado": [
        8542
    ],
    "manado": [
        8542
    ],
    "manado malay": [
        8542
    ],
    "manadonese": [
        8542
    ],
    "manadonese malay": [
        8542
    ],
    "minahasan malay": [
        8542
    ],
    "minahasan": [
        8542
    ],
    "manichaean middle persian": [
        8543
    ],
    "manichaean": [
        8543
    ],
    "morerebi": [
        8544
    ],
    "meroitic": [
        8547
    ],
    "moroccan sign language": [
        8548
    ],
    "maroc": [
        8548
    ],
    "marocaine": [
        8548
    ],
    "matbat": [
        8549
    ],
    "malagasy, antankarana": [
        8551
    ],
    "malagasy, tsimihety": [
        8552
    ],
    "maden": [
        8553
    ],
    "mayaguduna": [
        8554
    ],
    "mayi-kutuna": [
        8554
    ],
    "mori bawah": [
        8555
    ],
    "middle mongolian": [
        8558
    ],
    "murring": [
        8560,
        8665
    ],
    "minango": [
        8562
    ],
    "mozambican ngoni": [
        8566
    ],
    "malani": [
        8568
    ],
    "moondjan": [
        8570
    ],
    "mattokki": [
        8572,
        8573,
        8574
    ],
    "mattoki": [
        8572,
        8574
    ],
    "madiin": [
        8580
    ],
    "midlands": [
        8594
    ],
    "mpalitjanh": [
        8596
    ],
    "mbalidjan": [
        8596
    ],
    "mpalit yan": [
        8596
    ],
    "mpalit": [
        8596
    ],
    "mpalityan̯": [
        8596
    ],
    "mpalitjan": [
        8596
    ],
    "mpalityanh": [
        8596
    ],
    "mohegan-pequot": [
        8603
    ],
    "mehim": [
        8615
    ],
    "mean-anger": [
        8619
    ],
    "mearn-anger": [
        8619
    ],
    "meenung": [
        8619
    ],
    "meernanger": [
        8619
    ],
    "menang": [
        8619
    ],
    "mineng": [
        8619
    ],
    "mining": [
        8619
    ],
    "minnal yungar": [
        8619,
        8695
    ],
    "minnal": [
        8619,
        8695
    ],
    "minung": [
        8619
    ],
    "mirnong": [
        8619
    ],
    "mount barker tribe": [
        8619
    ],
    "marriammu": [
        8625
    ],
    "mareammu": [
        8625
    ],
    "mariamo": [
        8625
    ],
    "mariamu": [
        8625
    ],
    "marri ammu": [
        8625
    ],
    "marri": [
        8625,
        9090,
        9100
    ],
    "marri amu": [
        8625
    ],
    "makhuwa-saka": [
        8638
    ],
    "mixtec, alcozauca": [
        8645
    ],
    "mixteco de alocozauca": [
        8645
    ],
    "mixteco de xochapa": [
        8645
    ],
    "mixtec, chazumba": [
        8646
    ],
    "mixteco de chazumba": [
        8646
    ],
    "mixtec, diuxi-tilantongo": [
        8648
    ],
    "mixteco de diuxi-tilantongo": [
        8648
    ],
    "mixteco del este central": [
        8648
    ],
    "mixtec, sinicahua": [
        8652
    ],
    "mixteco de san antonio sinicahua": [
        8652
    ],
    "mixtec, san juan teita": [
        8653
    ],
    "mixteco de san juan teita": [
        8653
    ],
    "mixtec, tijaltepec": [
        8654
    ],
    "mixteco de san pablo tijaltepec": [
        8654
    ],
    "mixteco de santa maría yosoyúa": [
        8654
    ],
    "mixtec, magdalena peñasco": [
        8655
    ],
    "magdalena": [
        8655,
        9119
    ],
    "magdalena peñasco mixtec": [
        8655
    ],
    "mixtec, northern tlaxiaco": [
        8656
    ],
    "mixteco de san juan ñumí": [
        8656
    ],
    "mixteco del norte de tlaxiaco": [
        8656
    ],
    "mixtec, san miguel piedras": [
        8658
    ],
    "mixteco de san miguel piedras": [
        8658
    ],
    "mixtec, sindihui": [
        8662
    ],
    "mixtec, tacahua": [
        8663
    ],
    "mixteco de santa cruz tacahua": [
        8663
    ],
    "mixteco del sur medio": [
        8663
    ],
    "mixtec, cuyamecalco": [
        8664
    ],
    "mixteco de cañada central": [
        8664
    ],
    "mixteco de cuyamecalco": [
        8664
    ],
    "mixtec, yoloxóchitl": [
        8667
    ],
    "mixteco de yoloxóchitl": [
        8667
    ],
    "mbara kwengo": [
        8684
    ],
    "minalnjunga": [
        8695
    ],
    "mamberamo": [
        8699
    ],
    "mallenjerrick": [
        8701
    ],
    "minkin": [
        8704
    ],
    "mayi-yapi": [
        8709
    ],
    "majabi": [
        8709
    ],
    "miappe": [
        8709
    ],
    "miappi": [
        8709
    ],
    "miubbi": [
        8709
    ],
    "myabi": [
        8709
    ],
    "myappe": [
        8709
    ],
    "mayi-kulan": [
        8710
    ],
    "maidhagudi": [
        8710
    ],
    "maigudina": [
        8710
    ],
    "maigudung": [
        8710
    ],
    "maigulung": [
        8710
    ],
    "maikolon": [
        8710
    ],
    "maikudun": [
        8710
    ],
    "maikudung": [
        8710
    ],
    "maikudunu": [
        8710
    ],
    "maikulan": [
        8710
    ],
    "maikulung": [
        8710
    ],
    "majadhagudi": [
        8710
    ],
    "makulu": [
        8710
    ],
    "mayagoondoon": [
        8710
    ],
    "mayagulan": [
        8710
    ],
    "mayatagoorri": [
        8710
    ],
    "maygulan": [
        8710
    ],
    "mayhulan": [
        8710
    ],
    "maykulan": [
        8710
    ],
    "miccoolin": [
        8710
    ],
    "micoolan": [
        8710
    ],
    "mikadoon": [
        8710
    ],
    "mikkoolan": [
        8710
    ],
    "mikoodoono": [
        8710
    ],
    "mikoolu": [
        8710
    ],
    "mayi-thakurti": [
        8712
    ],
    "maidakadi": [
        8712
    ],
    "maidhagari": [
        8712
    ],
    "maidhaggaria": [
        8712
    ],
    "maidhargari": [
        8712
    ],
    "maioakuri": [
        8712
    ],
    "maitakeidi": [
        8712
    ],
    "maitakudi": [
        8712
    ],
    "maithagudi": [
        8712
    ],
    "maithakadi": [
        8712
    ],
    "maithakari": [
        8712
    ],
    "maithakudi": [
        8712
    ],
    "mayadhagurdifagurdi": [
        8712
    ],
    "mayatagoori": [
        8712
    ],
    "maydhagurdi": [
        8712
    ],
    "maytagoori": [
        8712
    ],
    "mitagurdi": [
        8712
    ],
    "mitakoodi": [
        8712
    ],
    "mitakudi": [
        8712
    ],
    "mitroogoordi": [
        8712
    ],
    "mittagurdi": [
        8712
    ],
    "mittaka": [
        8712
    ],
    "mythaguddi": [
        8712
    ],
    "mythugadi": [
        8712
    ],
    "mythuggadi": [
        8712
    ],
    "moira": [
        8713
    ],
    "makú-yahup": [
        8718
    ],
    "mbem": [
        8731
    ],
    "mbubem": [
        8731
    ],
    "muzok": [
        8731
    ],
    "mayangna": [
        8732
    ],
    "matapi": [
        8762
    ],
    "munji-war": [
        8766
    ],
    "mayeyi": [
        8780
    ],
    "malyangapa": [
        8781
    ],
    "malgaaljangaba": [
        8781
    ],
    "malgangara": [
        8781
    ],
    "malja:pa": [
        8781
    ],
    "maljangaba": [
        8781
    ],
    "maljangapa": [
        8781
    ],
    "malya-napa": [
        8781
    ],
    "malyanapa": [
        8781
    ],
    "malyangaba": [
        8781
    ],
    "malyapa": [
        8781
    ],
    "malynapa": [
        8781
    ],
    "milya-uppa": [
        8781
    ],
    "milyauppa": [
        8781
    ],
    "muliaarpa": [
        8781
    ],
    "mullia-arpa": [
        8781
    ],
    "multyerra": [
        8781
    ],
    "mulya-napa": [
        8781
    ],
    "mulya-nappa": [
        8781
    ],
    "mulyanapa": [
        8781
    ],
    "mulyanappa": [
        8781
    ],
    "mootaburra": [
        8782
    ],
    "moothaburra": [
        8782
    ],
    "muta-bura": [
        8782
    ],
    "muttaburra": [
        8782
    ],
    "maimbie": [
        8799
    ],
    "mungera ohalo": [
        8799
    ],
    "mungera": [
        8799
    ],
    "maganfang": [
        8801
    ],
    "miqie": [
        8806
    ],
    "micha": [
        8806
    ],
    "mielang": [
        8806
    ],
    "minqi": [
        8806
    ],
    "maasa": [
        8822
    ],
    "muji, southern": [
        8840
    ],
    "muzi": [
        8857,
        8840,
        8890
    ],
    "masamae": [
        8842
    ],
    "masamae yameo": [
        8842
    ],
    "mazan": [
        8842
    ],
    "mili": [
        8844
    ],
    "moji": [
        8845
    ],
    "makwe": [
        8846,
        8847
    ],
    "macue": [
        8846,
        8847
    ],
    "maraba": [
        8846,
        8847
    ],
    "maay": [
        8849
    ],
    "maay maay": [
        8849
    ],
    "mai mai": [
        8849
    ],
    "malek": [
        8851
    ],
    "menandon": [
        8851
    ],
    "minendon": [
        8851
    ],
    "muji, qila": [
        8853
    ],
    "mujitsu": [
        8853
    ],
    "malayar": [
        8854
    ],
    "mysian": [
        8855
    ],
    "muji, northern": [
        8856
    ],
    "mujima": [
        8856
    ],
    "mogeha": [
        8857
    ],
    "middle musa": [
        8893
    ],
    "modern tupi": [
        8896
    ],
    "modern tupí": [
        8896
    ],
    "mel": [
        8897
    ],
    "macedonian sign language": [
        8906
    ],
    "montenegrin sign language": [
        8906
    ],
    "montenegro sign language": [
        8906
    ],
    "myanmar sign language": [
        8907
    ],
    "maio-yesan": [
        8912
    ],
    "mayo-yesan": [
        8912
    ],
    "minglang": [
        8913
    ],
    "maya, yucatec": [
        8919
    ],
    "maaya": [
        8919
    ],
    "maaya t’aan": [
        8919
    ],
    "maayáa": [
        8919
    ],
    "manaldjali": [
        8920
    ],
    "minjanbal": [
        8920
    ],
    "macau cantonese": [
        8923,
        8924,
        8925,
        8926
    ],
    "minh huong": [
        8923,
        8924,
        8925,
        8926
    ],
    "masa-wadyana": [
        8929
    ],
    "macoíta": [
        8935
    ],
    "manso": [
        8935
    ],
    "mita": [
        8937
    ],
    "morobe": [
        8939
    ],
    "mantembu": [
        8943
    ],
    "mora": [
        8943
    ],
    "misapa": [
        8952
    ],
    "mayawali": [
        8955
    ],
    "maiawali": [
        8955
    ],
    "mayawarli": [
        8955
    ],
    "mayuli": [
        8955
    ],
    "maraban": [
        8960
    ],
    "maragan": [
        8960
    ],
    "moiraduban": [
        8960
    ],
    "moitheriban": [
        8960
    ],
    "mandjoen": [
        8961
    ],
    "mind’jana": [
        8961
    ],
    "mundjun": [
        8961
    ],
    "merida": [
        8975,
        8976,
        8977
    ],
    "myagatwa": [
        8979
    ],
    "miahuatlán": [
        8982,
        9132,
        9134,
        9138
    ],
    "miahuatlán zapotec": [
        8982
    ],
    "mitla": [
        8991
    ],
    "mitla zapotec": [
        8991
    ],
    "melawan": [
        8997,
        8998
    ],
    "mauritania berber": [
        9010,
        9011
    ],
    "mauritanian berber": [
        9010,
        9011
    ],
    "mauritanian": [
        9010,
        9011
    ],
    "marocain": [
        9014
    ],
    "minz": [
        9015
    ],
    "minz zhuang": [
        9015
    ],
    "magori": [
        9017
    ],
    "mandarin": [
        9021,
        9020,
        9022,
        9030,
        9040
    ],
    "mesme": [
        9055
    ],
    "msegua": [
        9057
    ],
    "mawteik": [
        9061
    ],
    "meye": [
        9068
    ],
    "meyor": [
        9068
    ],
    "m’ye": [
        9068
    ],
    "medaindi": [
        9071
    ],
    "medaindie": [
        9071
    ],
    "meljurna": [
        9071
    ],
    "merelde": [
        9071
    ],
    "merildekald": [
        9071
    ],
    "meyu": [
        9071
    ],
    "midlanta": [
        9071
    ],
    "milipitingara": [
        9071
    ],
    "malay (individual language)": [
        9077,
        9078
    ],
    "manda (australia)": [
        9081
    ],
    "mendhe": [
        9081
    ],
    "menthe": [
        9081
    ],
    "margany": [
        9083
    ],
    "marrganj": [
        9083
    ],
    "maridan": [
        9084
    ],
    "maredan": [
        9084
    ],
    "marridan": [
        9084
    ],
    "meradan": [
        9084
    ],
    "mangerr": [
        9085
    ],
    "mangerei": [
        9085
    ],
    "mangeri": [
        9085
    ],
    "mengerrdji": [
        9085
    ],
    "mennagi": [
        9085
    ],
    "mfinu": [
        9086
    ],
    "mfununga": [
        9086
    ],
    "marti ke": [
        9087
    ],
    "marti": [
        9087
    ],
    "magadige": [
        9087
    ],
    "magati gair": [
        9087
    ],
    "magati": [
        9087
    ],
    "magati ke": [
        9087
    ],
    "magati-ge": [
        9087
    ],
    "marri-ge": [
        9087
    ],
    "mati ke": [
        9087
    ],
    "mirrinh-ge": [
        9087
    ],
    "makolkol": [
        9088
    ],
    "malaysian minangkabau": [
        9089
    ],
    "muar": [
        9089
    ],
    "maridjabin": [
        9090
    ],
    "maredyerbin": [
        9090
    ],
    "maretyabin": [
        9090
    ],
    "maridyerbin": [
        9090
    ],
    "maritjabin": [
        9090
    ],
    "marri tjevin": [
        9090
    ],
    "mandandanyi": [
        9091
    ],
    "mandandanji": [
        9091
    ],
    "mandandanjnjdji": [
        9091
    ],
    "mundaeinbura": [
        9091
    ],
    "mundainbara": [
        9091
    ],
    "matngala": [
        9092
    ],
    "maangella": [
        9092
    ],
    "madngela": [
        9092
    ],
    "madngele": [
        9092
    ],
    "mandella": [
        9092
    ],
    "matngele": [
        9092
    ],
    "muttangulla": [
        9092
    ],
    "marimanindji": [
        9093
    ],
    "maramanandji": [
        9093
    ],
    "maramanindji": [
        9093
    ],
    "maramarandji": [
        9093
    ],
    "marimanindu": [
        9093
    ],
    "marramaninjsji": [
        9093
    ],
    "marramaninyshi": [
        9093
    ],
    "murinmanindji": [
        9093
    ],
    "mbangwe": [
        9094
    ],
    "mbaouin": [
        9094
    ],
    "m’bahouin": [
        9094
    ],
    "malkan": [
        9095
    ],
    "mpuono": [
        9096
    ],
    "mbuun": [
        9096
    ],
    "mituku": [
        9097
    ],
    "metoko": [
        9097
    ],
    "maranungku": [
        9098
    ],
    "merranunggu": [
        9098
    ],
    "mobesa": [
        9099
    ],
    "mombesa": [
        9099
    ],
    "maringarr": [
        9100
    ],
    "marenggar": [
        9100
    ],
    "maringa": [
        9100
    ],
    "mari’ngar": [
        9100
    ],
    "marri ngarr": [
        9100
    ],
    "marringarr": [
        9100
    ],
    "muringar": [
        9100
    ],
    "muruwari": [
        9101
    ],
    "marawari": [
        9101
    ],
    "murawari": [
        9101
    ],
    "murawarri": [
        9101
    ],
    "murrawari": [
        9101
    ],
    "muruwarri": [
        9101
    ],
    "muruwurri": [
        9101
    ],
    "mbariman-gudhinma": [
        9102
    ],
    "mbo (democratic republic of congo)": [
        9103
    ],
    "mbomitaba": [
        9104
    ],
    "mbomotaba": [
        9104
    ],
    "mariyedi": [
        9105
    ],
    "marijadi": [
        9105
    ],
    "marijedi": [
        9105
    ],
    "murijadi": [
        9105
    ],
    "mbandja": [
        9106
    ],
    "mbandza": [
        9106
    ],
    "mbanja": [
        9106
    ],
    "mbanza": [
        9106
    ],
    "morre": [
        9107
    ],
    "manbu": [
        9110
    ],
    "mang u": [
        9110
    ],
    "manangkari": [
        9111
    ],
    "mananggari": [
        9111
    ],
    "manangkarri": [
        9111
    ],
    "mangas": [
        9112
    ],
    "ma’as": [
        9112
    ],
    "mixtepec zapotec": [
        9132
    ],
    "mazaltepec": [
        9144
    ],
    "mazaltepec zapotec": [
        9144
    ],
    "mirgan": [
        9149,
        9150
    ],
    "mirgami": [
        9149,
        9150
    ],
    "mirkan": [
        9149,
        9150
    ],
    "mairasi": [
        9154
    ]
};
